/* eslint-disable no-unreachable */
/* eslint-disable no-unused-vars */
import store from '@/store';
import { PANEL_TAB } from '@/constants/tabs';
import { PANEL_IDS } from '@/constants/panelIds';
import { POSITION_PICK_SOURCE } from '@/constants/positionPickSource';
import { ForgeMessage } from './../../utils/forgeMessageUtils';
import HttpService from '../../utils/httpService';
import { FACILITY_REQUEST } from '../../utils/http/RequestRegistry';
import { getViewPage2d, getViewPage360, getViewPage3D, launchViewer, getMessagePopup } from './forgeviewer';
import { $getURLParameterVal } from '@Utils';
import { toPoint2D, isPointInsidePolygon, getBoxAroundPoint, createBoxAroundPoint, getBoxOffset } from '../../utils/threejsUtils';
import { CLOSE_ICON_HIT_PADDING } from './measurementRenderer';
import {
  editType,
  saveScaffolds,
  postData,
  postDataAsync,
  getAttachments,
  getJSON,
} from '../../utils/mongoUtils';
import levelsService from '@/features/Admin/services/levels.service';
import { getAMISTagById } from '../../utils/amisAPIs';
import { axisAngleToEuler } from '../../utils/geometryUtils';
import {
  PanoramaHotspotManager,
  HOTSPOT_LABEL_CHIP_BG,
  HOTSPOT_LABEL_TEXT_COLOR,
  HOTSPOT_LABEL_TEXT_SHADOW,
} from './PanoramaHotspotManager';
// Wave C-α (specs/003-cml-phase2-popup-cards) — singleton popup card driver.
// T015 wires CML marker clicks to this open() function.
import { openPopupCard, closePopupCard, popupCardState } from '@/composables/usePopupCard';
import { THUMBNAIL_CONFIG } from '@/constants/apiLimits';
import images360Service from '@Dashboard/service/images360.service';
import { NO_DATA_COLOR, CONDITION_RATING_ORDER } from '@/features/Tags/components/monitoring/cmlColoringConstants';
import {
  getMiddleBBoxForGroup,
  checkIsModelTrasnlated,
  addViewable,
  setPermeativeElementsTheme,
  createGrayMaterial,
  getNodeChildDbidsForNode,
  createMaterial,
  isolateForge,
  getBBBox,
  getAllLeafComponents,
  clearThemingColors,
  zoomToFitBox2D,
  addToScene,
  removeFromScene,
  forgeObjectFromDbId,
} from '../../utils/forgeUtils';
import {
  ForgeInspection,
  ForgeObject,
  ForgeAnnotation,
  ForgeEquipment,
  ForgeScaffold,
  ForgeAttachment,
  Image360,
  ForgeInspectionSubTag,
  ShareFileItem,
  ForgePipeline,
  ForgeStructural,
  ForgeAnomaly,
  ForgeBaseTag,
  ForgeAvaInspect,
} from './forgeModels';
import config from '../../../appConfig';
import $ from 'jquery';
import {
  BlobServiceClient,
  StorageSharedKeyCredential,
  ContainerClient,
  BlockBlobClient,
} from '@azure/storage-blob';
import { AnonymousCredential } from '@azure/identity';
import jspdf from 'jspdf';

import 'pannellum';
import 'pannellum/src/css/pannellum.css';
import Vue from 'vue';
import { $getAuthHeaders, $handleError, $uuidv4 } from '@/utils';
import { log as debugLog, warn as debugWarn, error as debugError } from '@/utils/debugLogger';
import { LINK_TYPE_COLORS } from '@/constants/linkTypeColors';
import { isCustomFilterActive } from '@/config/inspectionFilterRegistry';
import { levelPitch, SNAP_DURATION_MS, computeNorthOffset } from '@/features/Dashboard/utils/compass';
import { useSpatialFocus } from '@/features/Dashboard/composables/useSpatialFocus';
import { createPanoramaTagSelectionSeed } from '@/features/Tags/utils/tagMarkerLifecycle';
import { findTagSyncImage } from '@/features/Tags/utils/tagScanSync';
import { pick360Point } from '@/utils/pano360Pick';
import {
  layoutMarkerLabels,
  markerConditionPriority,
  screenScaleForTarget,
} from '@/utils/markerScreenSpace';

/** Legend/scene owner for an anomaly focus, so a sibling widget cannot blank its scene. */
const ANOMALY_FOCUS_OWNER_ID = 'anomaly-tag-focus';

const Proj4js = window.Proj4js;
const pannellum = window.pannellum;
const THREE = window.THREE;
const Autodesk = window.Autodesk;
const pdfjsLib = window.pdfjsLib;

const CML_MARKER_TARGET_PX = 16;
const TML_MARKER_TARGET_PX = 11;
const CML_MARKER_HIT_RADIUS_PX = 12;
const TML_MARKER_HIT_RADIUS_PX = 9;

function runLoad360ViewerCallback() {
  const callback = store.getters['getLoad360ViewerCallback'];
  if (!callback) return true;
  let consumed = true;
  try {
    consumed = callback();
  } finally {
    if (consumed !== false && store.getters['getLoad360ViewerCallback'] === callback) {
      store.commit('setLoad360ViewerCallback', null);
    }
  }
  return consumed !== false;
}

const LOAD_360_CALLBACK_MAX_WAIT_MS = 30000;

// ── 360 scan-bubble click / double-click disambiguation ─────────────────────
// A single click on a 360 scan bubble opens its info card; a double-click
// navigates into that scan. Without a delay, the first click of a double-click
// already opens the card, so it flashes before navigation. We debounce the
// single-click open by this window and let the dblclick handler cancel the
// pending timer. Keyed per-bubble by the Image360 object (WeakMap → auto-GC,
// no leak, no model mutation). 300ms covers the typical OS/browser double-click
// threshold; the dblclick handler's hideThumbnailPopup is a backstop if a very
// slow double-click still lets the timer fire (worst case: brief flash, never a
// stuck card). Lower toward 250 for a snappier single-click if flashes are rare.
const SCAN_BUBBLE_CLICK_DELAY_MS = 300;
const _scanBubbleClickTimers = new WeakMap();

// Breathing room added around a scaffold's own box when isolating it in 3D, so the
// crop keeps the immediate surroundings visible. Metres — converted to viewer units
// with worldToView3dLength at use, like every other real-world length here.
const SCAFFOLD_CROP_MARGIN_M = 0.5;

export class ForgeViewerService {
  constructor() {
    this.allForgeElements = [];
    this.dbIdPerObj = [];
    this.smallModelsUrnsPerElements = new Map();

    // Initialize the panorama hotspot manager
    this.panoramaHotspotManager = new PanoramaHotspotManager(this);

    // PanoramaCompass state lives in top-level Vuex state (see store/index.js:
    // panoramaCompassState + SET_PANORAMA_COMPASS_READY/RESET_PANORAMA_COMPASS/
    // SET_PANORAMA_COMPASS_INTERACTING mutations). This class only holds the
    // imperative interaction-end timer; the reactive state is Vuex-managed so
    // pageView.vue computeds can track it reliably (Vue 2 reactivity doesn't
    // walk class instance properties).
    this._compassInteractEndTimer = null; // pending setTimeout for the coast window
    this._programmaticLookAtTimer = null; // pending setTimeout for wrapped lookAt compass kick

    // 0 => Gray
    // 1 => Wireframe
    // 2 => Shaded
    this.ThemingStack = [];

    // ghosting
    this.fragIdPerMaterial = null;
    this.ghostingMaterial = null;
    this.dbIdPerThemingColor = {};

    this.pointCloudsToShowIn3D = [];
    this._suppressPanoSync = false;
    this.scaffoldStates = [
      { state: 'USE WITHOUT HARNESS', color: '#92D050' },
      { state: 'USE ONLY WITH HARNESS', color: '#ffa500' },
      { state: 'DO NOT USE', color: '#ff0000' },
    ];
    this.permitsStates = [
      { state: 'Permit Preparation', color: '#00000' },
      { state: 'Issuing Authority Review', color: '#00000' },
      { state: 'Permit Coordinator Review', color: '#00000' },
      { state: 'Concurrence signature Authority Review', color: '#00000' },
      { state: 'Affected Area Review', color: '#00000' },
      { state: 'Validation', color: '#00000' },
      { state: 'Site Issuing Authority Review', color: '#00000' },
      { state: 'Pending Live', color: '#00000' },
      { state: 'Live PTW', color: '#00000' },
      { state: 'To be Closed', color: '#00000' },
    ];
    this.permitStatuses = ['Permit Raised', 'Permit Live', 'Permit Closed'];
    this.gpsSystems = ['Default', 'Indian 1975/UTM 47N'];
    this.unitsList = [
      'decimal-ft',
      'ft-and-fractional-in',
      'ft-and-decimal-in',
      'decimal-in',
      'm',
      'cm',
      'mm',
    ];

    this.panoViewerId = 'panorama';
    this.lastPanoramaPreviewImage = null;
    this.isPanoramaViewerLoading = false;
    this._pendingCropConfirm = false;

    this.startedPanoChange;
    this.panoramaViewer;

    this.clustersIds = [];

    this.lockedFOV_360;

    this.image360ToNavigateToIn3D = null;
    this.on3dModelLoadedCallback = null;
    this.tagToZoomToIn3D = null;
    this.isolateOnZoom = true; // Whether to isolate when zooming to tag (for cross-facility navigation)

    this.pointToZoomToIn2d = null;

    this.isCroppingForPointCloudDownload = false;
    this.amisTagToPickObjectTo = null;

    //mapping point
    this.isPickingMappingPoint1;
    this.isPickingMappingPoint2;
    this.mappedPoint1 = { generalViewPoint: null, planViewPoint: null };
    this.mappedPoint2 = { generalViewPoint: null, planViewPoint: null };

    this.pRenderer = null;

    var _this = this;

    this.panoCustomSceneId = 'customScene';
    this.poiHighlightId = 'poi-highlight-hotspot';
    this.clusterIds = [];

    let moveHandler = () => {
      if (
        !_this.panoramaViewer ||
        !store.state.selectedImage ||
        !store.state.selectedImage.isLocked ||
        !_this.startedPanoChange ||
        !_this.getMainExtension() ||
        !store.state.areViewsLocked
      )
        return;
      _this.updateforgeViewerFromPano(store.state.selectedImage);
      _this.panoramaViewer.stopMovement();
    };

    window.ontouchmove = moveHandler;
    window.onmousemove = moveHandler;
  }

  // ---------------------------------------------------------------------
  // PanoramaCompass adapter surface
  //
  // These methods are passed as props to the PanoramaCompass Vue component
  // mounted in pageView.vue. Keeping them on the service means the
  // component stays viewer-agnostic — it doesn't import pannellum — and
  // both pageView.vue and ViewersSection.vue can mount the same component.
  // All values are in degrees (Pannellum's native unit).
  // ---------------------------------------------------------------------
  _markPanoramaCompassReady(image) {
    // Commit to Vuex so pageView.vue computeds re-run reactively.
    const northOffset = computeNorthOffset(image.lockedYaw, image.lockedForgeDirection);
    store.commit('SET_PANORAMA_COMPASS_READY', { northOffset });
    debugLog('[ForgeViewerService] panoramaCompass ready, northOffset=' + northOffset);

    // Wrap panoramaViewer.lookAt() so that ANY programmatic rotation
    // (zoom-to-tag, typed coordinates, sync 3D camera, etc.) automatically
    // kicks the compass rAF loop for the animation duration.
    this._wrapPanoramaLookAt();
  }

  _wrapPanoramaLookAt() {
    const viewer = this.panoramaViewer;
    if (!viewer || viewer._lookAtWrapped) return;

    const originalLookAt = viewer.lookAt.bind(viewer);
    const _this = this;

    viewer.lookAt = function wrappedLookAt(pitch, yaw, hfov, animMs) {
      originalLookAt(pitch, yaw, hfov, animMs);

      // Kick compass polling for programmatic animations
      if (animMs != null && animMs > 0) {
        store.commit('SET_PANORAMA_COMPASS_INTERACTING', true);
        if (_this._programmaticLookAtTimer != null) {
          clearTimeout(_this._programmaticLookAtTimer);
        }
        _this._programmaticLookAtTimer = setTimeout(() => {
          store.commit('SET_PANORAMA_COMPASS_INTERACTING', false);
          _this._programmaticLookAtTimer = null;
        }, animMs + 100);
      } else {
        // Instant lookAt (animMs=0): single rAF tick to capture final yaw
        store.commit('SET_PANORAMA_COMPASS_INTERACTING', true);
        requestAnimationFrame(() => {
          store.commit('SET_PANORAMA_COMPASS_INTERACTING', false);
        });
      }
    };

    viewer._lookAtWrapped = true;
  }
  resetPanoramaCompass() {
    if (this._compassInteractEndTimer != null) {
      clearTimeout(this._compassInteractEndTimer);
      this._compassInteractEndTimer = null;
    }
    if (this._programmaticLookAtTimer != null) {
      clearTimeout(this._programmaticLookAtTimer);
      this._programmaticLookAtTimer = null;
    }
    store.commit('RESET_PANORAMA_COMPASS');
  }
  getPanoramaYaw() {
    return this.panoramaViewer ? this.panoramaViewer.getYaw() : null;
  }
  // Round 6 signature update: second arg is a boolean that forces pitch-level
  // regardless of magnitude (passed true on double-click, false on single click).
  // Uses the shared levelPitch() helper from compass.js so the threshold is not
  // duplicated between this file and ViewersSection.vue.
  lookAtPanoramaNorth(animationMs, forceLevelPitch) {
    const s = store.state.panoramaCompassState;
    if (!this.panoramaViewer || !s || !s.isReady) return;
    const viewer = this.panoramaViewer;
    const currentPitch = viewer.getPitch();
    const targetPitch = levelPitch(currentPitch, !!forceLevelPitch);
    const ms = Number.isFinite(animationMs) ? animationMs : SNAP_DURATION_MS;
    // Round 7: Pannellum convention — facing north means yaw = -northOffset,
    // NOT yaw = northOffset. The target yaw is negated so the viewer actually
    // snaps to the physical north direction (matching Pannellum's built-in
    // compass needle).
    const targetYaw = -s.northOffset;
    debugLog('[ForgeViewerService] snap panorama to north', {
      targetPitch,
      targetYaw,
      northOffset: s.northOffset,
      animationMs: ms,
      forceLevelPitch: !!forceLevelPitch,
    });
    viewer.lookAt(targetPitch, targetYaw, viewer.getHfov(), ms);
  }

endIsolation3D() {
        this.getMainExtension().endIsolation();
        store.commit('setIsIsolating3D', false);
      }

      async showTagIn3D(data) {
         let { name, id} = data;

    const vuexStore = window.vuexStore;

    if (!vuexStore) {
      debugError('Vuex store not found.');
      throw new Error('Vuex store not found.');
    }

    if (!name && !id) {
      debugError('Invalid data provided. Name or ID is required.');
      throw new Error('Invalid data provided. Name or ID is required.');
    }
    const mainApp = vuexStore.state.mainApp;
   const pageView3d = vuexStore.getters['GET_PAGE_VIEW_3D'];
   let tag = await vuexStore.dispatch('GET_BASE_TAG_BY_ID_NAME', {name: name, id: id});
        mainApp.openViewPageWithType('3d');
        setTimeout(() => {
          if (pageView3d) {
            this.zoomInAllAvailableViewers(tag, true);
          } else {
            this.tagToZoomToIn3D = tag;
          }
        }, 100);
      }
      async showTagIn2D(data) {
        let { name, id} = data;

    const vuexStore = window.vuexStore;

    if (!vuexStore) {
      debugError('Vuex store not found.');
      throw new Error('Vuex store not found.');
    }

    if (!name && !id) {
      debugError('Invalid data provided. Name or ID is required.');
      throw new Error('Invalid data provided. Name or ID is required.');
    }

   let tag = await vuexStore.dispatch('GET_BASE_TAG_BY_ID_NAME', {name: name, id: id});


        let point =
          tag instanceof ForgeScaffold
            ?  tag.position
            :  tag.point;
        if (!point) return;
        this.zoomToPointIn2D(point, tag.level2D, () => {
          this.getLabels2DExtension()?.createHighlightingTags([tag]);
        });
      }
      zoomToPointIn2D(point3d, levelName, callback) {
         const vuexStore = window.vuexStore;
        vuexStore.dispatch('zoomToPointIn2D', {
          point3d,
          levelName: levelName,
          callback: callback,
        });
      }
  initializeMappingPointsEvents(viewer, isGeneralViewer) {
    if (!viewer) return;
    //https://stackoverflow.com/questions/53511258/forge-viewer-how-to-convert-arbitrary-client-point-to-world-point
    let canvas = viewer.canvas;
    let drag = false;
    canvas.addEventListener('mousedown', () => (drag = false));
    canvas.addEventListener('mousemove', () => (drag = true));
    canvas.addEventListener('mouseup', (evt) => {
      if (drag || !store.state.selectedLevel) return;
      var hitTest = viewer.clientToWorld(evt.offsetX, evt.offsetY, false);
      if (!hitTest) return;
      let modelScale = store.state.unitScale;
      if (this.isPickingMappingPoint1) {
        if (isGeneralViewer)
          this.mappedPoint1.generalViewPoint = hitTest.point
            .clone()
            .add(store.state.globalOffset)
            .multiplyScalar(modelScale);
        else this.mappedPoint1.planViewPoint = hitTest.point;
        if (this.mappedPoint1.generalViewPoint && this.mappedPoint1.planViewPoint)
          this.isPickingMappingPoint1 = false;
        store.state.adminAppContainer.isPoint1Valid =
          this.mappedPoint1.generalViewPoint && this.mappedPoint1.planViewPoint;
      } else if (this.isPickingMappingPoint2) {
        if (isGeneralViewer)
          this.mappedPoint2.generalViewPoint = hitTest.point
            .clone()
            .add(store.state.globalOffset)
            .multiplyScalar(modelScale);
        else this.mappedPoint2.planViewPoint = hitTest.point;
        if (this.mappedPoint2.generalViewPoint && this.mappedPoint2.planViewPoint)
          this.isPickingMappingPoint2 = false;
        store.state.adminAppContainer.isPoint2Valid =
          this.mappedPoint2.generalViewPoint && this.mappedPoint2.planViewPoint;
      }
      let point1OnLevel = this.mappedPoint1.planViewPoint;
      let point1OnModel = this.mappedPoint1.generalViewPoint;
      let point2OnLevel = this.mappedPoint2.planViewPoint;
      let point2OnModel = this.mappedPoint2.generalViewPoint;
      if (point1OnLevel && point1OnModel && point2OnLevel && point2OnModel) {
        store.state.selectedLevel.fillAlignment(
          point1OnLevel,
          point1OnModel,
          point2OnLevel,
          point2OnModel,
        );
        levelsService.editLevel(store.state.assetId, store.state.selectedLevel);
        this.getMappingExtension3D().updateShownLevels();
      }
    });
  }
  loadHandler () {
    const handlerStartedAt = Date.now();
    let loadFinalized = false;
    let activeCallback = store.getters['getLoad360ViewerCallback'];
    let callbackWaitStartedAt = handlerStartedAt;
    const intervalId = setInterval(() => {
      const now = Date.now();
      if (!this.panoramaViewer?.isLoaded()) {
        if (now - handlerStartedAt >= LOAD_360_CALLBACK_MAX_WAIT_MS) {
          if (store.getters['getLoad360ViewerCallback'] === activeCallback) {
            store.commit('setLoad360ViewerCallback', null);
          }
          clearInterval(intervalId);
        }
        return;
      }

      // if (!this.panoramaViewer?.getRenderer()?.isLoading()) {
      const shouldFinalizeLoad = !loadFinalized;
      if (shouldFinalizeLoad) {
        loadFinalized = true;
        debugLog(`%c 360 viewer loaded`, 'color: green; font-weight: bold; font-size: 16px;');
        this.panoramaHotspotManager.updateReferencePointHotSpot();
      }

      const callback = store.getters['getLoad360ViewerCallback'];
      if (callback !== activeCallback) {
        activeCallback = callback;
        callbackWaitStartedAt = now;
      }
      const consumed = runLoad360ViewerCallback();
      const callbackAfterRun = store.getters['getLoad360ViewerCallback'];
      const callbackReplaced = !consumed && callbackAfterRun !== callback;
      if (callbackReplaced) {
        activeCallback = callbackAfterRun;
        callbackWaitStartedAt = now;
      } else {
        const callbackExpired = !consumed
          && now - callbackWaitStartedAt >= LOAD_360_CALLBACK_MAX_WAIT_MS;
        if (callbackExpired && callbackAfterRun === callback) {
          store.commit('setLoad360ViewerCallback', null);
        }
        if (consumed || callbackExpired) clearInterval(intervalId);
      }

      if (shouldFinalizeLoad) {
        setTimeout(() => {
          this.linkViewers(true);
          this.getDrawPointsExtension()?.drawDirection2D();
          this.isPanoramaViewerLoading = false;
          // Cross-facility 360 zoom (?zoom360): authoritative success clear of
          // the continuous "Preparing your workspace" overlay on real panorama
          // load. (MainView also clears on already-open/no-scan/abort/teardown.)
          store.commit('setPending360Zoom', false);
          debugLog('[ZoomFromUrl] pending360Zoom cleared on panorama load (authoritative)');
        }, 1000);
      }
    }, 1000);
  }
  launchPanoViewer(image) {
    if (!image.imageUrl) {
      Vue.prototype.$dialog.notify.warning('No image found.');
      return;
    }

    this.isPanoramaViewerLoading = true;

    if (this.panoramaViewer) {
      store.commit('setTooltipObject', null);

      var imageDataUrl = this.panoramaViewer.getRenderer().render(this.panoramaViewer.getPitch() / 180 * Math.PI, this.panoramaViewer.getYaw() / 180 * Math.PI, this.panoramaViewer.getHfov() / 180 * Math.PI, {'returnImage': true});

      var img = new Image();

      img.onload = () => {
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        canvas.width = img.width / 6;
        canvas.height = img.height / 6;
        ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, canvas.width, canvas.height);
        this.lastPanoramaPreviewImage = canvas.toDataURL();
        let viewer360 = getViewPage360();
        if (viewer360) viewer360.is360PreviewImageLoaded = false;
      }

      img.src = imageDataUrl;
    }

    // Update 2d Level
    if (getViewPage2d()) {
      let levels = store.state.levels;
      let t = levels.find((o) => o.isImageInsideLevel(image));
      if (t && store.state.selectedLevel != t) {
        store.dispatch('showLevel', { level: t });
      }
    }

    setTimeout(() => {
      this.launchPanoViewerHandler(image);
    }, 1000)
  }
  async launchPanoViewerHandler(image) {
    var lastCoordinates = {
      yaw: this.panoramaViewer?.getYaw() ?? 0,
      pitch: this.panoramaViewer?.getPitch() ?? 0,
    }

    var lastImage = this.panoramaViewer?.forgeImage;
    if (lastImage) {
      lastCoordinates.yaw -= lastImage.lockedYaw;
      lastCoordinates.pitch -= lastImage.lockedPitch;
    }

    var referencePoint = store.state.referencePoint360;
    if (referencePoint) {
      const direction = new THREE.Vector3().subVectors(referencePoint, image.forgeCameraPosition).normalize();
      const info = this.getNewYawAndPitch(image, direction);
      const pitch = info['pitch'];
      const yaw = info['yaw'];

      lastCoordinates.yaw = yaw;
      lastCoordinates.pitch = pitch;
    }

    this.panoramaViewer?.destroy();
    // Reset compass state so the new scan's northOffset is picked up cleanly.
    // _markPanoramaCompassReady() below restores isReady=true.
    this.resetPanoramaCompass();

    if (getViewPage360()) getViewPage360().clearPanoDimension();

    //TODO: remove later
    if (!image.rotationAngle) image.rotationAngle = Math.abs(image.lockedYaw);
    //get Horizon Pitch & Roll
    let horizonRoll,
      horizonPitch = 0;
    if (image.rotationAngle && image.rotationX && image.rotationY && image.rotationZ) {
      debugLog(image.rotationAngle, image.rotationX, image.rotationY, image.rotationZ)
      var rotation = axisAngleToEuler(
        image.rotationX,
        image.rotationY,
        image.rotationZ,
        image.rotationAngle,
      );

      if (image.scanType === 'leica') {
        const sign = rotation.z < 0 ? -1 : 1;
        image.lockedYaw = sign * (Math.abs(rotation.z) - 180);

        // keep the yaw between -180 and 180
        if (image.lockedYaw > 180) image.lockedYaw -= 360;
        if (image.lockedYaw < -180) image.lockedYaw += 360;

        horizonPitch = -rotation.y;
        horizonRoll = rotation.x;
      }

      window.calibrationFactor = 2.15;
      image.lockedPitch = 0

    } else if (image.scanType == 'geoslam') {
      horizonRoll = image.rotationX;
      horizonPitch = image.rotationY;
    }

    if (!referencePoint) {
      lastCoordinates.yaw += image.lockedYaw;
      lastCoordinates.pitch += image.lockedPitch;
    }

    // - Comment it out if you want to use the direction between the last image and the current image as a heading
    // if (lastImage && lastImage.forgeCameraPosition && image.forgeCameraPosition) {
    //   const direction = new THREE.Vector3().subVectors(image.forgeCameraPosition, lastImage.forgeCameraPosition).normalize();
    //   console.log(`Direction: ${direction.x} ${direction.y} ${direction.z}`)
    //   const { yaw: newYaw, pitch: newPitch } = this.getNewYawAndPitch(image, direction);
    //   console.log(newYaw, newPitch)

    //   if (newYaw !== undefined && newPitch !== undefined) {
    //     lastCoordinates.yaw = newYaw;
    //     lastCoordinates.pitch = newPitch;
    //   }

    //   console.log(`${lastCoordinates.yaw} ${lastCoordinates.pitch}`)
    // }

    if(image.tilesGenerated && image.highResolution) {
      var config= JSON.parse(image.multiResConfig)?.multiRes ?? {
        "basePath":image.tilesBaseUrl,
        "path": "/%l/%s%y_%x",
        "fallbackPath": "/fallback/%s",
        "extension": "jpg",
        "tileResolution": 512,
        "maxLevel": 5,
        "cubeResolution": 6456
      };

      // Get container-level SAS token for 360 tiles
      // This ensures proper URL construction: basePath/level/tile.jpg?sasToken
      let tilesBaseUrl = image.tilesBaseUrl;
      let sasToken = '';

      // Check if this is an Azure blob URL that needs signing
      if (tilesBaseUrl && (tilesBaseUrl.includes('blob.core.windows.net') || tilesBaseUrl.includes('127.0.0.1:10000'))) {
        try {
          const response = await HttpService.get({
            url: '/api/BlobStorage/sign360TilesFolder',
            params: { tilesBaseUrl }
          });
          if (response.data) {
            tilesBaseUrl = response.data.baseUrl;
            sasToken = response.data.sasToken || '';
          }
        } catch (err) {
          debugWarn('Failed to sign 360 tiles URL, using original:', err);
        }
      }

      config.basePath = tilesBaseUrl;

      // Append SAS token to extension so Pannellum constructs URLs correctly:
      // basePath + path + '.' + extension => .../1/f0_0.jpg?sv=...&sig=...
      if (sasToken) {
        config.extension = `${config.extension || 'jpg'}?${sasToken}`;
      }

      this.panoramaViewer = pannellum.viewer('panoramaContainer', {
        type: 'multires',
        autoLoad: true,
        multiRes: config,
        yaw: image.lockedYaw,
        pitch: image.lockedPitch,
        horizonPitch: horizonPitch,
        horizonRoll: horizonRoll,
        // "hotSpotDebug": true,
        // Built-in compass disabled; PanoramaCompass Vue overlay (mounted in
        // pageView.vue next to #panoramaContainer) renders the informing compass.
        compass: false,
        northOffset: computeNorthOffset(image.lockedYaw, image.lockedForgeDirection),
        hfov: 100,
        minHfov: 10,
        maxHfov: 120,
        scenes: {
          customScene: {
            type: 'multires',
            autoLoad: true,
            multiRes: config,
          },
        },
      });
      this._markPanoramaCompassReady(image);
    }
    else{
      let url = image.lowResUrl??image.imageUrl ;

      if (!url) {
        Vue.prototype.$dialog.notify.warning('No image found.');
        return;
      }

      this.panoramaViewer = pannellum.viewer('panoramaContainer', {
        type: 'equirectangular',
        panorama: url,
        autoLoad: true,
        yaw: image.lockedYaw,
        pitch: image.lockedPitch,
        horizonPitch: horizonPitch,
        horizonRoll: horizonRoll,
        // "hotSpotDebug": true,
        // Built-in compass disabled; PanoramaCompass Vue overlay renders the
        // informing compass (see multires branch above for the full reasoning).
        compass: false,
        northOffset: computeNorthOffset(image.lockedYaw, image.lockedForgeDirection),
        scenes: {
          customScene: {
            type: 'equirectangular',
            panorama: url,
            autoLoad: true,
          },
        },
      });
      this._markPanoramaCompassReady(image);
    }

    this.loadHandler();

    this.panoramaViewer.loadScene(
      this.panoCustomSceneId,
      image.lockedPitch,
      image.lockedYaw,
      this.panoramaViewer.getHfov(),
    );

    let viewer = store.state.viewer;
    if (viewer)
      // this.panoramaViewer.setHfovBounds([10, 120])
      this.panoramaViewer.setHfovBounds([
        viewer.navigation.getFovMin(),
        viewer.navigation.getFovMax(),
      ]);

    this.panoramaViewer.forgeImage = image;
    //update shown
    this.getAllPanoramaImages().forEach((o) => (o.isShown = false));
    image.isShown = true;
    // if (store.state.selectedTab == 3) this.scrollToImage360(image);

    store.state.selectedImage = image;
    store.commit('hideThumbnailPopup', '360');

    let onPointerDown = () => {
      store.commit('hideThumbnailPopup', '360');
      if (!store.state.selectedImage || !store.state.selectedImage.isLocked) return;
      //to stop updating Pano viewer from forge
      _this.startedPanoChange = true;
    };

    let onPointerUp = async (event) => {
      // On click on middle mouse button, set the reference point in 360 viewer
      if (event.button == 1) {
        // Show the panel immediately in loading state before the ray-cast.
        store.commit('SET_SHOW_SCAN_SELECTOR_PANEL_LOADING', true);

        // Load this scan's point cloud and pick from it (model only when the scan has none).
        try {
          const pick = await _this.pick360ClickPoint(event);
          // An earlier pick is still waiting; it owns the loading state.
          if (pick.busy) return;
          const intersection = pick.point;
          debugLog('[RefPoint] Pick result:', pick.source);

          if (!intersection) {
            store.commit('SET_SHOW_SCAN_SELECTOR_PANEL_LOADING', false);
            return;
          }

          let worldIntersection = _this.view3dToWorld(intersection);
          store.commit('SET_REFERENCE_POINT_360', worldIntersection);
          store.commit('SET_SHOW_SCAN_SELECTOR_PANEL_LOADING', false);
          _this.panoramaHotspotManager.updateReferencePointHotSpot();
        } catch (err) {
          debugLog('[RefPoint] Raycast error:', err);
          Vue.prototype.$dialog.notify.error('Failed to resolve scan position');
          store.commit('SET_SHOW_SCAN_SELECTOR_PANEL_LOADING', false);
        }
        return;
      }

      if (event.button != 0) return;

      let page360 = getViewPage360();
      let canvas = document.getElementById('pano-canvas');

      if (page360.closeIconInfo && canvas) {
        const closeIconInfo = page360.closeIconInfo;
        const rect = canvas.getBoundingClientRect();
        const mouseX = event.clientX - rect.left;
        const mouseY = event.clientY - rect.top;

        // Calculate distance from click to circle center
        const dx = mouseX - closeIconInfo.centerX;
        const dy = mouseY - closeIconInfo.centerY;
        const distance = Math.sqrt(dx * dx + dy * dy);

        if (distance <= closeIconInfo.radius + CLOSE_ICON_HIT_PADDING) {
          page360.clearPanoramaMeasuring();
          store.commit('SET_IS_MEASURING_IN_PANORAMA', false);
        }
      }

      // ── Tag Position Assignment (follows CML picking pattern) ──
      if (store.state.isSettingTagPosition) {
        const tag = store.state.positionAssignmentTag;
        if (!tag) return;

        const currentImage = _this.panoramaViewer?.forgeImage;
        if (!currentImage) return;

        debugLog('[SetPosition] Click in panorama, image:', currentImage.id, 'tag:', tag.id);

        // Steps 1-2: load this scan's point cloud and pick from it (model only when it has none)
        const pick = await _this.pick360ClickPoint(event, currentImage);
        if (pick.autoLoadedPcName) store.commit('setPositionAutoLoadedPcName', pick.autoLoadedPcName);
        const intersection = pick.point;
        debugLog('[SetPosition] Pick result:', pick.source);

        // Step 3: Handle miss — keep mode active for retry (the pick already told the user why)
        if (!intersection) return;

        // Step 4: Convert to world coordinates and invoke callback
        const worldPoint = _this.view3dToWorld(intersection);
        debugLog('[SetPosition] World point:', worldPoint);

        const callback = store.state.positionAssignmentCallback;
        if (callback) {
          // source marks the leg the click came from - see the 3D leg in forgeviewer.js.
          // imageId is the scan that was actually clicked, not the selected one - a consumer
          // records it as the tag's source 360 (AVA-492 share links).
          callback({ x: worldPoint.x, y: worldPoint.y, z: worldPoint.z, source: POSITION_PICK_SOURCE.PANO_360, imageId: currentImage?.id });
        }

        // Step 5: Exit mode and cleanup (CML pattern)
        store.commit('setIsSettingTagPosition', false);
        store.commit('setPositionAssignmentTag', null);
        store.commit('setPositionAssignmentCallback', null);
        $('.pnlm-ui').css('cursor', '');

        // Close auto-loaded PC
        const pcName = store.state.positionAutoLoadedPcName;
        if (pcName) {
          const pc = store.state.pointClouds.find(p => p.name === pcName);
          if (pc) _this.toggleShowingPointCloudIn3D(pc);
          store.commit('setPositionAutoLoadedPcName', null);
        }

        return;
      }

      if (!store.state.selectedImage || !store.state.selectedImage.isLocked) return;

      // CML point picking in 360
      if (store.state.isPickingCmlPoint) {
        // Load this scan's point cloud and pick from it (model only when the scan has none).
        const cmlPick = await _this.pick360ClickPoint(event);
        if (cmlPick.autoLoadedPcName) store.commit('setCmlAutoLoadedPcName', cmlPick.autoLoadedPcName);
        const cmlIntersection = cmlPick.point;
        debugLog('[CML] Pick result:', cmlPick.source);

        if (!cmlIntersection) return;

        let cmlWorldPoint = _this.view3dToWorld(cmlIntersection);
        var cmlCallback = store.state.pickingCmlCallback;
        // The 360 pick returns a point, never a model element (even on its model fallback),
        // so there's no Forge dbId to propagate. Pass null explicitly so the
        // callback shape stays uniform with the 3D and 2D pick paths.
        if (cmlCallback) cmlCallback({
          x: cmlWorldPoint.x,
          y: cmlWorldPoint.y,
          z: cmlWorldPoint.z,
          dbId: null,
          fragId: null,
        });
        store.commit('setIsPickingCmlPoint', false);
        store.commit('setPickingCmlCallback', null);
        $('.pnlm-ui').css('cursor', '');

        // Close the PC that was auto-loaded for CML picking
        const cmlPcName = store.state.cmlAutoLoadedPcName;
        if (cmlPcName) {
          const pc = store.state.pointClouds.find(p => p.name === cmlPcName);
          if (pc) _this.toggleShowingPointCloudIn3D(pc);
          store.commit('setCmlAutoLoadedPcName', null);
        }
        return;
      }

      if (!store.state.isPickingTag && !store.state.isPickingPin) return;

      const pickType = store.state.isPickingTag ? 'Tag' : 'Pin';

      // Load this scan's point cloud and pick from it (model only when the scan has none).
      const pick = await _this.pick360ClickPoint(event);
      const intersection = pick.point;
      debugLog('[' + pickType + '] Pick result:', pick.source);

      if (!intersection) return;

      let worldIntersection = _this.view3dToWorld(intersection);

      if (store.state.isPickingTag) {
        viewer?.impl?.selector?.clearSelection();
        _this.addNewTag('360', worldIntersection, false, true);
      } else if (store.state.isPickingPin) {
        let coordinates = _this.panoramaViewer.mouseEventToCoords(event);
        store.state.pinnedPoint360 = {
          point: intersection,
          imgName: image.name,
          yaw: coordinates[1],
          pitch: coordinates[0],
        };
        _this.updatePinnedPointIn360();
        $('#panorama').css('cursor', 'hand');
      }
    };

    var _this = this;
    this.panoramaViewer.on('touchstart', onPointerDown);
    this.panoramaViewer.on('touchend', onPointerUp);
    this.panoramaViewer.on('mousedown', onPointerDown);
    this.panoramaViewer.on('mouseup', onPointerUp);

    // PanoramaCompass interaction gating — flips the reactive `isInteracting`
    // flag so the compass's rAF loop only runs during pointer-down + 500ms
    // coast window. Kept separate from the onPointerDown/onPointerUp handlers
    // above because those handlers do scaffold/tag-click logic and are noisy
    // to extend.
    const onCompassInteractStart = () => {
      if (_this._compassInteractEndTimer != null) {
        clearTimeout(_this._compassInteractEndTimer);
        _this._compassInteractEndTimer = null;
      }
      store.commit('SET_PANORAMA_COMPASS_INTERACTING', true);
    };
    const onCompassInteractEnd = () => {
      if (_this._compassInteractEndTimer != null) {
        clearTimeout(_this._compassInteractEndTimer);
      }
      _this._compassInteractEndTimer = setTimeout(() => {
        store.commit('SET_PANORAMA_COMPASS_INTERACTING', false);
        _this._compassInteractEndTimer = null;
      }, 500);
    };
    this.panoramaViewer.on('mousedown', onCompassInteractStart);
    this.panoramaViewer.on('touchstart', onCompassInteractStart);
    this.panoramaViewer.on('mouseup', onCompassInteractEnd);
    this.panoramaViewer.on('touchend', onCompassInteractEnd);

    this.panoramaViewer.on('load', (e) => {
      debugLog(`%c 360 viewer loaded Event`, 'color: green; font-weight: bold; font-size: 16px;');
      runLoad360ViewerCallback();
    });

    var mousewheelevt = /Firefox/i.test(navigator.userAgent) ? 'DOMMouseScroll' : 'mousewheel';
    this.panoramaViewer.getContainer().addEventListener(mousewheelevt, (evt) => {
      // Compass gating: zoom gestures count as interaction — kick the rAF
      // loop so the compass tracks yaw during wheel-driven pan/zoom.
      onCompassInteractStart();
      onCompassInteractEnd();
      store.commit('hideThumbnailPopup', '360');
      // if(mainApp.showComparasionTool && _this.lockedFOV_360){
      //     store.state.forgeService.panoramaViewer.setHfov(_this.lockedFOV_360,false)
      //     _this.panoramaViewer.stopMovement()
      //     return;
      // }

      if (
        !store.state.viewer ||
        !store.state.areViewsLocked ||
        !store.state.selectedImage ||
        !_this.panoramaViewer
      )
        return;
      _this.panoramaViewer.stopMovement();

      ///===== Old ways to map the HFOV with 3d FOV =====///
      // var fov = _this.panoramaViewer.getHfov();

      // 1- oldest way and not used from  4-2022
      // var ratio = (fov - 50.0) / 70.0;
      // var newFocalLength = 25 - 15 * ratio;
      // viewer.navigation.setFocalLength(newFocalLength);

      // 2- Not used from 10-2022
      // if(mainApp.localShowComparasionTool)
      //     fov = store.state.forgeService.getComparasionModeFOV(fov);
      // viewer.navigation.setFocalLength(viewer.navigation.fov2fl(fov));
      ///===============================================///

      // The newest way.
      this.mapPanoramaHFovTo3dVHov();
    });

    let handleMouseUp = () => {
      _this.startedPanoChange = false;
      if (store.state.viewer) {
        let walkEx = store.state.viewer.getExtension('Autodesk.BimWalk');
        if (walkEx) walkEx.deactivate();
      }
    };

    window.onmouseup = handleMouseUp;
    window.ontouchend = handleMouseUp;

    this.panoramaViewer.lookAt(
      lastCoordinates.pitch,
      lastCoordinates.yaw,
      this.panoramaViewer.getHfov(),
      0,
    );

    this.updatePinnedPointIn360();
    this.updateTagsAnnotationsInPanoViewer();
    this.update360ImagesHotspots();
  }
  getFittestHFov() {
    // This function is used to get fittest HFOV for 3d viewer.
    // IMPORTANT: Not implemented yet.
    let newHFov = this.panoramaViewer.getHfov();
    let notFit = true;
    while (notFit) {
      let vFov = this.get3dVFovFormPanoramaHFov(newHFov);

      let min = store.state.viewer.navigation.getFovMin();
      let max = store.state.viewer.navigation.getFovMax();

      if (vFov > max) {
        newHFov -= 1;
      } else if (vFov < min) {
        newHFov += 1;
      } else {
        notFit = false;
      }
    }
    return newHFov;
  }
  /** Where a 360 click's direction lands on the 3D viewer canvas, or null when not ready. */
  img360MouseToClientPoint(event) {
    // Guard: panorama viewer must be ready with a loaded image
    if (!this.panoramaViewer?.forgeImage) return null;
    // Guard: 3D viewer must be attached (not in temp-div / null state)
    if (!store.state.viewer) return null;

    let coordinates = this.panoramaViewer.mouseEventToCoords(event);
    let newTarget = this.imageYawPitchToPoint3D(
      this.panoramaViewer.forgeImage,
      coordinates[1],
      coordinates[0],
    );
    return store.state.viewer.worldToClient(newTarget);
  }
  /** Point-cloud hit behind a 360 click, in viewer space, or null. */
  img360MouseToPointCloudPoint(event) {
    const clientPoint = this.img360MouseToClientPoint(event);
    if (!clientPoint) return null;
    const rect = store.state.viewer.impl.canvas.getBoundingClientRect();
    const pointer = {
      x: clientPoint.x + rect.left,
      y: clientPoint.y + rect.top,
    };
    return this.getMainExtension()?.pickNearestPointCloudPoint(pointer) || null;
  }
  /** 3D-model hit behind a 360 click, in viewer space, or null. */
  img360MouseToModelPoint(event) {
    const clientPoint = this.img360MouseToClientPoint(event);
    if (!clientPoint) return null;
    return store.state.viewer?.impl?.castRay(clientPoint.x, clientPoint.y, false)?.point || null;
  }
  /**
   * Point cloud first, else the model - silently. Kept for measuring and the crop box; anything
   * that SAVES a position from a 360 click goes through pick360ClickPoint instead.
   */
  img360MouseTo3DPoint(event) {
    return this.img360MouseToPointCloudPoint(event) || this.img360MouseToModelPoint(event);
  }
  /**
   * Resolves a 360 click to a 3D point from the scan's own point cloud (see utils/pano360Pick).
   * Loads that cloud even when another one is open, retries while it streams in, and falls back
   * to the model - with a warning - only when the scan has no point cloud.
   * A click that lands while an earlier pick is still waiting for the cloud (up to 10 s) is
   * ignored and answers `busy: true`, so one click never saves two points.
   * @returns {Promise<{point: Object|null, source: string|null, autoLoadedPcName: string|null,
   *   busy?: boolean}>} `point` is in viewer space.
   */
  async pick360ClickPoint(event, image = this.panoramaViewer?.forgeImage || store.state.selectedImage) {
    if (this._pano360PickInFlight) {
      return { point: null, source: null, autoLoadedPcName: null, busy: true };
    }
    this._pano360PickInFlight = true;
    try {
      return await this.runPick360(event, image);
    } finally {
      this._pano360PickInFlight = false;
    }
  }
  runPick360(event, image) {
    return pick360Point({
      loadScanPointCloud: () => (image
        ? store.dispatch('OPEN_360_CORRESPONDING_PC', { selectedImage: image, useAnalyzerPriority: false })
        : Promise.reject(new Error('No 360 image selected'))),
      pickPointCloud: () => this.img360MouseToPointCloudPoint(event),
      pickModel: () => this.img360MouseToModelPoint(event),
      waitForRender: (ms) => new Promise((resolve) => {
        store.state.viewer?.impl?.invalidate(true, true, true);
        setTimeout(resolve, ms);
      }),
      notify: {
        info: (message) => Vue.prototype.$dialog.notify.info(message, { position: 'top-right', timeout: 3000 }),
        warning: (message) => Vue.prototype.$dialog.notify.warning(message, { position: 'top-right', timeout: 6000 }),
      },
    });
  }
  getClosestImageToPoint(point) {
    var images = store.state.projects.flatMap((o) => o.images);
    if (images.length == 0) return null;
    images.sort((a, b) => {
      if (
        a.getCameraPositionInViewer().distanceTo(point) <
        b.getCameraPositionInViewer().distanceTo(point)
      )
        return -1;
      return 1;
    });

    return images[0];
  }
  updatePinnedPointIn360() {
    $('.pnlm-ui').css('cursor', '');
    if (
      !store.state.pinnedPoint360 ||
      store.state.pinnedPoint360.imgName != store.state.selectedImage.name
    )
      return;
    function hotspot(hotSpotDiv, args) {
      hotSpotDiv.classList.add('custom-tooltip');
      var personIcon = document.createElement('div');
      personIcon.className = `person-icon pinned-point-360`;
      hotSpotDiv.appendChild(personIcon);
    }
    let pinnedId = 'pinnedPoint';
    let hotspotImg = {
      id: pinnedId,
      pitch: store.state.pinnedPoint360.pitch,
      yaw: store.state.pinnedPoint360.yaw,
      cssClass: 'custom-hotspot-pinned',
      createTooltipFunc: hotspot,
      createTooltipArgs: '',
      clickHandlerFunc: function (event) { },
      clickHandlerArgs: 'test',
    };
    this.panoramaViewer.removeHotSpot(pinnedId, this.panoCustomSceneId);
    this.panoramaViewer.addHotSpot(hotspotImg, this.panoCustomSceneId);
    store.commit('setIsPickingPin', false);
  }
  removePinnedPointIn360() {
    store.state.pinnedPoint360 = null;
    store.commit('setIsPickingPin', false);
    this.panoramaViewer?.removeHotSpot('pinnedPoint', this.panoCustomSceneId);
  }
  update360ImagesHotspots() {
    if (!this.panoramaViewer) return;

    let image = this.panoramaViewer.forgeImage;
    //remove existing images
    let allImages = store.state.projects.flatMap((o) => o.images);
    allImages.forEach((o) => {
      this.panoramaViewer.removeHotSpot(o.name, this.panoCustomSceneId);
    });

    let visibilityRange = Math.min(store.state.userSettings.displaySettings.getVisibilityRange(), 15);
    var nearImages = [];
    if (store.state.userSettings.displaySettings.show360)
      nearImages = store.state.forgeService.getAllShownPanoramaImagesIn3D();

    nearImages = nearImages.filter(
      (o) =>
        o != image &&
        o.name != image.name &&
        o.forgeCameraPosition.distanceTo(image.forgeCameraPosition) < visibilityRange,
    );

    // let isGlobalSearchTabShown = store.state.isTabShown && store.state.selectedTab == 0;

    // if (isGlobalSearchTabShown && store.getters['GET_GLOBAL_SEARCH_TEXT'])
    //   nearImages = nearImages.filter((o) => store.state.filtered360Imgs.includes(o));
    if (nearImages.length == 0) return;

    var _this = this;

    function hotspot(hotSpotDiv, args) {
      // var imagePath = require(`@/images/${args.scanType.charAt(0).toUpperCase() + args.scanType.slice(1)
      //   }.png`);
      let imagePath = require(`@/images/tags-icons/image360.png`);

      hotSpotDiv.classList.add('custom-tooltip');
      var personIcon = document.createElement('img');
      personIcon.className = `person-icon ${args.scanType}-icon`;
      personIcon.src = imagePath;
      hotSpotDiv.appendChild(personIcon);
      //All calculated in meters
      var devicePixelRatio = window.devicePixelRatio;

      let unitScale = store.state.unitScale ?? 1.0;

      var scaleFactor = 1 / unitScale;

      var distanceFromCamera =
        args.forgeCameraPosition.distanceTo(image.forgeCameraPosition) * scaleFactor;

      let newWidth = 20.0 * (20.0 / (distanceFromCamera + 1.0)) * scaleFactor;

      if (newWidth < 20) newWidth = 20;

      // Max gl_PointSize value
      if (newWidth > 1024.0) newWidth = 1024.0;

      newWidth /= devicePixelRatio;

      personIcon.style.width = newWidth + 'px';
      personIcon.style.height = newWidth + 'px';

      personIcon.addEventListener('dblclick', (event) => {
        // Cancel the pending single-click card open for this bubble (args === o)
        // so it never appears, then navigate into the scan.
        const pending = _scanBubbleClickTimers.get(args);
        if (pending) {
          clearTimeout(pending);
          _scanBubbleClickTimers.delete(args);
        }
        debugLog('[360-Card] scan-bubble double-click → navigate', args.name);
        store.commit('hideThumbnailPopup', '360');
        _this.showImageInViews(args)
      });

      personIcon.addEventListener('mouseover', function (e) {
        let personIconBoundry = personIcon.getBoundingClientRect();

        let width = personIconBoundry.width ? personIconBoundry.width : 20; // personIcon css class default width
        var hotSpotDivStyle = window.getComputedStyle(hotSpotDiv);
        var matrix = new window.WebKitCSSMatrix(hotSpotDivStyle.transform);

        const text = args.name;
        const font = '16px ArtifaktElement';
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        context.font = font;
        const offset = context.measureText(text);

        let textWidth = offset.width > 200 ? offset.width : 200;

        store.commit('setTooltipObject', {
          title: args.name,
          position: {
            left: matrix.m41,
            top: matrix.m42 - 40,
          },
          margin: width / 2 - (textWidth + 20) / 2, // tooltip width + 20 padding
        });
      });

      personIcon.addEventListener('mouseout', function (e) {
        store.commit('setTooltipObject', null);
      });
    }
    nearImages.forEach((o) => {
      var direction = new THREE.Vector3();
      direction.subVectors(o.forgeCameraPosition, image.forgeCameraPosition).normalize();
      var info = _this.getNewYawAndPitch(image, direction);
      let hotspotImg = {
        id: o.name,
        pitch: info['pitch'],
        yaw: info['yaw'],
        cssClass: 'custom-hotspot',
        createTooltipFunc: hotspot,
        createTooltipArgs: o,
        clickHandlerFunc: function (event) {
          // Debounce the single-click card open so a double-click (navigate)
          // never flashes the card. Capture coords now — the event is recycled.
          const coords = _this.panoEventToContainerOffset(event);
          const pending = _scanBubbleClickTimers.get(o);
          if (pending) clearTimeout(pending);
          _scanBubbleClickTimers.set(
            o,
            setTimeout(() => {
              _scanBubbleClickTimers.delete(o);
              debugLog('[360-Card] scan-bubble single-click → open card', o.name);
              _this.onClickOn3dIcon(o, coords, '360');
            }, SCAN_BUBBLE_CLICK_DELAY_MS),
          );
        },
        clickHandlerArgs: 'test',
      };
      this.panoramaViewer.addHotSpot(hotspotImg, this.panoCustomSceneId);
    });
  }

  updateTagsAnnotationsInPanoViewer() {
    if (!this.panoramaViewer) return;
    // Make sure the manager is initialized with the current panorama viewer
    this.panoramaHotspotManager.initialize(this.panoramaViewer, this.panoCustomSceneId);

    // Delegate to the manager to update all hotspots
    this.panoramaHotspotManager.updateAllHotspots();
  }

  create360HighlightHotspot(tag, options = {}) {
    const image = this.panoramaViewer?.forgeImage;
    if (!image || !tag?.point || !this.panoramaHotspotManager) return false;

    this.panoramaHotspotManager.initialize?.(this.panoramaViewer, this.panoCustomSceneId);
    const seed = createPanoramaTagSelectionSeed({
      tag,
      facilityId: options.facilityId ?? store.state.assetId,
      scanId: options.scanId ?? image.id,
    });
    const selection = this.panoramaHotspotManager.beginTagHotspotSelection(seed);
    return this.panoramaHotspotManager.selectTagHotspot(
      selection,
      this.panoramaHotspotManager.getTagHotspotSelectionGeneration(),
      options.receipt ?? null,
    );
  }

  // ─── Cross-viewer marker sync (Phase 1a) — 360 highlight ────────────────────
  /**
   * Single-slot 360 highlight for a CML/TML at a RAW world point, rendered as a
   * pulsing CONDITION-colored glow disc concentric with the marker — mirrors the
   * 3D `highlightMarkerIn3D` sphere glow so the highlight reads the same across
   * viewers. Uses a dedicated POI slot so tag selection remains independently
   * visible. `colorHex` falls back to brand green if unknown;
   * `entityType` ('cml' | 'tmlpoint') sizes the glow to ~1.65× the marker so the
   * glow-to-marker ratio matches the other viewers (CML triangle > TML square).
   */
  highlightPointIn360(rawPoint, colorHex, entityType) {
    if (!this.panoramaViewer || !rawPoint) return;
    const image = this.panoramaViewer?.forgeImage;
    const position = image?.forgeCameraPosition;
    if (!position) return;
    const p = rawPoint instanceof THREE.Vector3 ? rawPoint : new THREE.Vector3(rawPoint.x, rawPoint.y, rawPoint.z);
    const direction = new THREE.Vector3().subVectors(p, position).normalize();
    const info = this.getNewYawAndPitch(image, direction);
    const color = colorHex || '#03624C';
    // ~1.65× the marker box (CML triangle 22px, TML square 16px) so the glow-to-
    // marker ratio matches the 3D and doc highlights.
    const glowSize = (entityType === 'tmlpoint' || entityType === 'tml') ? 26 : 36;
    const hotspotIcon = {
      id: this.poiHighlightId,
      pitch: info['pitch'],
      yaw: info['yaw'],
      cssClass: 'custom-hotspot',
      createTooltipFunc: (hotSpotDiv) => {
        // A pulsing condition-colored glow disc, concentric with the marker —
        // shape-agnostic (a circle), matching the 3D sphere-glow highlight.
        // Purely visual: it sits on top of the marker and pulses past its edge, so
        // the whole highlight hotspot must be transparent to pointer input or it
        // would block clicks meant for the marker beneath it (or the panorama).
        hotSpotDiv.style.pointerEvents = 'none';
        const glow = document.createElement('div');
        glow.className = 'cml-360-glow-highlight';
        glow.style.width = `${glowSize}px`;
        glow.style.height = `${glowSize}px`;
        glow.style.backgroundColor = color;
        hotSpotDiv.appendChild(glow);
      },
    };
    this.panoramaViewer.removeHotSpot(this.poiHighlightId, this.panoCustomSceneId);
    this.panoramaViewer.addHotSpot(hotspotIcon, this.panoCustomSceneId);
    debugLog('[xsync] 360 highlight set', color);
  }

  clearPointHighlightIn360() {
    if (this.panoramaViewer) this.panoramaViewer.removeHotSpot(this.poiHighlightId, this.panoCustomSceneId);
  }

  showImageInViews(image) {
    if (!image.imageUrl) {
      Vue.prototype.$dialog.notify.warning('No image found.');
      return;
    }

    const preservedSlot = store.getters['GET_PANORAMA_PRESERVED_IN_SLOT'];

    if (preservedSlot) {
      if (this._pendingCropConfirm) return;
      this._pendingCropConfirm = true;
      Vue.prototype.$dialog.confirm({
        text: 'Opening a new scan will end the current crop session. Continue?',
        title: 'Crop Session Active',
        actions: {
          false: 'Cancel',
          true: { text: 'Continue', color: 'primary' },
        },
      }).then((confirmed) => {
        this._pendingCropConfirm = false;
        if (!confirmed) {
          return;
        }
        store.dispatch('DISPOSE_PANORAMA_VIEWER');
        this._showImageInViewsCore(image);
      });
      return;
    }

    this._showImageInViewsCore(image);
  }

  _showImageInViewsCore(image) {
    if (!getViewPage360()) {
      store.state.mainApp.openViewPageWithType('360');
    } else {
      store.state.mainApp.showViewPageWithType('360');
    }

    setTimeout(() => {
      if (store.state.viewer) {
        this.getAllPanoramaImages().forEach((o) => (o.isShown = false));
        image.isShown = true;
        //pano viewer
        this.launchPanoViewer(image);

        //forge viewer
        this.navigateIn3D(image);
        getViewPage360().is360Locked = true;
        getViewPage360().clearPanoMeasuringDimensions();
      } else this.launchPanoViewer(image);

      // In compare mode
      if (store.getters['getShowComparasionTool']) {
        store.commit('SET_COMPARE_MODE_IMAGE', image)
      }
    }, 100);
  }
  navigateIn3D(image) {
    if (!store.state.viewer?.model) return;

    if (this.panoramaViewer) {
      ///===== Old way to map the 3d viewer with panorama viewer =====///
      // var fov = this.panoramaViewer.getHfov();
      // if (mainApp.localShowComparasionTool) {
      //     fov = store.state.forgeService.getComparasionModeFOV(fov);
      // }
      // viewer.navigation.setFocalLength(viewer.navigation.fov2fl(fov));
      ///=============================================================///
      this.mapPanoramaHFovTo3dVHov();
    }

    store.commit('hideThumbnailPopup', '3d');

    store.state.viewer.navigation.setPosition(image.getCameraPositionInViewer());
    var newTarget = store.state.viewer.navigation.getPosition().add(image.lockedForgeDirection);
    store.state.viewer.navigation.setTarget(newTarget);
    store.state.viewer.navigation.setCameraUpVector(new THREE.Vector3(0, 0, 1));
    // setTimeout(() => {
    //   image.viewerLockedState = store.state.viewer.getState();
    // }, 100);
    store.state.viewer.navigation.setLockSettings({ walk: true, fov: true });
    //viewer.navigation.setIsLocked(true);
    let walkExt = store.state.viewer.getExtension('Autodesk.BimWalk');
    if (walkExt) {
      walkExt.activate();
      setTimeout(() => {
        $('.c-bimwalk-tooltip__actions #dontRemind').click();
      }, 50);
      walkExt.deactivate();
      walkExt.tool.navigator.enableGravity(false);
    }
    if (this.panoramaViewer) store.state.areViewsLocked = true;
  }
  dbidToForgeObject(dbid, model) {
    // Delegates to the canonical GLOBAL-space recipe. The old inline version
    // added globalOffset without × unitScale, persisting raw-model centers on
    // every non-metres facility (the Register-2D corruption channel).
    // Contract preserved: returns null when the object cannot be built —
    // callers already handle null (missing instanceTree did this before).
    try {
      return forgeObjectFromDbId(dbid, model);
    } catch (err) {
      if (err?.name === 'CoordinateSpaceError') {
        debugError('[CoordAuthority] dbidToForgeObject blocked:', err.message);
        Vue.prototype.$dialog?.notify?.error?.(err.message);
        return null;
      }
      throw err;
    }
  }

  updatePanoViewerFromForge(image) {
    if (this._suppressPanoSync) {
      return;
    }
    if (!this.panoramaViewer) {
      return;
    }
    var newDirection = store.state.viewer.navigation.getCamera().getWorldDirection();
    var info = this.getNewYawAndPitch(image, newDirection);

    this.panoramaViewer.lookAt(info['pitch'], info['yaw'], this.panoramaViewer.getHfov(), 0);

    getViewPage360()?.updatePanoDimensionLineInformation();
  }
  scrollToImage360(image) {
    //expand and scroll to element
    let level = store.state.projects.find((o) => o.images.includes(image));
    level.isExpanded = true;
    setTimeout(() => {
      let elem = document.getElementById('image360_' + image.id);
      if (elem) elem.scrollIntoView();
    }, 500);
  }
  getNewYawAndPitch(image, newDirection) {
    //set yaw
    var startVec2D = toPoint2D(image.lockedForgeDirection);
    var newVec2D = toPoint2D(newDirection);
    var angle = THREE.Math.radToDeg(startVec2D.angleTo(newVec2D));
    const multiplier = 1 - (Math.abs(angle) / 90); // Calculate multiplier based on the percentage of the angle from 0 180 0 -180 of the rotation
    if (startVec2D.cross(newVec2D).z > 0) angle = -angle;
    angle += image.lockedYaw;
    if (angle > 180) angle -= 360;
    else if (angle < -180) angle += 360;

    //set pitch
    let correctionPitchAngle = multiplier * image.lockedPitch;
    var verticalAngle = THREE.Math.radToDeg(newDirection.angleTo(newVec2D));
    if (newDirection.z < 0) verticalAngle = -verticalAngle;
    verticalAngle += correctionPitchAngle;
    if (verticalAngle > 180) verticalAngle -= 360;
    else if (verticalAngle < -180) verticalAngle += 360;
    return { yaw: angle, pitch: verticalAngle };
  }

  // ============== Crop Box 360 Methods ==============

  enableCropBoxModeIn360() {
    const panoramaContainer = document.getElementById('panoramaContainer');
    if (panoramaContainer) {
      this._cropBoxClickHandler = (event) => this.handlePanoramaClickForCropBox(event);
      panoramaContainer.addEventListener('click', this._cropBoxClickHandler);
    }
  }

  disableCropBoxModeIn360() {
    const panoramaContainer = document.getElementById('panoramaContainer');
    if (panoramaContainer) {
      if (this._cropBoxClickHandler) {
        panoramaContainer.removeEventListener('click', this._cropBoxClickHandler);
        this._cropBoxClickHandler = null;
      }
    }
  }

  async handlePanoramaClickForCropBox(event) {
    try {
      // Check left click
      if(event.button !== 0) return;

      // Map to 3D point
      const point3D = this.img360MouseTo3DPoint(event);

      // Guard: the point-cloud picker runs with pickClipped:true, so when a crop box
      // is already applied it can only resolve points INSIDE the cropped region.
      // A click outside those boundaries (or on empty sky/gap) returns null/undefined,
      // and create1x1x1Box(undefined) would throw "Cannot read properties of undefined (reading 'x')".
      // Inform the user why instead of crashing, and keep the mode active so they can retry.
      if (!point3D) {
        const cropExt = this.getCropping3DExtension();
        const cropApplied = !!cropExt?.croppingOn;
        debugLog('[CropBox360] No 3D point resolved from panorama click (cropApplied=' + cropApplied + ') — keeping mode active for retry');
        Vue.prototype.$dialog.notify.warning(
          cropApplied
            ? 'The selected point is outside the current crop box boundaries. Click within the cropped region, or clear the crop box to pick anywhere.'
            : 'Could not resolve a 3D point — please click on a loaded point cloud area.',
          { position: 'top-right', timeout: 4000 }
        );
        return;
      }

      // Create 1x1x1 box
      const box = this.create1x1x1Box(point3D);

      // Apply crop box to 3D viewer (3D viewer and PC already open via tryOpen360CorrespondingPC)
      this.applyCropBoxFrom360(box, point3D);

      // Directly open measurement viewer
      this.openMeasurementViewerWithCropBox();

      // Deactivate mode
      store.commit('SET_CROP_BOX_MODE_360', false);
      this.disableCropBoxModeIn360();
      $('.pnlm-ui').css('cursor', 'default');

    } catch (error) {
      debugError('Crop box 360 error:', error);
      store.commit('SET_CROP_BOX_MODE_360', false);
      this.disableCropBoxModeIn360();
      $('.pnlm-ui').css('cursor', 'default');
    }
  }

  panoramaCoordinateTo3D(yaw, pitch) {
    const currentImage = store.state.selectedImage;
    if (!currentImage?.forgeCameraPosition) {
      throw new Error('No 360 image camera position available');
    }

    // Camera position as origin
    const cameraPos = currentImage.forgeCameraPosition.clone();

    // Convert yaw/pitch to direction vector
    const yawRad = THREE.Math.degToRad(yaw);
    const pitchRad = THREE.Math.degToRad(pitch);

    const direction = new THREE.Vector3(
      Math.cos(pitchRad) * Math.sin(yawRad),
      Math.sin(pitchRad),
      Math.cos(pitchRad) * Math.cos(yawRad)
    ).normalize();

    // Project point 5 meters from camera (configurable)
    const distance = 5; // meters
    return cameraPos.clone().add(direction.multiplyScalar(distance));
  }

  create1x1x1Box(centerPoint) {
    // Build a 1 cubic-METRE box (±0.5 m from centre). The half-size MUST be converted
    // from metres to viewer-space units via worldToView3dLength — a raw 0.5 is 0.5 viewer
    // units, which at unitScale=0.001 is 0.5 mm, producing a ~1 mm box. In the standalone
    // Potree measurement viewer that box (volScale≈0.001) is smaller than the camera's
    // fixed near plane (0.01), so it's clipped to black on open until manually scaled up.
    // Converting to metres yields volScale≈1, which frames correctly and contains points.
    const halfSize = this.worldToView3dLength(0.5);
    debugLog('[CropBox360] create1x1x1Box halfSize (viewer units):', halfSize, 'unitScale:', store.state.unitScale);

    return new THREE.Box3(
      new THREE.Vector3(
        centerPoint.x - halfSize,
        centerPoint.y - halfSize,
        centerPoint.z - halfSize
      ),
      new THREE.Vector3(
        centerPoint.x + halfSize,
        centerPoint.y + halfSize,
        centerPoint.z + halfSize
      )
    );
  }

  applyCropBoxFrom360(box, center) {
    const cropExt = store.state.viewer.getExtension('Cropping3DExtension');
    if (!cropExt) {
      throw new Error('Cropping extension not loaded');
    }

    cropExt.cropBoxOrigin = center;
    cropExt.setCropBox(box);
    cropExt.toggleCropbox(true);
    store.commit('setIsCropBoxVisible', true);

    // Update images in crop box if needed
    store.dispatch('updateImagesInCropbox');
  }

  openMeasurementViewerWithCropBox() {
    const cropExt = store.state.viewer.getExtension('Cropping3DExtension');
    if (!cropExt) {
      throw new Error('Cropping extension not available');
    }

    // Reuse existing measurement dialog logic
    cropExt.openMeasurementDialog();
  }

  // ============== End Crop Box 360 Methods ==============

  // ============== Crop 360 Action (new crop button on 360 view) ==============

  enableCrop360Mode() {
    // Always clean up first — prevents double-registration if called without a preceding disable
    this.disableCrop360Mode();
    const panoramaContainer = document.getElementById('panoramaContainer');
    if (panoramaContainer) {
      this._crop360ClickHandler = (event) => this._onCrop360Click(event);
      panoramaContainer.addEventListener('click', this._crop360ClickHandler);
    }
  }

  disableCrop360Mode() {
    const panoramaContainer = document.getElementById('panoramaContainer');
    if (panoramaContainer && this._crop360ClickHandler) {
      panoramaContainer.removeEventListener('click', this._crop360ClickHandler);
      this._crop360ClickHandler = null;
    }
  }

  async _onCrop360Click(event) {
    try {
      // Cheap filter first, then state check
      if (event.button !== 0) return;
      if (!store.state.isCropBox360Active) return;

      // Resolve click to a 3D world point: point cloud first, else the 3D model.
      // img360MouseTo3DPoint returns null only when the viewer is not ready or both miss.
      const point3D = this.img360MouseTo3DPoint(event);
      if (!point3D) {
        // Keep mode active so the user can retry on a loaded area
        Vue.prototype.$dialog.notify.warning(
          'Could not resolve a 3D point — please click on a loaded point cloud area.',
          { position: 'top-right', timeout: 3000 }
        );
        return;
      }

      if (store.state.cropFromNearbySelector) {
        debugLog('[Nearby360] _onCrop360Click → cropFromNearbySelector=true → setting reference point only (no crop)')
        const worldPoint = this.view3dToWorld(point3D);
        store.commit('SET_REFERENCE_POINT_360', worldPoint);
        store.commit('SET_CROP_FROM_NEARBY_SELECTOR', false);
        this.panoramaHotspotManager.updateReferencePointHotSpot();
      } else {
        debugLog('[Nearby360] _onCrop360Click → standard crop360 → applying crop box + split screen')
        this._applyCrop360AtPoint(point3D);
        this._ensure360And3DVisible();
      }

      // Deactivate mode
      store.commit('SET_CROP_BOX_360_ACTIVE', false);
      this.disableCrop360Mode();
      $('.pnlm-ui').css('cursor', 'default');

    } catch (err) {
      debugError('[Crop360] Error handling panorama click:', err);
      store.commit('SET_CROP_BOX_360_ACTIVE', false);
      this.disableCrop360Mode();
      $('.pnlm-ui').css('cursor', 'default');
    }
  }

  /**
   * Ensures both the 360 and 3D viewer slots are visible.
   * - If a viewer type exists in a hidden slot, shows it (showViewPageWithType).
   * - If a viewer type is absent entirely, opens a new slot (openViewPageWithType).
   * Does NOT force compare/overlay mode — leaves layout to the existing slot arrangement.
   */
  _ensure360And3DVisible() {
    const mainApp = store.state.mainApp;
    if (!mainApp) return;

    const viewSlots = [1, 2, 3, 4];

    const has360Visible = viewSlots.some((i) => mainApp[`view${i}Type`] === '360' && mainApp[`isView${i}Visible`]);
    const has3DVisible  = viewSlots.some((i) => mainApp[`view${i}Type`] === '3d'  && mainApp[`isView${i}Visible`]);

    if (!has360Visible) {
      // Check whether a 360 slot exists but is hidden — just show it instead of opening a new one
      const has360Hidden = viewSlots.some((i) => mainApp[`view${i}Type`] === '360' && !mainApp[`isView${i}Visible`]);
      has360Hidden ? mainApp.showViewPageWithType('360') : mainApp.openViewPageWithType('360');
    }

    if (!has3DVisible) {
      const has3DHidden = viewSlots.some((i) => mainApp[`view${i}Type`] === '3d' && !mainApp[`isView${i}Visible`]);
      has3DHidden ? mainApp.showViewPageWithType('3d') : mainApp.openViewPageWithType('3d');
    }
  }

  /**
   * Applies a 2x2x2 metre crop box centred on the given 3D point.
   * Clears any existing crop first to ensure a clean state.
   *
   * Coordinate space notes:
   *  - `point` comes from img360MouseTo3DPoint() — already in viewer-space.
   *  - The radius 1 (one real-world metre) is converted to viewer-space units via
   *    worldToView3dLength(1) so the box is always 2m real-world regardless of unitScale.
   */
  _applyCrop360AtPoint(point) {
    if (!store.state.unitScale) {
      debugError('[Crop360] unitScale is 0 — model units not yet set, aborting crop');
      return;
    }

    const cropExt = this.getCropping3DExtension();
    if (!cropExt) {
      debugError('[Crop360] Cropping3DExtension not available');
      return;
    }

    // Clear any existing crop box first
    if (cropExt.croppingOn) {
      cropExt.toggleCropbox(false);
    }

    // Convert 1 real-world metre → viewer-space units (divides by unitScale)
    const viewerSpaceRadius = this.worldToView3dLength(1);

    // Create a 2x2x2 real-world-metre box around the clicked point
    const box = createBoxAroundPoint(point, viewerSpaceRadius);

    cropExt.cropBox = box;
    cropExt.cropBoxOrigin = point;
    cropExt.toggleCropbox(true);

    store.commit('setIsCropBoxVisible', true);
    store.dispatch('updateImagesInCropbox');
  }

  // ============== End Crop 360 Action ==============

  linkViewers(forceLock) {
    // Don't re-lock during crop session (panorama preserved in background)
    if (store.getters['GET_PANORAMA_PRESERVED_IN_SLOT']) {
      return;
    }
    if (
      !store.state.selectedImage ||
      !store.state.viewer ||
      (store.state.areViewsLocked && !forceLock)
    )
      return;

    // Camera Position
    store.state.viewer.navigation.setPosition(
      store.state.selectedImage.getCameraPositionInViewer(),
    );

    // Camera Target
    let yaw = store.state.forgeService.panoramaViewer.getYaw();
    let pitch = store.state.forgeService.panoramaViewer.getPitch();
    let newTarget = store.state.forgeService.imageYawPitchToPoint3D(
      store.state.selectedImage,
      yaw,
      pitch,
    );
    store.state.viewer.navigation.setTarget(newTarget);
    store.state.viewer.navigation.setCameraUpVector(new THREE.Vector3(0, 0, 1));

    // FOV
    ///===== Old way to link 3d with panorama and map FOV between them =====///
    // var fov = store.state.forgeService.panoramaViewer.getHfov();
    // if (mainApp.localShowComparasionTool) fov = store.state.forgeService.getComparasionModeFOV(fov);
    // viewer.navigation.setFocalLength(viewer.navigation.fov2fl(fov));
    ///=====================================================================///
    this.mapPanoramaHFovTo3dVHov();

    // setTimeout(() => {
    //   store.state.selectedImage.viewerLockedState = store.state.viewer.getState();
    // }, 100);

    // BimWalk
    store.state.viewer.navigation.setLockSettings({ walk: false, fov: true });
    let walkExt = store.state.viewer.getExtension('Autodesk.BimWalk');
    if (walkExt) {
      walkExt.activate();
      setTimeout(() => {
        $('.c-bimwalk-tooltip__actions #dontRemind').click();
      }, 50);
      walkExt.deactivate();
      walkExt.tool.navigator.enableGravity(false);
      walkExt.tool.navigator.set('mouseTurnInverted', true);
    }

    // Lock viewers
    store.state.areViewsLocked = true;
  }
  updateforgeViewerFromPano(image) {
    let newTarget = this.imageYawPitchToPoint3D(
      image,
      this.panoramaViewer.getYaw(),
      this.panoramaViewer.getPitch(),
    );
    store.state.viewer.navigation.setTarget(newTarget);

    getViewPage360()?.updatePanoDimensionLineInformation();

    //update up direction
    let camera = store.state.viewer.getCamera();
    camera.up = new THREE.Vector3(0, 0, 1);
    store.state.viewer.applyCamera(camera);
  }
  imageYawPitchToPoint3D(image, yaw, pitch) {
    //get right 2D direction
    var deltaYaw = yaw - image.lockedYaw;
    //set the direction of the axis to make right rotation
    var axis = new THREE.Vector3(0, 0, deltaYaw > 0 ? -1 : 1);
    //remove the negative sign as the rotation direction is handled by the axis
    deltaYaw = Math.abs(deltaYaw);
    const multiplier = 1 - (deltaYaw / 90);
    var vec2D = toPoint2D(image.lockedForgeDirection);
    vec2D.applyAxisAngle(axis, THREE.Math.degToRad(deltaYaw));
    let cameraPosition = image.getCameraPositionInViewer();
    var newTarget = cameraPosition.clone().add(vec2D);

    //get z
    var deltaPitch = pitch - (multiplier * image.lockedPitch);
    var dist = toPoint2D(cameraPosition).distanceTo(toPoint2D(newTarget));
    var z = dist * Math.tan(THREE.Math.degToRad(deltaPitch));
    newTarget.z += z;
    return newTarget;
  }
  getCameraAngle() {
    var direc = store.state.viewer.navigation.getCamera().getWorldDirection();
    var direc2D = toPoint2D(direc);
    var upVec = new THREE.Vector3(0, 1, 0);
    var angle = THREE.Math.radToDeg(upVec.angleTo(direc2D));
    if (direc.x < 0) angle += (180 - angle) * 2;
    return angle;
  }
  //https://stackoverflow.com/questions/59385734/how-can-i-create-section-box-in-forge-viewer
  cropLevelIn3D(levels) {
    store.state.levels.forEach((o) => (o.isCropped = false));

    if (levels.length == 0) {
      store.state.viewer.setCutPlanes(null);
      this.updateAll3DIcons();
      return;
    }

    levels.forEach((level) => (level.isCropped = true));

    const normals = [
      new THREE.Vector3(1, 0, 0),
      new THREE.Vector3(0, 1, 0),
      new THREE.Vector3(0, 0, 1),
      new THREE.Vector3(-1, 0, 0),
      new THREE.Vector3(0, -1, 0),
      new THREE.Vector3(0, 0, -1),
    ];

    let points = levels.map((o) => o.getViewCropBox()).flatMap((o) => [o.min, o.max]);
    let bbox = new THREE.Box3().setFromPoints(points);
    const cutPlanes = [];

    for (let i = 0; i < normals.length; i++) {
      const plane = new THREE.Plane(normals[i], -1 * bbox.max.dot(normals[i]));

      // offset plane with negative normal to form an octant
      if (i > 2) {
        const ptMax = plane.orthoPoint(bbox.max);
        const ptMin = plane.orthoPoint(bbox.min);
        const size = new THREE.Vector3().subVectors(ptMax, ptMin);
        plane.constant -= size.length();
      }

      const n = new THREE.Vector4(plane.normal.x, plane.normal.y, plane.normal.z, plane.constant);
      cutPlanes.push(n);
    }

    store.state.viewer.setCutPlanes(cutPlanes);

    var mainExtension = store.state.forgeService.getMainExtension();
    if (mainExtension._pointclouds) {
      var pointclouds = Array.from(mainExtension._pointclouds.values());
      if (pointclouds.length == 0) return;
      pointclouds.forEach((o) => o.setClippingBoxNew(bbox));
    }

    //update cropped 3d icons
    this.updateAll3DIcons();
  }
  toggleShowingModel(model) {
    if (model.isLoading) return;
    if (model.isShown) {
      var models = store.state.viewer.impl.modelQueue().getModels();
      var forgeModel = models.find(
        (o) =>
          o.getSeedUrn() == model.urn ||
          o.getSeedUrn() + '==' == model.urn ||
          o.getSeedUrn() + '=' == model.urn,
      );
      store.state.viewer.impl.removeModel(forgeModel);
      model.isShown = false;
    } else {
      model.isLoading = true;
      checkIsModelTrasnlated(model.urn, model.apsRegion, (isTranslated, progress) => {
        if (!isTranslated) {
          Vue.prototype.$dialog.notify.warning('Model translation in progress.', {
            position: 'top-right',
            timeout: 3000,
          });
          model.isLoading = false;
          return;
        } else {
          var state = store.state.viewer.getState({ viewport: true });
          addViewable(
            store.state.viewer,
            model.urn,
            null,
            store.state.globalOffset,
          )
            .then((m) => {
              store.state.viewer.restoreState(state, { viewport: true }, true);
              model.isLoading = false;
              model.isShown = true;
            })
            .catch((error) => {
              debugLog(error);
              model.isLoading = false;
            });
        }
      });
    }
  }
  textFileContentToImages(text, imageInfoList, scanType, onProgress) {
    var result = [];
    if (scanType == 'faro') {
      var lines = text.split('{')[1].split('}')[0].split('\n');

      for (var i = 0; i < lines.length; i++) {
        if (onProgress) onProgress((i / lines.length) * 100);

        var parts = lines[i].split(' ');
        if (parts.length < 8) continue;
        var name = parts[0].split('"')[1];

        let info = imageInfoList.find((o) => o.name == name);
        if (!info) continue;

        let imageRotation = Number.parseFloat(parts[7]);
        let easting = Number.parseFloat(parts[1]);
        let northing = Number.parseFloat(parts[2]);
        let elevation = Number.parseFloat(parts[3]);

        let rotationX = Number.parseFloat(parts[4]);
        let rotationY = Number.parseFloat(parts[5]);
        let rotationZ = Number.parseFloat(parts[6]);
        let img = new Image360();
        img.name = name;
        img.width = info.width;
        img.height = info.height;
        // let date = parts[8].split('.');
        // let time = parts[9].trim().split(':');
        // img.createDate = new Date(
        //   date[2],
        //   date[1],
        //   date[0],
        //   time[0],
        //   time[1],
        //   time[2],
        // ).toGMTString();
        img.createDate = this.dateTimeNow()
        img.createdBy = store.state.username;
        img.scanType = scanType;
        img.rotationX = rotationX;
        img.rotationY = rotationY;
        img.rotationZ = rotationZ;
        img.rotationAngle = imageRotation;
        // img.imageUrl = '../images/360-Panorama/' + name + ".jpg";
        img.isLocked = true;
        var rotation = axisAngleToEuler(rotationX, rotationY, rotationZ, imageRotation);

        img.lockedYaw = this.loadedFileAngleToYaw(rotation.z);
        img.lockedPitch = 0; //this.getPitch(rotationX,rotationY,rotationZ);
        img.forgeCameraPosition = new THREE.Vector3(easting, northing, elevation);
        img.lockedForgeDirection = Image360.getDefaultLockDirection();
        result.push(img);
      }
    } else if (scanType == 'leica') {


      lines = text.split('\n');
      for (let i = 1; i < lines.length; i++) {
        if (onProgress) onProgress((i / lines.length) * 100);
        let data = lines[i].split(',');
        name = data[0];
        let info = imageInfoList.find((o) => o.name == name);
        if (!info) continue;

        if(data.length<8)
          continue;
        let imageRotation = Number.parseFloat(data[4]);
        let easting = Number.parseFloat(data[1]);
        let northing = Number.parseFloat(data[2]);
        let elevation = Number.parseFloat(data[3]);

        let rotationX = Number.parseFloat(data[5]);
        let rotationY = Number.parseFloat(data[6]);
        let rotationZ = Number.parseFloat(data[7]);

        let img = new Image360();
        img.name = name;
        img.width = info.width;
        img.height = info.height;
        img.createdBy = store.state.username;
        img.createDate = this.dateTimeNow()
        img.scanType = scanType;
        img.rotationX = rotationX;
        img.rotationY = rotationY;
        img.rotationZ = rotationZ;
        img.rotationAngle = imageRotation;
        // img.imageUrl = '../images/360-Panorama/' + name + ".jpg";
        img.isLocked = true;

        //based on discussion with Scott and Andy
        // Diffrance between leica
        // imageRotation -= 90;
        // let rotation = axisAngleToEuler(rotationX, rotationY, rotationZ, imageRotation, 'YZX');

        let zSign = rotationZ < 0 ? -1 : 1;
        let rotation = zSign * (imageRotation - 180);

        img.lockedYaw = this.loadedFileAngleToYaw(rotation);
        img.lockedPitch = 0; //this.getPitch(rotationX,rotationY,rotationZ);
        img.forgeCameraPosition = new THREE.Vector3(easting, northing, elevation);
        img.lockedForgeDirection = Image360.getDefaultLockDirection();
        result.push(img);
      }
    } else if (scanType == 'geoslam') {
      let lines = text.split('\n');
      if (lines.length == 0) return result;
      for (let i = 1; i < lines.length; i++) {
        if (onProgress) onProgress((i / lines.length) * 100);
        let parts = lines[i].split(',');
        let name = parts[0];
        if (name.endsWith('.jpg')) name = name.slice(0, name.length - 4);
        let info = imageInfoList.find((o) => o.name == name);
        if (!info) continue;
        //columns in csv
        //Image, Time, X, Y, Z, Heading, Roll, Pitch
        var imageRotation = Number.parseFloat(parts[5]);
        let yaw = imageRotation;
        if (imageRotation > 0) {
          if (imageRotation < 90) {
            yaw = -90 - imageRotation;
          } else {
            yaw = 180 - (imageRotation - 90);
          }
        } else if (imageRotation < 0) {
          if (imageRotation > -90) {
            yaw = -90 + Math.abs(imageRotation);
          } else {
            yaw = Math.abs(imageRotation) - 90;
          }
        }
        var unixDate = Number.parseFloat(parts[1]);
        var easting = Number.parseFloat(parts[2]);
        var northing = Number.parseFloat(parts[3]);
        var elevation = Number.parseFloat(parts[4]);

        var rotationX = Number.parseFloat(parts[6]);
        var rotationY = Number.parseFloat(parts[7]);
        var rotationZ = 0;
        var img = new Image360();
        img.name = name;
        img.width = info.width;
        img.height = info.height;
        img.createdBy = store.state.username;
        img.createDate = new Date(unixDate * 1000).toGMTString();
        img.scanType = scanType;
        img.rotationX = rotationX;
        img.rotationY = rotationY;
        img.rotationZ = rotationZ;
        img.rotationAngle = imageRotation;
        // img.imageUrl = '../images/360-Panorama/' + name + ".jpg";
        img.isLocked = true;
        img.lockedYaw = yaw;
        img.lockedPitch = 0; //this.getPitch(rotationX,rotationY,rotationZ);
        img.forgeCameraPosition = new THREE.Vector3(easting, northing, elevation);
        img.lockedForgeDirection = Image360.getDefaultLockDirection();
        result.push(img);
      }
    }
    return result;
  }
  getPitch(rotationX, rotationY, rotationZ) {
    var y = Math.abs(rotationZ);
    var x = new THREE.Vector2(rotationX, rotationY).distanceTo(new THREE.Vector2());
    var angle = Math.atan(y / x);
    return 90 - THREE.Math.radToDeg(angle);
  }
  loadedFileAngleToYaw(fileAngle) {
    if (fileAngle <= 180) return fileAngle;
    return -(360 - fileAngle);
  }
  getAllPanoramaImages() {
    var result = [];
    store.state.projects.forEach((project) => {
      project.images.forEach((img) => {
        result.push(img);
      });
    });
    return result;
  }
  getAllShownPanoramaImagesIn3D() {
    var result = [];
    store.state.projects.forEach((project) => {
      project.images.forEach((img) => {
        if (img.isVisibleInViewers && img.isLocked) result.push(img);
      });
    });
    return result;
  }
  activatePersonMode() {
    store.state.viewer.getExtension('Autodesk.BimWalk').activate();
  }
  filterImagesByGlobalSearchText(images) {
    const GLOBAL_SEARCH_TAB_INDEX = 0;

    if (!store.state.isTabShown || store.state.selectedTab !== GLOBAL_SEARCH_TAB_INDEX) {
      return images;
    }
    const searchText = store.getters['GET_GLOBAL_SEARCH_TEXT'];
    if (!searchText) {
      return images;
    }
    return images.filter((img) => store.state.filtered360Imgs.includes(img));
  }
  getTagsClustersAndItems(tags, cameraPosition3d, visibilityRange, range = 10) {
    // if (!store.state.selectedImage) return { items: [], clusters: [] };

    tags = tags.filter(e=>e.point).filter((i) => i.point.distanceTo(cameraPosition3d) < visibilityRange);

    const positionsMap = new Map();
    for (let i = 0; i < tags.length; i++) {
      positionsMap.set(tags[i], tags[i].point);
    }

    let unitScale = store.state.unitScale || 1.0;

    range = range / unitScale;

    const { clusters, separatedItems } = store.state.forgeService.getItemsClusters(
      tags,
      positionsMap,
      cameraPosition3d,
      range,
    );

    return { items: separatedItems, clusters };
  }
  getItemsClusters(items, positionMap, cameraPosition, range = 5) {
    const processed = new Array(items.length).fill(false);
    const clusters = [];
    const separatedItems = [];

    items.sort((a, b) =>
      positionMap.get(a).distanceTo(cameraPosition) -
      positionMap.get(b).distanceTo(cameraPosition)
    );

    // Use a spatial clustering algorithm like DBSCAN
    for (let i = 0; i < items.length; i++) {
      if (processed[i]) continue;

      processed[i] = true;
      const currentItem = items[i];
      const itemPosition = positionMap.get(currentItem);

      // Too close to camera - separate item
      if (itemPosition.distanceTo(cameraPosition) < range * 1.5) {
        separatedItems.push(currentItem);
        continue;
      }

      // Start a new cluster
      const cluster = [currentItem];

      // Find all points within clustering distance
      for (let j = 0; j < items.length; j++) {
        if (processed[j] || i === j) continue;

        const otherItem = items[j];
        const otherPosition = positionMap.get(otherItem);

        // Check if this point should be in the same cluster
        if (itemPosition.distanceTo(otherPosition) < range &&
            otherPosition.distanceTo(cameraPosition) > range) {
          cluster.push(otherItem);
          processed[j] = true;
        }
      }

      // Add as a cluster or single item
      if (cluster.length > 1) {
        clusters.push(cluster);
      } else {
        separatedItems.push(currentItem);
      }
    }

    return { clusters, separatedItems };
  }
  newGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
  dateTimeNow() {
    return new Date().toISOString().slice(0, 19).replace('T', ' ');
  }
  getMainExtension() {
    if (!store.state.viewer) return null;

    let ex = store.state.viewer.getExtension('MainExtension');

    if (ex) return ex;

    store.state.viewer.loadExtension('MainExtension');

    return store.state.viewer.getExtension('MainExtension');
  }
  getMappingExtension3D() {
    return store.state.viewer?.getExtension('Mapping2d_3dExtension');
  }
  getMeasureExtensionInViewer3D() {
    if (!store.state.viewer) return null;
    return store.state.viewer.getExtension('MeasurementExtension');
  }
  getMeasureExtensionInViewer2D() {
    if (!store.state.planViewer) return null;
    return store.state.planViewer.getExtension('MeasurementExtension');
  }
  getCropping3DExtension() {
    if (!store.state.viewer) return null;
    return store.state.viewer.getExtension('Cropping3DExtension');
  }
  getEraserExtension() {
    if (!store.state.viewer) return null;
    return store.state.viewer.getExtension('PointCloudEraserExtension');
  }
  getScaffoldBoxExtension() {
    return store.state.viewer.getExtension('ScaffoldBoxExtension');
  }
  getDrawPointsExtension() {
    if (!store.state.planViewer) return null;
    return store.state.planViewer.getExtension('Plan2DExtension');
  }
  getLabels3DExtension() {
    if (!store.state.viewer) return null;
    return store.state.viewer.getExtension('labels3dExt');
  }
  getLabels2DExtension() {
    if (!store.state.planViewer) return null;
    return store.state.planViewer.getExtension('labels3dExt');
  }
  sortByTag(items) {
    items.sort((a, b) => a.name.localeCompare(b.name));
  }
  sortByName(items) {
    items.sort((a, b) => a.name.localeCompare(b.name, 'en-US', { numeric: 'true' }));
  }
  getLevelContainsPoint(point) {
    for (var i = 0; i < store.state.levels.length; i++) {
      if (store.state.levels[i].containsElevation(point.z)) return store.state.levels[i];
    }
    return null;
  }
  getTaggedItemsInLevel(level) {
    var result = [];

    if (!level) return result;

    for (var e = 0; e < store.state.tags.length; e++) {
      if (store.state.tags[e].level2D == level.name) {
        result.push(store.state.tags[e]);
        continue;
      }
      var center = store.state.tags[e].point;
      if (!center || center.z < level.bottomElevation || center.z > level.topElevation) continue;
      result.push(store.state.tags[e]);
    }
    return result;
  }
  getEquipmentsInLevel(level) {
    var result = [];

    var allEquipments = store.state.tags ?? [];

    if (!level) return result;

    for (var i = 0; i < allEquipments.length; i++) {
      var e = allEquipments[i];

      var center = e.point;

      if (!center) continue;

      if (e.level2D == level.name) {
        result.push(e);
        continue;
      }

      if (center.z < level.bottomElevation || center.z > level.topElevation) continue;

      result.push(e);
    }

    return result;
  }
  getAutoEquipmentsInLevel(level) {
    var result = [];

    if (!level) return result;

    var tags = store.getters['GET_ALL_EXISTING_AUTOMATIC_TAGS'];

    for (var i = 0; i < tags.length; i++) {
      var e = tags[i];

      var center = e.point;

      if (!center) continue;

      if (center.z < level.bottomElevation || center.z > level.topElevation) continue;

      result.push(e);
    }

    return result;
  }
  getManualStructuralTagsInLevel(level) {
    let result = [];

    if (!level) return result;

    let tags = store.getters.GET_MANUAL_STRUCTURAL_TAGS;

    for (let i = 0; i < tags.length; i++) {
      let center = tags[i].point;
      if (!center) continue;
      if (center.z < level.bottomElevation || center.z > level.topElevation) continue;
      result.push(tags[i]);
    }

    return result;
  }
  getStructuralTagsInLevel(level) {
    let result = [];
    if (!level) return result;
    let tags = store.getters.GET_ALL_EXISTING_STRUCTURAL_TAGS;
    for (let i = 0; i < tags.length; i++) {
      if (tags[i].level2D == level.name) {
        result.push(tags[i]);
        continue;
      }
      let center = tags[i].point;
      if (!center) continue;
      if (center.z < level.bottomElevation || center.z > level.topElevation) continue;
      result.push(tags[i]);
    }
    return result;
  }
  getManualPipelineTagsInLevel(level) {
    let result = [];

    if (!level) return result;

    let tags = store.getters.GET_MANUAL_PIPELINES_TAGS;

    for (let i = 0; i < tags.length; i++) {

      if (tags[i].level2D == level.name) {
        result.push(tags[i]);
        continue;
      }
      let center = tags[i].point;
      if (!center) continue;
      if (center.z < level.bottomElevation || center.z > level.topElevation) continue;
      result.push(tags[i]);
    }

    return result;
  }
  getAnomaliesInLevel(level) {
    let result = [];
    if (!level) return result;
    let anomalies = store.getters.GET_ALL_EXISTING_ANOMALIES_TAGS;
    for (let i = 0; i < anomalies.length; i++) {
      if (anomalies[i].level2D == level.name) {
        result.push(anomalies[i]);
        continue;
      }
      let center = anomalies[i].point;
      if (!center) continue;
      if (center.z < level.bottomElevation || center.z > level.topElevation) continue;
      result.push(anomalies[i]);
    }
    return result;
  }
  getAvaInspectTagsInLevel(level) {
    let result = [];
    if (!level) return result;
    let avaInspectTags = store.getters.GET_AVA_INSPECT_TAGS;
    for (let i = 0; i < avaInspectTags.length; i++) {
      if (avaInspectTags[i].level2D == level.name) {
        result.push(avaInspectTags[i]);
        continue;
      }
      let center = avaInspectTags[i].point;
      if (!center) continue;
      if (center.z < level.bottomElevation || center.z > level.topElevation) continue;
      result.push(avaInspectTags[i]);
    }
    return result;
  }
  getPipelineTagsInLevel(level) {
    let result = [];

    if (!level) return result;

    let tags = store.getters.GET_ALL_EXISTING_PIPELINES_TAGS;
    for (let i = 0; i < tags.length; i++) {
      let center = tags[i].point;
      if (!center) continue;
      if (center.z < level.bottomElevation || center.z > level.topElevation) continue;
      result.push(tags[i]);
    }
    return result;
  }
  getAnnotationsInLevel(level) {
    if (!level) return [];

    var result = [];
    for (var i = 0; i < store.state.annotations.length; i++) {
      if (store.state.annotations[i].level2D == level.name) {
        result.push(store.state.annotations[i]);
        continue;
      }

      var center = store.state.annotations[i].point;
      if (!center) continue;
      if (center.z < level.bottomElevation || center.z > level.topElevation) continue;
      result.push(store.state.annotations[i]);
    }
    return result;
  }
  getInspectionsInLevel(level, inspections) {
    if (!inspections) inspections = store.state.inspections;

    if (!level) return [];

    var result = [];
    for (var i = 0; i < inspections.length; i++) {
      var center = inspections[i].point;

      if (!center) continue;

      if (inspections[i].level2D == level.name) {
        result.push(inspections[i]);
        continue;
      }

      if (center.z < level.bottomElevation || center.z > level.topElevation) continue;
      result.push(inspections[i]);
    }
    return result;
  }
  getScaffoldsInLevel(level) {
    var result = [];
    if (!level) return result;
    for (var i = 0; i < store.state.scaffolds.length; i++) {
      var center = store.state.scaffolds[i].position;
      if (!center) continue;
      if (center.z < level.bottomElevation || center.z > level.topElevation) continue;
      result.push(store.state.scaffolds[i]);
    }
    return result;
  }
  getTagsInfoData(tagsInfo) {
    let result = [];
    let ids = [];

    var equipmentIds = tagsInfo.filter((o) => o.type == 'tag');
    var annotationIds = tagsInfo.filter((o) => o.type == 'annotation');
    var inspectionIds = tagsInfo.filter((o) => o.type == 'inspection');
    var scaffoldIds = tagsInfo.filter(
      (o) => o.type == 'permit' || o.type == 'scaffold' || o.type == 'container',
    );

    result = store.state.tags.reduce((acc, item) => {
      let e = equipmentIds.find((i) => i.id == item.id);
      if (e && item.children?.length) {
        ids.push(...item.children.map((i) => i.dbId));
        e.children = item.children.map((c) => c.dbId);
        acc.push(e);
      }
      return acc;
    }, result);

    result = store.state.TAGS.allExistingAutomaticDbids.reduce((acc, item) => {
      let e = equipmentIds.find((i) => i.id == item.id);
      if (e) {
        const childDbIds = item.children?.map(c => c.dbId) || [];
        ids.push(...childDbIds);
        e.children = childDbIds;
        acc.push(e);
      }
      return acc;
    }, result);

    result = store.state.annotations.reduce((acc, item) => {
      let e = annotationIds.find((i) => i.id == item.id);
      if (e && item.children?.length) {
        ids.push(...item.children.map((i) => i.dbId));
        e.children = item.children.map((c) => c.dbId);
        acc.push(e);
      }
      return acc;
    }, result);

    result = store.state.inspections.reduce((acc, item) => {
      let e = inspectionIds.find((i) => i.id == item.id);
      if (e && item.children?.length) {
        ids.push(...item.children.map((i) => i.dbId));
        e.children = item.children.map((c) => c.dbId);
        acc.push(e);
      }
      return acc;
    }, result);

    result = store.state.scaffolds.reduce((acc, item) => {
      let e = scaffoldIds.find((i) => i.id == item.id);
      if (e && item.children?.length) {
        ids.push(...item.children.map((i) => i.dbId));
        e.children = item.children.map((c) => c.dbId);
        acc.push(e);
      }
      return acc;
    }, result);

    return { tagsInfo: result, dbIds: ids };
  }
  showTagsByIdsWithColorAndAnimation(tagsInfo, options) {
    if (!store.state.viewer) return;

    let result = store.state.forgeService.getTagsInfoData(tagsInfo);

    store.commit('SET_THEMED_DB_IDS', result.dbIds);

    result.tagsInfo.forEach((item) => {
      if (item.color && item.children) {
        let color = new THREE.Color(item.color);
        color = new THREE.Vector4(color.r, color.g, color.b, 1);
        let dbIds = item.children;
        setPermeativeElementsTheme(dbIds, color);
      }
    });

    store.state.forgeService.getMainExtension().showDbIdsWithAnimation(result.dbIds, options);
  }
  showTagsByIds(tagsInfo) {
    if (!store.state.viewer) return;

    var equipmentIds = tagsInfo.filter((o) => o.type == 'tag').map((o) => parseInt(o.id));
    var annotationId = tagsInfo.find((o) => o.type == 'annotation')?.id;
    var inspectionId = tagsInfo.find((o) => o.type == 'inspection')?.id;
    var scaffoldId = tagsInfo.find(
      (o) => o.type == 'permit' || o.type == 'scaffold' || o.type == 'container',
    )?.id;
    var tags = store.state.tags.filter((o) => equipmentIds.includes(o.id));
    var automaticTags = store.state.TAGS.allExistingAutomaticDbids.filter((o) =>
      equipmentIds.includes(o.id),
    );

    if (tags.length > 0 || automaticTags.length > 0) {
      var normalDbIds = tags
        .filter((o) => o.children)
        .flatMap((o) => o.children.map((o) => o.dbId));
      let autoDbIds = automaticTags.flatMap((t) => t.children?.map(c => c.dbId) || []);
      this.getMainExtension().isolateDbIds(normalDbIds.concat(autoDbIds));
      return;
    }

    if (annotationId) {
      annotationId = parseInt(annotationId);
      let annotation = store.state.annotations.find((o) => annotationId == o.id);
      if (annotation) {
        this.zoomToAnnotation(annotation, true);
        return;
      }
    }

    if (inspectionId) {
      inspectionId = parseInt(inspectionId);
      let inspection = store.state.inspections.find((o) => inspectionId == o.id);
      if (inspection) {
        this.zoomToAnnotation(inspection, true);
        return;
      } else {
        let amisInspection = store.state.TAGS.allExistingAMISDbids.find(
          (t) => t.id == inspectionId,
        );

        if (amisInspection && amisInspection.children) {
          let dbIds = amisInspection.children.map((o) => o.dbId);
          this.getMainExtension().isolateDbIds(dbIds);
          return;
        }
      }
    }

    if (scaffoldId) {
      scaffoldId = parseInt(scaffoldId);
      var scaffold = store.state.scaffolds.find((o) => scaffoldId == o.id);
      if (scaffold) {
        this.zoomToTagOrScaffold(scaffold, true);
      }
    }
  }
  zoomToItem(item) {
    this.getLabels3DExtension()?.createHighlightingTags([item]);

    let fitToView = !store.state.selectedImage;

    if (item instanceof ForgeAnnotation || item instanceof ForgeInspection)
      this.zoomToAnnotation(item, fitToView);
    else if (item instanceof ForgeScaffold) this.zoomToTagOrScaffold(item, fitToView);
    else this.isolateTag(item, fitToView);
  }
  zoomToPoint2D(point) {
    let mapping = store.state.selectedLevel.mappingViewersPointsInfo;

    if (!mapping || !mapping.isReady()) {
      Vue.prototype.$dialog.notify.warning('2D is not ready to zoom, Please map 2D first.', {
        position: 'top-right',
        timeout: 3000,
      });
      return;
    }

    const unit = 5;

    let min = new THREE.Vector3(point.x - unit, point.y - unit, 0);
    let max = new THREE.Vector3(point.x + unit, point.y + unit, 0);

    min = store.state.selectedLevel.mappingViewersPointsInfo._3dTo2d(min);
    max = store.state.selectedLevel.mappingViewersPointsInfo._3dTo2d(max);
    var bubbleBox = new THREE.Box3(min, max);
    zoomToFitBox2D(store.state.planViewer, bubbleBox);
  }
  zoomToPoints2D(points, callback) {
    if (!store.state.planViewer) return;

    let minX = Math.min(...points.map((o) => o.x));
    let minY = Math.min(...points.map((o) => o.y));
    let maxX = Math.max(...points.map((o) => o.x));
    let maxY = Math.max(...points.map((o) => o.y));

    let min = new THREE.Vector3(minX - 1, minY - 1, 0);
    let max = new THREE.Vector3(maxX + 1, maxY + 1, 0);

    min = store.state.selectedLevel.mappingViewersPointsInfo._3dTo2d(min);
    max = store.state.selectedLevel.mappingViewersPointsInfo._3dTo2d(max);
    var bubbleBox = new THREE.Box3(min, max);
    zoomToFitBox2D(store.state.planViewer, bubbleBox);
  }
  isolateTag(tag, fitToView = true) {
    if (!store.state.viewer) {
      Vue.prototype.$dialog.notify.warning('Please open 3D viewer first.', {
        position: 'top-right',
        timeout: 3000,
      });
      return;
    }

    var dbids = tag.getAllDbIds();
    //send model if tag is model tag to isolate
    let model = null;
    if (tag.tagHarvesterId && tag.children?.length > 0 && tag.children[0].urn)
      model = store.state.viewer.getAllModels().find((o) => o.getSeedUrn() == tag.children[0].urn);

    fitToView
      ? this.getMainExtension()?.isolateDbIds(dbids, model)
      : this.getMainExtension()?.isolateDbIdsWithoutFitView(dbids, model);
  }
  addToIsolate(tag) {
    if (!store.state.viewer) {
      Vue.prototype.$dialog.notify.warning('Please open 3D viewer first.', {
        position: 'top-right',
        timeout: 3000,
      });
      return;
    }

    var dbIds = tag.getAllDbIds();
    this.getMainExtension()?.addToIsolate(dbIds);
  }
  getPointCloudContainsImage(image) {
    let scan = store.state.pointClouds.find(o => o.name === image.name);

    if (scan) return scan;

    let project = store.state.projects.find((o) => o.images.find((i) => i.id == image.id));

    if (project) {
      let projectPointCloud = store.state.pointClouds.find((o) => o.name == project.name);

      if (projectPointCloud) return projectPointCloud;
    }

    let level = store.state.levels.find((level) => level.isImageInsideLevel(image));

    if (level) {
      let levelPointCloud = store.state.pointClouds.find((o) => o.name == level.name);

      if (levelPointCloud) return levelPointCloud;
    }

    return null;
  }
  toggleShowingPointCloudIn3D(model) {
    return store.state.forgeService.setShowingPointCloudIn3D(model, !model.isShown);
  }
  setShowingPointCloudIn3D(model, value) {
    if (store.state.viewer) {
      model.isShown = value;

      if (model.isShown) {
        if (store.state.pointClouds.every((o) => o.isShown))
          store.state.userSettings.displaySettings.pointCloudDisplay.showPointClouds = true;
        this.linkViewers()
      } else {
        if (store.state.pointClouds.every((o) => !o.isShown))
          store.state.userSettings.displaySettings.pointCloudDisplay.showPointClouds = false;
      }

      return store.state.forgeService
        .getMainExtension()
        .showPointCloud(model.name, model.isShown, model.url);
    }
  }
  refreshPointClouds() {
    if (!store.state.viewer) return;

    let openedPointClouds = store.state.pointClouds.filter((o) => o.isShown).map((o) => o.name);
    const ext = this.getMainExtension();
    openedPointClouds.forEach((name) => {
      ext.refreshPointCloudsByName(name);
    });
  }
  resetThemingColors() {
    const viewer = store.state.viewer;

    let tree = viewer?.model?.getInstanceTree();

    if (!tree) {
      return;
    }

    let themedDbIds = store.getters['GET_THEMED_DB_IDS'];

    if (themedDbIds?.length) clearThemingColors(viewer);

  }
  cacheFragsPerMaterials() {
    if (!store.state.viewer?.model) return;

    if (this.fragIdPerMaterial) return;
    this.fragIdPerMaterial = {};
    const tree = store.state.viewer.model.getInstanceTree();
    const frags = store.state.viewer.model.getFragmentList();
    for (let i = 0; i < this.allForgeElements.length; i++) {
      const dbid = this.allForgeElements[i].dbId;
      tree.enumNodeFragments(
        dbid,
        (fragid) => {
          this.fragIdPerMaterial[fragid] = frags.getMaterial(fragid);
        },
        true,
      );
    }
  }
  resetObjectsMaterials() {
    if (!this.fragIdPerMaterial) return;

    const tree = store.state.viewer.model.getInstanceTree();

    if (!tree) return;

    const frags = store.state.viewer.model.getFragmentList();

    for (let i = 0; i < this.allForgeElements.length; i++) {
      const dbid = this.allForgeElements[i].dbId;
      tree.enumNodeFragments(
        dbid,
        (fragid) => {
          var mat = this.fragIdPerMaterial[fragid];
          if (mat) {
            frags.setMaterial(fragid, mat);
            store.state.viewer.model.unconsolidate();
          }
        },
        true,
      );
    }
  }
  updateMaterialToGray() {
    this.grayMaterial = createGrayMaterial(store.state.viewer, 'MODS_GrayMaterial');
    this.cacheFragsPerMaterials();
    var toggleOn = store.state.isGreyModel ?? false;
    const tree = store.state.viewer.model.getInstanceTree();
    const frags = store.state.viewer.model.getFragmentList();
    for (let i = 0; i < this.allForgeElements.length; i++) {
      const dbid = this.allForgeElements[i].dbId;
      tree.enumNodeFragments(
        dbid,
        (fragid) => {
          var mat = toggleOn ? this.grayMaterial : this.fragIdPerMaterial[fragid];
          if (mat) {
            frags.setMaterial(fragid, mat);
            store.state.viewer.model.unconsolidate();
          }
        },
        true,
      );
    }
  }
  updateModelGray() {
    if (store.state.isGreyModel) {
      if (!this.ThemingStack.includes(0)) this.ThemingStack.push(0);
      store.state.forgeService.updateMaterialToGray();
    } else {
      if (this.ThemingStack.includes(0))
        this.ThemingStack = this.ThemingStack.filter((o) => o !== 0);
      store.state.forgeService.resetObjectsMaterials();
    }

    store.state.forgeService.updateGhosting();

    store.state.viewer.impl.invalidate(true, true, true);
  }
  updateGhosting(fitViewer = true) {
    // Prepare data.
    store.state.forgeService.cacheFragsPerMaterials();
    const mainExt = this.getMainExtension();
    if (!mainExt || !store.state.viewer?.model) return;

    const grayModel = store.state.isGreyModel ?? false;
    const toggleOn = store.state.isGhostingOn;
    const isGhostingWireframe = store.state.isGhostingWireframe;
    const isolatedDbids = mainExt.isolatedDbids ?? [];
    const tree = store.state.viewer.model.getInstanceTree();
    const frags = store.state.viewer.model.getFragmentList();
    const isolatedDbidsPrimitive = isolatedDbids.flatMap((o) => getNodeChildDbidsForNode(o, tree));

    // Check ghosting:
    if (!toggleOn) {
      // If ghosting is off, then isolate the selected elements and reset the theming colors
      store.state.viewer.isolate(isolatedDbids, store.state.viewer.model);

      // There is a previous ghosting mode, so we need to reset the materials
      const modeIsGhosted = this.ThemingStack.some((o) => o);
      if (modeIsGhosted) {
        if (isGhostingWireframe) {
          store.state.viewer.setGhosting(false);
        } else {
          this.grayMaterial ??= createGrayMaterial(store.state.viewer, 'MODS_GrayMaterial');
          this.updateFragmentMaterials(
            store.state.viewer,
            tree,
            frags,
            isolatedDbidsPrimitive,
            () => grayModel,
            this.grayMaterial,
          );
        }

        this.ThemingStack = this.ThemingStack.filter((o) => !o); // Remove all ghosting modes from the stack
      }
    } else {
      // If ghosting is on
      if (isGhostingWireframe) {
        store.state.viewer.setGhosting(false);

        // If wireframe is on, then isolate the selected elements and set the ghosting to true
        this.isolateAndGhost(store.state.viewer, isolatedDbids, fitViewer, toggleOn);

        if (!this.ThemingStack.includes(1)) {
          this.ThemingStack = this.ThemingStack.filter((o) => o !== 2);
          this.ThemingStack.push(1);
        }
      } else {
        // If wireframe is off, show all elements and set the correct material to elements
        store.state.viewer.setGhosting(false);

        store.state.viewer.isolate([]);

        this.ghostingMaterial = createMaterial(
          store.state.viewer,
          'MODS_GhostingMaterials',
          store.state.ghostingColor,
          true,
        );

        this.updateFragmentMaterials(
          store.state.viewer,
          tree,
          frags,
          this.allForgeElements.map((d) => d.dbId),
          (dbId) => !isolatedDbidsPrimitive.includes(dbId),
          this.ghostingMaterial,
        );

        if (grayModel) {
          this.updateFragmentMaterials(
            store.state.viewer,
            tree,
            frags,
            isolatedDbidsPrimitive,
            () => grayModel,
            this.grayMaterial,
          );
        }

        if (!this.ThemingStack.includes(2)) {
          this.ThemingStack = this.ThemingStack.filter((o) => o !== 1);
          this.ThemingStack.push(2);
        }
      }
    }

    this.updateThemingColors(store.state.viewer, this.dbIdPerThemingColor);

    store.state.viewer.impl.invalidate(true, true, true);
  }

  isolateAndGhost(viewer, isolatedDbids, fitViewer, toggleOn) {
    isolateForge(viewer, viewer.model, isolatedDbids, fitViewer);
    viewer.setGhosting(toggleOn);
  }

  updateFragmentMaterials(viewer, tree, frags, dbids, condition, conditionalMaterial) {
    for (const dbid of dbids) {
      tree.enumNodeFragments(
        dbid,
        (fragid) => {
          const mat = condition(dbid, fragid)
            ? conditionalMaterial
            : this.fragIdPerMaterial[fragid];
          if (mat) {
            frags.setMaterial(fragid, mat);
            viewer.model.unconsolidate();
          }
        },
        true,
      );
    }
  }

  updateThemingColors(viewer, themingColors) {
    for (const [key, value] of Object.entries(themingColors)) {
      if (value) {
        viewer.setThemingColor(key, value, null, true);
      }
    }
  }

  cameraZoomOutByScaler(scaler) {
    var nav = store.state.viewer.navigation;

    var pos = nav.getPosition();

    var target = nav.getTarget();

    var viewDirection = new THREE.Vector3();

    viewDirection.subVectors(pos, target).normalize();

    viewDirection.multiplyScalar(scaler);

    pos.add(viewDirection);

    nav.setPosition(pos);
  }
  /**
   * Resolves the 360 scan an already-open panorama pane should be synced to.
   *
   * The scan the tag was positioned from wins, then the scan it was created from
   * (findTagSyncImage); when neither resolves in this facility (stale, foreign, deleted, or a
   * scan still processing) we fall through to the nearest scan rather than returning nothing —
   * callers hand the result straight to `launchPanoViewer`. Synchronous by design: this is the
   * in-app sync path, where `store.state.projects` is authoritative for the current facility.
   * The API refetch rung lives only on the deep-link path (`openNearest360ToTag`).
   *
   * @param {ForgeBaseTag} element - Tag whose 360 scan is wanted.
   * @returns {Image360|null} Scan to open, or null when the facility has none.
   */
  getTargetImageIfAvailable(element) {
    let closestImage = null;

    if (this.panoramaViewer) {
      closestImage = findTagSyncImage(
        element,
        (store.state.projects || []).flatMap((o) => o.images || []),
      );

      if (!closestImage && (element.positionImage360Id || element.linked360ImageInfo?.imageId)) {
        debugLog(
          '[Sync360] Tag scan unresolvable in this facility, falling through to nearest:',
          element.positionImage360Id || element.linked360ImageInfo.imageId,
        );
      }

      if (!closestImage) {
        closestImage = this.getClosestImageToPoint(element.getPointInView());
      }
    }

    return closestImage;
  }
  open360CorresponsdindPointClouds(imageName) {
    const vuexStore = window.vuexStore;
    const forgeService = vuexStore.state.forgeService;

    let image = vuexStore.state.projects
      .flatMap((o) => o.images)
      .find((img) => img.name == imageName);

    if (!image) {
      debugError(`Image with name ${imageName} not found.`);
      return;
    }

    let correspondingPC = vuexStore.getters['getPointClouds'].find((p) => p.name == imageName);

    if (!correspondingPC) {
      let level = vuexStore.state.levels.find((level) =>
        level.isImageInsideLevel(image),
      );
      if (level) {
        correspondingPC = vuexStore.getters['getPointClouds'].find((p) => p.name == level.name);
      }
    }

    if (!correspondingPC) {
      let project = vuexStore.state.projects.find((p) =>
        p.images.some((i) => i.id == image.id),
      );
      correspondingPC = vuexStore.getters['getPointClouds'].find(
        (p) => p.name == project.name,
      );
    }

    if (!correspondingPC) {
      return false;
    }

    forgeService.setShowingPointCloudIn3D(correspondingPC, true);
  }
  /**
   *  open specific tag in 3d viewer if not opened open closest 360 image and open point cloud around the tag
   * @param {id,name} acceptas tag name or id
   * @returns
   */
  async openTagIn3dAnd360(data) {
    let { name, id} = data;

    const vuexStore = window.vuexStore;

    if (!vuexStore) {
      debugError('Vuex store not found.');
      throw new Error('Vuex store not found.');
    }

    if (!name && !id) {
      debugError('Invalid data provided. Name or ID is required.');
      throw new Error('Invalid data provided. Name or ID is required.');
    }

    const mainApp = vuexStore.state.mainApp;
    const pageView3d = vuexStore.getters['GET_PAGE_VIEW_3D'];
    const forgeService = vuexStore.state.forgeService;

    function getViewPage3D() {
      return mainApp.$children
        .filter((o) => o.$vnode.tag.includes('PageView'))
        .find((o) => o.view_type == '3d');
    }

    let tag = await vuexStore.dispatch('GET_BASE_TAG_BY_ID_NAME', {name: name, id: id});

    mainApp.openViewPageWithType('3d');
    setTimeout(() => {
      if (pageView3d) {
        forgeService.zoomInAllAvailableViewers(tag, true);
      } else {
        forgeService.tagToZoomToIn3D = tag;
      }
    }, 100);

    const viewer = vuexStore.state.viewer;

    let point = tag.point ?? tag.position;

    if (!point) {
      debugError('No point found in the tag data.');
      return;
    }

    function cropping() {
      let cropping3DExtension = forgeService.getCropping3DExtension();
      let isUSUnit = forgeService.isUSUnit();

      const cropValue = 2;

      let x = isUSUnit ? cropValue * 0.3048 : cropValue;
      let y = isUSUnit ? cropValue * 0.3048 : cropValue;
      let z = isUSUnit ? cropValue * 0.3048 : cropValue;

      cropping3DExtension.cropBox = getBoxAroundPoint(tag.getPointInView(), x, y, z);
      cropping3DExtension.toggleCropbox(true);
    }

    forgeService.openNearest360ToTag(tag, (closestImage) => {
      if (!!tag.children?.length && getViewPage3D() && !!viewer && !!viewer.model) {
        forgeService.isolateTag(tag, false);
      }

      forgeService.zoomToPoint3dViewer(tag.getPointInView());
      forgeService.zoomToPointIn360Viewer(point, () => {
        setTimeout(() => {
          forgeService.linkViewers();
          forgeService.create360HighlightHotspot(tag);
          forgeService.getLabels3DExtension()?.createHighlightingTags([tag]);
        }, 100);
      });

      if (pageView3d) {
        forgeService.open360CorresponsdindPointClouds(closestImage.name);
        cropping();
      } else {
        forgeService.on3dModelLoadedCallback = () => {
          forgeService.open360CorresponsdindPointClouds(closestImage.name);
          cropping();
        }
      }
    });

    return tag;
  }
  ZoomToDbIdsIn3D(dbIds) {
    if (!store.state.viewer) {
      Vue.prototype.$dialog.notify.warning('Please open 3D viewer first.', {
        position: 'top-right',
        timeout: 3000,
      });
      return;
    }

    if (dbIds.length == 0) {
      Vue.prototype.$dialog.notify.warning('No inspection to zoom in.');

      return;
    }

    let bbox = getBBBox(dbIds);

    this.getMainExtension()?.isolateDbIdsWithoutFitView(dbIds);

    this.zoomToPoint3dViewer(bbox);
  }
  /**
   * Zooms in all available viewers to the specified element.
   *
   * @param {Object} element - The element to zoom in to.
   * @param {Boolean} isolate - Whether or not to isolate the element in the viewer.
   */
  async zoomInAllAvailableViewers(element, isolate, options = {}) {
    const isRequestCurrent = () => !options.shouldExecute || options.shouldExecute();
    debugLog(`🔍 Zooming in to element: ${element.name}`);
    // Check if the element is null.
    if (!element) {
      debugLog('❌ element is null.');
      return;
    }
    if (!isRequestCurrent()) return { status: 'stale', reason: 'superseded-intent' };

    isolate = isolate || store.state.isGhostingOn;

    // Get the point and target to zoom in on.
    let point = element instanceof ForgeScaffold ? element.position : element.point; // Normal point.
    let target = element.getPointInView(); // Mapped point to 3d.
    target = new THREE.Vector3(target.x, target.y, target.z);

    // Zoom in to the point in the 2D viewer if it exists.
    if (getViewPage2d() && store.state.planViewer) {
      store.dispatch('zoomToPointIn2D', {
        point3d: point,
        levelName: element.level2D,
        callback: () => {
          if (!isRequestCurrent()) return;
          this.zoomToPoint2D(point);
          store.state.forgeService?.getLabels2DExtension()?.createHighlightingTags([element]);
        },
      });
    }

    // Get the closest image if the panorama viewer exists.
    let closestImage = this.panoramaViewer
      ? store.state.forgeService.getTargetImageIfAvailable(element)
      : null;

    // Check if the closest image is already opened.
    let isAlreadyOpened = closestImage != null && store.state.selectedImage == closestImage;

    let bbox = null;

    let viewerPage3dAvailable = !!getViewPage3D() && !!store.state.viewer;
    let selectedArea = store.getters['AREAS/GET_SELECTED_AREA'];
    // Plan C: an anomaly's 3D scene is owned by the one spatial-focus composable, which also
    // frames it. The generic camera moves at the end of this method must therefore stand down for
    // that element kind rather than fight the fit the composable just performed.
    const anomalyFocus = viewerPage3dAvailable && isolate && element instanceof ForgeAnomaly;
    let spatialFocusOwnsCamera = false;

    if (viewerPage3dAvailable && selectedArea) {
      const isReady = await this.checkIfAreaIsReady(target, {
        requestOwner: options.requestOwner,
        shouldExecute: options.shouldExecute,
      });
      if (!isRequestCurrent()) return { status: 'stale', reason: 'superseded-intent' };

      if (!isReady) {
        debugLog('❌ The selected area is not ready to zoom in.');
        return;
      }
    }

    // Create highlighting tags for the element in the 3D viewer.
    this.getLabels3DExtension()?.createHighlightingTags([element]);

    // An Anomaly is a point of interest on a larger component. Which component greys, which exact
    // elements colour, how the camera frames them and how they pulse is ONE decision, and it is
    // the composable's — resolved server-side from the stable subject, never from this client's
    // own Component-Ref walk. This is the single anomaly entry point: every generic caller of
    // `zoomInAllAvailableViewers` funnels through here, so no route can reach the children-based
    // branch below with a ForgeAnomaly.
    if (anomalyFocus) {
      const result = await useSpatialFocus().show({
        owner: { widgetId: ANOMALY_FOCUS_OWNER_ID, title: element.name || 'Anomaly' },
        scope: { kind: 'entities', entities: [{ kind: 'anomalyTag', id: element.id }] },
        encoding: null,
        viewer: store.state.viewer,
        shouldExecute: options.shouldExecute,
        // Swap straight from the previous focus to this anomaly, like a plain tag-card isolate:
        // the whole model never flashes in between, and the user's ghosting is kept.
        swapInPlace: true,
      });
      if (!isRequestCurrent()) return { status: 'stale', reason: 'superseded-intent' };

      if (result.status === 'rendered') {
        spatialFocusOwnsCamera = true;
      } else if (result.status === 'empty' || result.status === 'unrenderable') {
        Vue.prototype.$dialog.notify.warning(
          'This anomaly has no linked 3D elements to isolate.',
        );
      } else if (result.status === 'failed') {
        debugWarn('[AnomalyFocus] spatial focus refused', { anomalyId: element.id, error: result.error });
        Vue.prototype.$dialog.notify.error(
          result.error?.message || 'Unable to isolate this anomaly.',
        );
      }
    }
    // Isolate the element in the viewer if it has children and isolate is true.
    else if (viewerPage3dAvailable && element.children?.length) {
      var dbids = element.children.map((o) => o.dbId);
      bbox = getBBBox(dbids);

      if (isolate) {
        this.getMainExtension()?.isolateDbIdsWithoutFitView(dbids);
      } else {
        this.getMainExtension()?.showDbIds(dbids);
      }
    }

    // Scaffolds hold no dbIds, so the isolate above never fires for them. Crop the
    // model around the scaffold's own box instead — the same crop machinery the
    // element-carrying tag types drive from their panels.
    if (viewerPage3dAvailable && isolate && element instanceof ForgeScaffold) {
      this.applyScaffoldCropBox(element);
    }

    // Show CML markers when isolating an inspection with CML data
    if (isolate && element.cmlRecords?.length) {
      this.showCmlPointMarkers(element);
    }

    // Zoom in to the 3D and 360 viewer if they both exist.
    if (viewerPage3dAvailable && this.panoramaViewer) {
      if (!isRequestCurrent()) return { status: 'stale', reason: 'superseded-intent' };
      if (isAlreadyOpened) {
        if (!spatialFocusOwnsCamera) this.zoomToPoint3dViewer(target);
        this.zoomToPointIn360Viewer(point, () => {
          if (!isRequestCurrent()) return;
          setTimeout(() => {
            if (!isRequestCurrent()) return;
            this.create360HighlightHotspot(element);
            this.linkViewers();
          }, 100);
        });
      } else {
        // Guarded: with no scan to open, registering the load callback would leave it
        // in the store to fire on some later, unrelated panorama load.
        if (closestImage) {
          const onLoaded = () => {
            if (!isRequestCurrent()) return false;
            this.create360HighlightHotspot(element);
            this.zoomToPointIn360Viewer(point);
            return true;
          };
          onLoaded.tagSpatialRequestOwner = options.requestOwner;
          store.commit('setLoad360ViewerCallback', onLoaded);
          this.launchPanoViewer(closestImage);
        } else {
          debugLog('[Sync360] No scan available in this facility, 360 pane left as is:', element.name);
        }

        if (!spatialFocusOwnsCamera) this.zoomToPoint3dViewer(target);
      }

      this.linkViewers(true);
    }
    // Zoom in to the 3D viewer if it exists.
    else if (viewerPage3dAvailable) {
      if (!isRequestCurrent()) return { status: 'stale', reason: 'superseded-intent' };
      if (!spatialFocusOwnsCamera) this.zoomToPoint3dViewer(bbox ?? target);
    }
    // Zoom in to the 360 viewer if it exists.
    else if (this.panoramaViewer) {
      if (!isRequestCurrent()) return { status: 'stale', reason: 'superseded-intent' };
      if (isAlreadyOpened) {
        this.create360HighlightHotspot(element);
        this.zoomToPointIn360Viewer(point);
      } else if (closestImage) {
        const onLoaded = () => {
          if (!isRequestCurrent()) return false;
          this.create360HighlightHotspot(element);
          this.zoomToPointIn360Viewer(point);
          return true;
        };
        onLoaded.tagSpatialRequestOwner = options.requestOwner;
        store.commit('setLoad360ViewerCallback', onLoaded);
        this.launchPanoViewer(closestImage);
      } else {
        debugLog('[Sync360] No scan available in this facility, 360 pane left as is:', element.name);
      }
    }
  }
  /**
   * Crops the 3D viewer around a scaffold that is being isolated.
   *
   * A crop volume the user saved on the scaffold wins, exactly like the "Load Saved
   * Crop" action on the element-carrying tag panels; otherwise the box is derived
   * from the scaffold's own dimensions.
   *
   * @param {ForgeScaffold} scaffold - Scaffold being isolated.
   * @returns {Boolean} True when a crop box was applied.
   */
  applyScaffoldCropBox(scaffold) {
    const cropExtension = this.getCropping3DExtension();

    if (!cropExtension || !store.state.viewer?.model) {
      debugLog('[ScaffoldCrop] Crop extension or model unavailable, skipping:', scaffold.name);
      return false;
    }

    if (scaffold.cropVolumeJson && cropExtension.loadCropVolumeForTag(scaffold)) {
      debugLog('[ScaffoldCrop] Applied the crop volume saved on the scaffold:', scaffold.name);
      store.commit('SET_IS_CROPPING_3D', true);
      return true;
    }

    const cropBox = this.buildScaffoldCropBox(scaffold, cropExtension);

    if (!cropBox) return false;

    cropExtension.setCropBox(cropBox);
    cropExtension.toggleCropbox(true);
    cropExtension.setCropBoxControls(cropBox);
    store.commit('SET_IS_CROPPING_3D', true);

    debugLog('[ScaffoldCrop] Applied crop box for:', scaffold.name, cropBox.min, cropBox.max);

    return true;
  }
  /**
   * Builds the crop box for a scaffold: its own box plus a margin, or the crop
   * extension's default 1 m cube when the stored dimensions are degenerate.
   *
   * `getBox()` already returns VIEWER space (max x scale run through
   * `worldToView3dLength`) — the very space the crop pipeline persists and consumes —
   * so it is passed through without any further unit conversion.
   *
   * @param {ForgeScaffold} scaffold - Scaffold being isolated.
   * @param {Object} cropExtension - Cropping3DExtension instance supplying the default box.
   * @returns {THREE.Box3|null} Crop box in viewer space, or null when none is derivable.
   */
  buildScaffoldCropBox(scaffold, cropExtension) {
    const box = scaffold.getBox();
    const extents = box
      ? [box.max.x - box.min.x, box.max.y - box.min.y, box.max.z - box.min.z]
      : [];
    const hasRealDimensions =
      extents.length > 0 && extents.every((extent) => Number.isFinite(extent) && extent > 0);

    if (hasRealDimensions) {
      debugLog('[ScaffoldCrop] Scaffold box extents in viewer units:', extents);
      return getBoxOffset(box, this.worldToView3dLength(SCAFFOLD_CROP_MARGIN_M));
    }

    debugLog('[ScaffoldCrop] Degenerate scaffold box, falling back to the default cube:', extents);

    const defaultBox = cropExtension.createDefaultCropBox(scaffold.getPointInView());

    if (!defaultBox) {
      debugWarn('[ScaffoldCrop] Default crop box unavailable for:', scaffold.name);
      return null;
    }

    return new THREE.Box3(
      new THREE.Vector3(defaultBox.Min.x, defaultBox.Min.y, defaultBox.Min.z),
      new THREE.Vector3(defaultBox.Max.x, defaultBox.Max.y, defaultBox.Max.z),
    );
  }
  async checkIfAreaIsReady(target, options = {}) {
    const isRequestCurrent = () => !options.shouldExecute || options.shouldExecute();
    return new Promise((resolve) => {
      if (!isRequestCurrent()) {
        resolve(false);
        return;
      }
      let areas = store.getters['AREAS/GET_ENTRIES'];
      let selectedArea = store.getters['AREAS/GET_SELECTED_AREA'];
      let defaultAreaId = store.getters['AREAS/GET_DEFAULT_AREA_ID'];

      if (selectedArea) {
        const areaBox = selectedArea.getBoundingBox();

        const contain = areaBox.containsPoint(target);

        if (contain) {
          resolve(true);
          return;
        }

        const correctArea = areas.find((area) => {
          const areaBox = area.getBoundingBox();
          return areaBox.containsPoint(target);
        });

        if (!correctArea && defaultAreaId) {
          Vue.prototype.$dialog.notify.warning('No area to zoom in.');
          resolve(false);
          return;
        }

        let confim = {
          text: 'The selected area is not the same as the one you are trying to zoom in. Do you want to change it?',
          type: 'warning',
          title: 'Warning',
          actions: {
            false: {
              text: 'Cancel',
              color: 'error',
              handle: () => {
                resolve(false);
              },
            },
            true: {
              text: 'Yes',
              color: 'primary',
              handle: () => {
                if (!isRequestCurrent()) {
                  resolve(false);
                  return;
                }
                if (!store.state.viewer) {
                  resolve(false);
                  return;
                }

                let settled = false;
                const onAreaLoaded = () => {
                  if (settled) return false;
                  settled = true;
                  if (this.on3dModelLoadedCallback === onAreaLoaded) {
                    this.on3dModelLoadedCallback = null;
                  }
                  if (!isRequestCurrent()) {
                    resolve(false);
                    return false;
                  }
                  resolve(true);
                  return true;
                };
                onAreaLoaded.tagSpatialRequestOwner = options.requestOwner;
                this.on3dModelLoadedCallback = onAreaLoaded;

                if (!isRequestCurrent()) {
                  if (this.on3dModelLoadedCallback === onAreaLoaded) {
                    this.on3dModelLoadedCallback = null;
                  }
                  resolve(false);
                  return;
                }
                store.dispatch('AREAS/LOAD_AREA_IN_VIEWER', {
                  area: correctArea,
                  onAreaLoaded,
                  requestOwner: options.requestOwner,
                  shouldExecute: options.shouldExecute,
                });
              },
            },
          }
        };

        Vue.prototype.$dialog.confirm(confim);
      }
    });
  }
  clearTagSpatialNavigationCallback(requestOwner) {
    const callback = store.getters['getLoad360ViewerCallback'];
    if (callback?.tagSpatialRequestOwner === requestOwner) {
      store.commit('setLoad360ViewerCallback', null);
    }
  }

  /**
   * Navigates to a scan-derived tag position in the 360 viewer.
   * Finds the referenced scan (or closest scan as fallback), calculates
   * yaw/pitch on-the-fly from the 3D point, and orients the camera.
   * @param {ForgeBaseTag} tag - Tag with point and positionImage360Id set
   */
  async zoomToTagByScanPosition(tag, options = {}) {
    const {
      allowNearestFallback = true,
      onReady = null,
      rejectOnUnavailable = false,
      shouldExecute = null,
      requestOwner = null,
      // Raise the generic 360 highlight hotspot on arrival. Default ON: `openTagAtScanPosition`
      // (the search popup's 360 button) relies on this service raising it — nodeControls'
      // companions deliberately do NOT draw it themselves (6e8fc0ad). Callers that draw their own
      // marker — the CML popup — pass false, otherwise an unlabelled generic pin lands next to it.
      highlight = true,
      // The tag the highlight marker is drawn from. Callers that pass a navigation copy with a
      // scan id stamped on it (the nearest-scan open) hand the real tag here, so the marker shows
      // the tag's real placement - not a dashed "placed from 360" border for a tag that is not.
      highlightTag = null,
    } = options;
    const isRequestCurrent = () => !shouldExecute || shouldExecute();
    const clearOwnedCallback = () => {
      if (requestOwner) this.clearTagSpatialNavigationCallback(requestOwner);
      else store.commit('setLoad360ViewerCallback', null);
    };
    const clearPendingIfCurrent = () => {
      if (isRequestCurrent()) store.commit('setPending360Zoom', false);
    };
    if (!tag.point) {
      debugLog('[ZoomScan] Tag has no point:', tag.id);
      clearOwnedCallback();
      clearPendingIfCurrent();
      const missingPointError = new Error('Tag has no scan position point.');
      missingPointError.code = 'SCAN_UNAVAILABLE';
      if (rejectOnUnavailable) throw missingPointError;
      return { status: 'failed', reason: 'target-360-current' };
    }

    // Coerce to THREE.Vector3 if plain object
    const point = tag.point instanceof THREE.Vector3
      ? tag.point
      : new THREE.Vector3(tag.point.x, tag.point.y, tag.point.z);

    // Find referenced scan, or fall back to closest scan
    let targetImage = null;
    if (tag.positionImage360Id) {
      const projects = store.state.projects || [];
      targetImage = projects
        .flatMap(p => p.images || [])
        .find(img => img.id === tag.positionImage360Id);

      if (!targetImage) {
        try {
          const { data } = await images360Service.getById(
            tag.positionImage360Id,
            store.state.assetId,
          );
          if (data) {
            targetImage = Image360.fromDTO(data);
          }
        } catch (err) {
          debugLog('[ZoomScan] API lookup failed for positionImage360Id:', tag.positionImage360Id, err);
        }
      }

      if (targetImage) {
        debugLog('[ZoomScan] Found referenced scan:', targetImage.id);
      }
    }

    if (!isRequestCurrent()) {
      return { status: 'stale', reason: 'superseded-intent' };
    }

    if (!targetImage && allowNearestFallback) {
      // `point` is WORLD space (raw tag.point) and is reused below for the yaw/pitch
      // direction calc against the scan's world-space forgeCameraPosition — so convert
      // ONLY the argument here. getClosestImageToPoint expects VIEWER space
      // (getCameraPositionInViewer). This fallback is reached only when the tag's
      // pinned positionImage360Id scan can't be resolved (deleted/orphaned scan).
      targetImage = this.getClosestImageToPoint(this.worldToView3d(point, point));
      if (!targetImage) {
        Vue.prototype.$dialog.notify.warning(
          'No 360 scan available near this position.',
          { position: 'top-right', timeout: 3000 }
        );
        debugLog('[ZoomScan] No scan available near point');
        clearOwnedCallback();
        clearPendingIfCurrent();
        return;
      }
      debugLog('[ZoomScan] Referenced scan unavailable, using closest:', targetImage.id);
    }

    if (!targetImage) {
      clearOwnedCallback();
      clearPendingIfCurrent();
      const unavailableError = new Error('Persisted scan is unavailable in this facility.');
      unavailableError.code = 'SCAN_UNAVAILABLE';
      if (rejectOnUnavailable) throw unavailableError;
      return { status: 'failed', reason: 'target-360-current' };
    }
    // Silent for one caller: CmlPopupActionBar#onShowInOtherViewer ("Show in 360") ignores the
    // returned receipt and leaves `rejectOnUnavailable` at its `false` default, so a scan with no
    // imageUrl makes that button do nothing, with no message. Surfacing it is a separate decision
    // — not changed here. `openTagAtScanPosition` passes `rejectOnUnavailable: true`, so that path
    // gets the throw instead.
    if (!targetImage.imageUrl) {
      clearOwnedCallback();
      clearPendingIfCurrent();
      const unavailableError = new Error('Persisted scan has no viewable image.');
      unavailableError.code = 'SCAN_UNAVAILABLE';
      if (rejectOnUnavailable) throw unavailableError;
      return { status: 'failed', reason: 'target-360-current' };
    }

    // Calculate yaw/pitch on-the-fly from 3D point vs scan camera position
    const camPos = targetImage.forgeCameraPosition instanceof THREE.Vector3
      ? targetImage.forgeCameraPosition
      : new THREE.Vector3(
          targetImage.forgeCameraPosition.x,
          targetImage.forgeCameraPosition.y,
          targetImage.forgeCameraPosition.z
        );
    const direction = new THREE.Vector3().subVectors(point, camPos);
    const orientInfo = this.getNewYawAndPitch(targetImage, direction);
    debugLog('[ZoomScan] Calculated yaw/pitch:', orientInfo);

    let completed = false;
    const orientCamera = () => {
      if (completed) return;
      completed = true;
      if (shouldExecute && !shouldExecute()) return;
      try {
        // AVA-571: Pannellum treats null as a value and clamps to min HFOV (max zoom-in).
        this.panoramaViewer.lookAt(orientInfo.pitch, orientInfo.yaw, this.panoramaViewer.getHfov(), 0);
        if (highlight) this.create360HighlightHotspot(highlightTag?.point ? highlightTag : tag);
        onReady?.(targetImage);
        debugLog('[ZoomScan] Camera oriented');
      } catch (err) {
        if (rejectOnUnavailable) throw err;
        debugLog('[ZoomScan] Failed to orient camera:', err);
      }
    };

    const isAlreadyOpened = store.state.selectedImage?.id === targetImage.id;
    if (isAlreadyOpened) {
      try {
        orientCamera();
        return { status: 'executed', reason: 'target-360-current', reloaded: false };
      } finally {
        clearOwnedCallback();
        clearPendingIfCurrent();
      }
    } else {
      return new Promise((resolve, reject) => {
        let timeoutId = setTimeout(() => {
          timeoutId = null;
          clearOwnedCallback();
          clearPendingIfCurrent();
          const timeoutError = new Error('Timed out waiting for the persisted scan.');
          timeoutError.code = 'SCAN_UNAVAILABLE';
          if (rejectOnUnavailable) reject(timeoutError);
          else resolve({ status: 'failed', reason: 'target-360-current' });
        }, 25000);
        const finish = () => {
          if (timeoutId === null) return true;
          if (store.state.selectedImage?.id !== targetImage.id) return false;
          clearTimeout(timeoutId);
          timeoutId = null;
          try {
            orientCamera();
            clearOwnedCallback();
            resolve({ status: 'executed', reason: 'target-360-current', reloaded: true });
          } catch (err) {
            clearOwnedCallback();
            reject(err);
          }
          return true;
        };
        finish.tagSpatialRequestOwner = requestOwner;
        store.commit('setLoad360ViewerCallback', finish);
        try {
          this.launchPanoViewer(targetImage);
        } catch (err) {
          clearTimeout(timeoutId);
          timeoutId = null;
          clearOwnedCallback();
          clearPendingIfCurrent();
          if (rejectOnUnavailable) reject(err);
          else resolve({ status: 'failed', reason: 'target-360-current' });
        }
      });
    }
  }

  async openTagAtScanPosition(tag, options = {}) {
    if (String(options.facilityId).toLowerCase() !== String(store.state.assetId).toLowerCase()) {
      const facilityError = new Error('Persisted scan does not belong to the current facility.');
      facilityError.code = 'SCAN_UNAVAILABLE';
      throw facilityError;
    }
    const executionTag = Object.assign(
      Object.create(Object.getPrototypeOf(tag)),
      tag,
      { positionImage360Id: options.image360Id },
    );
    return this.zoomToTagByScanPosition(executionTag, {
      allowNearestFallback: false,
      onReady: options.onReady,
      rejectOnUnavailable: true,
      shouldExecute: options.shouldExecute,
      requestOwner: options.requestOwner,
      highlightTag: options.highlightTag ?? tag,
    });
  }

  async openTagAtLinkedSource(tag, options = {}) {
    const exactImageId = options.image360Id;
    const facilityId = options.facilityId;
    const isRequestCurrent = () => !options.shouldExecute || options.shouldExecute();
    const clearOwnedCallback = () => {
      this.clearTagSpatialNavigationCallback(options.requestOwner);
    };
    const clearPendingIfCurrent = () => {
      if (isRequestCurrent()) store.commit('setPending360Zoom', false);
    };
    if (String(facilityId).toLowerCase() !== String(store.state.assetId).toLowerCase()) {
      const facilityError = new Error('Linked scan does not belong to the current facility.');
      facilityError.code = 'SCAN_UNAVAILABLE';
      throw facilityError;
    }
    let targetImage = (store.state.projects || [])
      .flatMap(project => project.images || [])
      .find(image => image.id === exactImageId);
    let degraded = false;

    if (!targetImage && exactImageId) {
      try {
        const { data } = await images360Service.getById(exactImageId, facilityId);
        if (data) targetImage = Image360.fromDTO(data);
      } catch (err) {
        debugLog('[Open360] Scoped linked scan lookup failed:', exactImageId, err);
      }
    }

    if (!isRequestCurrent()) {
      return { status: 'stale', reason: 'superseded-intent' };
    }

    if (!targetImage && options.allowNearestFallback === true) {
      targetImage = this.getClosestImageToPoint(tag.getPointInView());
      degraded = !!targetImage;
    }
    if (!targetImage) {
      clearOwnedCallback();
      clearPendingIfCurrent();
      const unavailableError = new Error('Linked scan is unavailable in this facility.');
      unavailableError.code = 'SCAN_UNAVAILABLE';
      throw unavailableError;
    }
    if (!targetImage.imageUrl) {
      clearOwnedCallback();
      clearPendingIfCurrent();
      const unavailableError = new Error('Linked scan has no viewable image.');
      unavailableError.code = 'SCAN_UNAVAILABLE';
      throw unavailableError;
    }

    const reason = degraded
      ? 'scan-unavailable-nearest-fallback'
      : 'target-360-current';
    const finish = (() => {
      let completed = false;
      return () => {
        if (completed) return;
        completed = true;
        if (options.shouldExecute && !options.shouldExecute()) return;
        this.zoomToPointIn360Viewer(tag.point || tag.position, undefined, { keepCurrentZoom: true });
        this.create360HighlightHotspot(tag);
        options.onReady?.(targetImage);
      };
    })();

    if (store.state.selectedImage?.id === targetImage.id) {
      try {
        finish();
        return { status: 'executed', reason, degraded, reloaded: false };
      } finally {
        clearOwnedCallback();
        clearPendingIfCurrent();
      }
    }

    return new Promise((resolve, reject) => {
      let timeoutId = setTimeout(() => {
        timeoutId = null;
        clearOwnedCallback();
        clearPendingIfCurrent();
        const timeoutError = new Error('Timed out waiting for the linked scan.');
        timeoutError.code = 'SCAN_UNAVAILABLE';
        reject(timeoutError);
      }, 25000);
      const onLoaded = () => {
        if (timeoutId === null) return true;
        if (store.state.selectedImage?.id !== targetImage.id) return false;
        clearTimeout(timeoutId);
        timeoutId = null;
        try {
          finish();
          clearOwnedCallback();
          resolve({ status: 'executed', reason, degraded, reloaded: true });
        } catch (err) {
          clearOwnedCallback();
          reject(err);
        }
        return true;
      };
      onLoaded.tagSpatialRequestOwner = options.requestOwner;
      store.commit('setLoad360ViewerCallback', onLoaded);
      try {
        this.launchPanoViewer(targetImage);
      } catch (err) {
        clearTimeout(timeoutId);
        timeoutId = null;
        clearOwnedCallback();
        clearPendingIfCurrent();
        reject(err);
      }
    });
  }

  async openTagIn3d(tag, {
    isolate = false,
    requestOwner = null,
    shouldExecute = null,
  } = {}) {
    const execution = await this.zoomInAllAvailableViewers(tag, isolate, {
      requestOwner,
      shouldExecute,
    });
    if (execution?.status === 'stale') return execution;
    return { status: 'executed', reason: 'target-3d-current' };
  }

  zoomToTagOrScaffold(element, animate) {
    let linked360ImageInfo = element.linked360ImageInfo;
    let closestImage = null;

    if (this.panoramaViewer) {
      if (linked360ImageInfo) {
        closestImage = store.state.projects
          .flatMap((o) => o.images)
          .find((img) => img.id == linked360ImageInfo.imageId);
      } else if (store.state.viewer) {
        closestImage = this.getClosestImageToPoint(element.getPointInView());
      } else {
        closestImage = store.state.selectedImage;
      }
    }

    let isAlreadyOpended =
      store.state.selectedImage != null && store.state.selectedImage == closestImage;

    let point = element instanceof ForgeScaffold ? element.position : element.point;
    let target = element.getPointInView();

    if (
      store.state.viewer &&
      this.panoramaViewer &&
      store.state.areViewsLocked &&
      linked360ImageInfo
    ) {
      if (isAlreadyOpended) {
        this.zoomToPointIn3DAnd360(target);
      } else {
        this.launchPanoViewer(closestImage);
        this.zoomToPointIn360Viewer(point);
        this.zoomToPoint3dViewer(target);
      }
    } else if (store.state.viewer || this.panoramaViewer) {
      if (store.state.viewer) {
        if (!linked360ImageInfo) {
          if (element instanceof ForgeScaffold) {
            let box = element.getBox();
            store.state.viewer.navigation.fitBounds(!closestImage, box);
          } else {
            this.isolateTag(element, !closestImage);
          }
        } else {
          this.zoomToPoint3dViewer(target);
        }
      }

      if (this.panoramaViewer) {
        if (isAlreadyOpended) {
          this.zoomToPointIn360Viewer(point);
        } else {
          this.launchPanoViewer(closestImage);
          this.zoomToPointIn360Viewer(point);
        }
      }
    } else {
      Vue.prototype.$dialog.notify.warning('Please open 3D viewer first.', {
        position: 'top-right',
        timeout: 3000,
      });
    }
  }
  zoomToAnnotation(annotation, animate) {
    if (store.state.viewer && annotation.children && annotation.children.length > 0) {
      var dbids = annotation.children.map((o) => o.dbId);
      this.getMainExtension().isolateDbIds(dbids);
      return;
    }

    // annotation in 2D
    if (
      annotation.level2D &&
      (!store.state.planViewer || annotation.level2D != store.state.selectedLevel.name)
    ) {
      let level = store.state.levels.find((l) => l.name == annotation.level2D);

      if (level && level.planUrn) {
        store.dispatch('showLevel', { level: level });
        store.commit('setLoad2dViewerCallback', () => {
          let point = level.mappingViewersPointsInfo._3dTo2d(annotation.point);
          store.state.forgeService.zoomToPoint2dViewer(point);
        });
      } else {
        Vue.prototype.$dialog.notify.warning(
          `Please open 2d viewer first, level "${annotation.level2D}".`,
        );
      }

      return;
    }

    if (store.state.planViewer) {
      let showenIn2d = false;

      if (annotation instanceof ForgeInspection) {
        showenIn2d = store.state.forgeService
          .getInspectionsInLevel(store.state.selectedLevel)
          .includes(annotation);
      } else {
        showenIn2d = store.state.forgeService
          .getAnnotationsInLevel(store.state.selectedLevel)
          .includes(annotation);
      }

      if (showenIn2d) {
        let point = store.state.selectedLevel.mappingViewersPointsInfo._3dTo2d(annotation.point);
        store.state.forgeService.zoomToPoint2dViewer(point);
      } else {
        let level = store.state.forgeService.getLevelContainsPoint(annotation.point);

        if (level) {
          store.dispatch('showLevel', { level: level });
          store.commit('setLoad2dViewerCallback', () => {
            let point = level.mappingViewersPointsInfo._3dTo2d(annotation.point);
            store.state.forgeService.zoomToPoint2dViewer(point);
          });
        } else if (!store.state.forgeService.panoramaViewer || store.state.viewer) {
          Vue.prototype.$dialog.notify.warning('Please open 3d viewer first.');
        }
      }
    }

    if (!annotation.point) return;

    let closestImage = null;

    if (store.state.forgeService.panoramaViewer) {
      let linked360ImageInfo = annotation.linked360ImageInfo;

      if (linked360ImageInfo) {
        closestImage = store.state.projects
          .flatMap((o) => o.images)
          .find((img) => img.id == linked360ImageInfo.imageId);
      } else if (store.state.viewer) {
        closestImage = store.state.forgeService.getClosestImageToPoint(annotation.getPointInView());
      } else {
        closestImage = store.state.selectedImage;
      }
    }

    let isAlreadyOpended =
      store.state.selectedImage != null && store.state.selectedImage == closestImage;

    // 3d opened, 360 are opened
    if (this.panoramaViewer && store.state.viewer) {
      let target = annotation.getPointInView();

      setTimeout(() => {
        if (isAlreadyOpended) {
          if (store.state.areViewsLocked) {
            this.zoomToPointIn3DAnd360(target);
          } else {
            this.zoomToPoint3dViewer(target);
            this.zoomToPointIn360Viewer(annotation.point);
          }
        } else {
          this.launchPanoViewer(closestImage);
          this.zoomToPointIn360Viewer(annotation.point);
          this.zoomToPoint3dViewer(target);
        }
      }, 100);
    } else if (store.state.viewer) {
      let target = annotation.getPointInView();
      this.zoomToPoint3dViewer(target);
    } else if (this.panoramaViewer) {
      if (isAlreadyOpended) {
        this.zoomToPointIn360Viewer(annotation.point);
      } else {
        this.launchPanoViewer(closestImage);
        this.zoomToPointIn360Viewer(annotation.point);
      }
    }
  }
  // target = annotation.getPointInView();
  zoomToPointIn3DAnd360(target, callback) {
    let isLinkedViewers = store.state.areViewsLocked;

    if (!store.state.viewer || !this.panoramaViewer || !isLinkedViewers)
      return false;

    store.state.viewer.navigation.setTarget(target);

    let fov = this.panoramaViewer.getHfovBounds();
    let minFOV = fov[0];
    let maxFOV = fov[1];

    let zoom = (minFOV + maxFOV) / 2;

    this.panoramaViewer.setHfov(zoom, false);

    store.state.viewer.navigation.setFocalLength(store.state.viewer.navigation.fov2fl(zoom));

    if (callback) callback();

    return true;
  }
  // point = annotation.point
  zoomToPointIn360Viewer(point, callback, { keepCurrentZoom = false } = {}) {
    let selectedImage = store.state.selectedImage;

    if (!selectedImage || !store.state.forgeService.panoramaViewer) return false;
    if (!point) return false;

    // AVA cross-viewer sync: callers may pass a plain {x,y,z} (e.g. vm.raw.point);
    // coerce so .clone()/.sub() below don't throw (mirror the ZoomScan coercion ~3594).
    const p = point instanceof THREE.Vector3 ? point : new THREE.Vector3(point.x, point.y, point.z);

    let dir = p.clone().sub(selectedImage.forgeCameraPosition).normalize();

    var info = store.state.forgeService.getNewYawAndPitch(selectedImage, dir);

    let fov = store.state.forgeService.panoramaViewer.getHfovBounds();
    let minFOV = fov[0];
    let maxFOV = fov[1];

    let zoom = keepCurrentZoom
      ? store.state.forgeService.panoramaViewer.getHfov()
      : (minFOV + maxFOV) / 4;

    store.state.forgeService.panoramaViewer.lookAt(info['pitch'], info['yaw'], zoom, 0);

    if (callback) {
      callback();
    }

    return true;
  }
  // target = annotation.getPointInView();
  zoomToPoint3dViewer(target, callback) {
    if (!store.state.viewer?.model) return;

    let box = null;

    if (target instanceof THREE.Box3) {
      box = target;
    } else {
      let offset = 1 / store.state.unitScale; //todo:enhance this logic
      let min = new THREE.Vector3(target.x - offset, target.y - offset, target.z - offset);
      let max = new THREE.Vector3(target.x + offset, target.y + offset, target.z + offset);
      box = new THREE.Box3(min, max);
    }

    store.state.viewer.navigation.fitBounds(true, box);

    if (callback) callback();
  }
  // point = store.state.selectedLevel.mappingViewersPointsInfo._3dTo2d(annotation.point);
  zoomToPoint2dViewer(point, callback) {
    let min = new THREE.Vector3(point.x - 0.01, point.y - 0.01, point.z - 0.01);
    let max = new THREE.Vector3(point.x + 0.01, point.y + 0.01, point.z + 0.01);
    var box = new THREE.Box3(min, max);
    zoomToFitBox2D(store.state.planViewer, box);

    if (callback) callback();
  }
  take3dPointScreenshot(point, callback) {
    var state = store.state.viewer.getState();

    store.state.forgeService.zoomToPoint3dViewer(point);

    store.state.forgeService.getCropping3DExtension()?.updateBoxVisibility(false);

    setTimeout(() => {
      takeScreenshot(store.state.viewer, (base64) => {
        if (callback) callback(base64);
        store.state.viewer.restoreState(state);
        store.state.forgeService.getCropping3DExtension()?.updateBoxVisibility(true);
      });
    }, 100);
  }
  deleteScaffolds(scaffolds) {
    saveScaffolds(scaffolds, editType.DELETE_SCAFFOLDS);
    for (let i = 0; i < scaffolds.length; i++) {
      var index = store.state.scaffolds.findIndex((o) => o.id == scaffolds[i].id);
      store.state.scaffolds.splice(index, 1);
    }
    this.update3dIconsInAllViews();
  }
  uploadAttachment(file, parentId, parentType, callback) {
    this.isUploading = true;
    let formData = new FormData();
    formData.append('fileToUpload', file, file.name);
    formData.append('assetName', store.state.assetId);
    formData.append('parentId', parentId);
    formData.append('createdBy', store.state.username);
    formData.append('parentType', parentType);

    const ctrl = new AbortController(); // timeout
    setTimeout(() => ctrl.abort(), 5000);

    HttpService.post({
      url: 'api/forge/attachments/uploadAttachment',
      data: formData,
      signal: ctrl.signal,
      headers: {
        'Content-Type': false,
        processData: false,
      },
    })
      .then((response) => {
        let attachment = Object.assign(new ForgeAttachment(), response.data);
        callback(attachment);
      })
      .catch((err) => {
        $handleError({
          message: err,
        });
      })
      .finally(() => {
        this.isUploading = false;
      });

    $('#uploadAttachmentFile').val('');
  }
  addSubInspection(point) {
    store.commit('setIsPickingSubTag', false);
    let editingTag = store.getters['GET_EDITING_TAG'];
    if (!editingTag || !(editingTag instanceof ForgeInspection)) return;
    if (!editingTag.level2D && !store.state.viewer) {
      Vue.prototype.$dialog.notify.warning('Please open 3D viewer first.', {
        position: 'top-right',
        timeout: 3000,
      });
      return;
    }
    store.dispatch({
      type: 'prompt_Forge',
      title: 'Add Sub Inspection',
      callback: (name) => {
        let newSubTag = new ForgeInspectionSubTag();
        newSubTag.name = name;
        newSubTag.point = point;

        editingTag.subTags.push(newSubTag);
      },
      input: {
        inputName: 'Name',
        inputValue: '',
      },
    });
  }
  zoomToSubInspection(subTag, inspection) {
    var min, max;
    if (!inspection.level2D) {
      let point = subTag.getPointInView();
      min = new THREE.Vector3(point.x - 1, point.y - 1, point.z - 1);
      max = new THREE.Vector3(point.x + 1, point.y + 1, point.z + 1);
    } else {
      let point = store.state.selectedLevel.mappingViewersPointsInfo._3dTo2d(subTag.point);
      min = new THREE.Vector3(point.x - 0.01, point.y - 0.01, point.z - 0.01);
      max = new THREE.Vector3(point.x + 0.01, point.y + 0.01, point.z + 0.01);
    }
    var box = new THREE.Box3(min, max);
    let v = inspection.level2D ? store.state.planViewer : store.state.viewer;
    inspection.level2D ? zoomToFitBox2D(v, box) : v.navigation.fitBounds(false, box);
  }

  deleteAttachment(attachments, callback) {
    store.dispatch({
      type: 'confirm_Forge',
      message: 'Are you sure you want to remove attachment?',
      callback: () => {
        let info = {
          assetId: store.state.assetId,
          attachments: attachments,
        };

        HttpService.post({
          url: 'api/forge/attachments/deleteAttachments',
          data: info,
        })
          .then((response) => {
            callback();
          })
          .catch((err) => {
            debugLog(err);

            $handleError({
              message: err,
            });
          });
      },
    });
  }

  downloadMarkup(markup) {
    var url = markup.imageUrl ? markup.imageUrl : markup.pdfUrl;
    downloadURI(url, markup.name);
  }
  filterLevelsBySearch(projects, search) {
    var canFilterElementByText = function (text, image) {
      if (image.name != null && image.name.toLowerCase().trim().includes(text)) return true;
      return false;
    };
    projects.forEach((o) => o.setAllImagesVisable(true));
    if (!search || search == '') return projects;
    var lower = search.toLowerCase().trim();
    projects.forEach((project) => {
      project.isVisable = false;
      project.images.forEach((img) => {
        if (canFilterElementByText(lower, img)) {
          project.isExpanded = true;
          project.isVisable = true;
          img.isVisable = true;
        } else img.isVisable = false;
      });
    });
    return projects;
  }

  crop3D(point) {
    setTimeout(() => {
      store.commit('setIsPickingCropOrigin', false);
      let extension = store.state.forgeService.getCropping3DExtension();
      extension.cropBoxOrigin = point;

      store.commit('setShowCroppingBoxPopup', true);
    }, 50);
  }
  getPointInView(point) {
    if (!point || (!store.state.viewer?.model && !store.state.unitScale)) return point;

    if (!(point instanceof THREE.Vector3)) {
      point = new THREE.Vector3(point.x, point.y, point.z);
    }

    return store.state.forgeService.worldToView3d(point, point);
  }
  worldToView3d(point, defaultValue) {
    if (!point || ((!store.state.viewer || !store.state.viewer.model) && !store.state.unitScale))
      return defaultValue;

    if (!(point instanceof THREE.Vector3)) {
      point = new THREE.Vector3(point.x, point.y, point.z);
    }

    return point
      .clone()
      .multiplyScalar(1 / store.state.unitScale)
      .sub(store.state.globalOffset);
  }
  view3dToWorld(point) {
    if (!point || (!store.state.viewer?.model && !store.state.unitScale)) return point;

    if (!(point instanceof THREE.Vector3)) {
      point = new THREE.Vector3(point.x, point.y, point.z);
    }

    return point.clone().add(store.state.globalOffset).multiplyScalar(store.state.unitScale);
  }

  // ── CML Point Markers ──────────────────────────────────────────

  _getCmlConditionColor(cml) {
    // 5-level workflow scheme (D16) — drives 3D/360 marker color from the same
    // ConditionRating field the Monitoring tab's status dot reads, so the surfaces
    // never disagree. Null = no data.
    //
    // AVA-437 #3: the popup endpoint /api/v1/cmls/{id} returns conditionRating as an
    // INT (0..4); the monitoring-list endpoint returns the PascalCase string. Normalize
    // the numeric form → enum name so every source colors identically. Use `== null`
    // (NOT `!rating`) — int 0 is a VALID rating (Acceptable), not no-data.
    let rating = cml?.conditionRating;
    if (rating == null) return NO_DATA_COLOR;
    if (typeof rating === 'number' || /^\d+$/.test(String(rating))) {
      rating = CONDITION_RATING_ORDER[Number(rating)];
      if (rating == null) return NO_DATA_COLOR; // out-of-range int → no-data
    }
    const key = String(rating).toLowerCase();
    switch (key) {
      case 'acceptable':     return '#4CAF50'; // green
      case 'monitor':        return '#FBC02D'; // yellow
      case 'reinspect':      return '#FF9800'; // orange
      case 'ffsrequired':    return '#9C27B0'; // purple
      case 'repairrequired': return '#F44336'; // red
      default:               return NO_DATA_COLOR; // no-data fallback for unknown values
    }
  }

  _markerLabelKey(entityType, id) {
    return `${entityType}:${id}`;
  }

  _ensure3dMarkerLabelLayer() {
    const container = store.state.viewer?.container;
    if (!container) return null;
    if (this._markerLabelLayer?.parentNode === container) return this._markerLabelLayer;

    this._markerLabelLayer?.remove();
    const layer = document.createElement('div');
    layer.className = 'cml-tml-3d-label-layer';
    container.appendChild(layer);
    this._markerLabelLayer = layer;
    this._markerLabelEntries = [];
    return layer;
  }

  _create3dMarkerLabel(labelRequest) {
    const layer = this._ensure3dMarkerLabelLayer();
    if (!layer) return;

    const label = document.createElement('button');
    label.type = 'button';
    label.className = 'cml-tml-3d-label';
    label.textContent = labelRequest.text;
    label.title = labelRequest.text;
    const subjectKind = labelRequest.subjectKind
      || (labelRequest.entityType === 'cml' ? 'cml' : 'tml');
    const accessibleKind = subjectKind === 'cml'
      ? 'CML'
      : (subjectKind === 'tml' ? 'TML' : subjectKind);
    label.setAttribute('aria-label', `${accessibleKind} ${labelRequest.text}`);
    label.dataset.markerEntity = labelRequest.entityType;
    label.dataset.markerSubjectKind = subjectKind;
    label.dataset.markerId = labelRequest.id;
    if (labelRequest.parentCmlId) label.dataset.parentCmlId = labelRequest.parentCmlId;
    label.style.setProperty('--marker-label-color', labelRequest.conditionColor);
    layer.appendChild(label);

    const bounds = label.getBoundingClientRect();
    this._markerLabelEntries.push({
      ...labelRequest,
      key: this._markerLabelKey(labelRequest.entityType, labelRequest.id),
      element: label,
      width: Math.ceil(bounds.width),
      height: Math.ceil(bounds.height),
    });
  }

  _remove3dMarkerLabels(entityType) {
    const entries = this._markerLabelEntries || [];
    entries.filter((entry) => entry.entityType === entityType).forEach((entry) => entry.element.remove());
    this._markerLabelEntries = entries.filter((entry) => entry.entityType !== entityType);
    if (this._hoveredMarkerLabelKey?.startsWith(`${entityType}:`)) {
      this._hoveredMarkerLabelKey = null;
    }
    if (this._markerLabelEntries.length > 0) return;

    this._markerLabelLayer?.remove();
    this._markerLabelLayer = null;
  }

  _schedule3dMarkerVisualUpdate() {
    if (this._markerVisualRaf != null) return;
    this._markerVisualRaf = window.requestAnimationFrame(() => {
      this._markerVisualRaf = null;
      this._update3dMarkerVisuals();
    });
  }

  _markerPointIsVisible(viewer, worldPosition) {
    const visibilityQuery = viewer.navigation?.isPointVisible;
    return typeof visibilityQuery !== 'function'
      || visibilityQuery.call(viewer.navigation, worldPosition);
  }

  _projectedMarkerScale(viewer, camera, marker) {
    const baseClient = viewer.worldToClient(marker._basePosition, camera);
    const spanVector = new THREE.Vector3(0, marker._markerWorldSpan, 0)
      .applyQuaternion(camera.quaternion);
    const endClient = viewer.worldToClient(marker._basePosition.clone().add(spanVector), camera);
    return screenScaleForTarget(baseClient, endClient, marker._markerTargetPx);
  }

  _update3dMarkerGlyph(viewer, camera, marker) {
    const visible = this._markerPointIsVisible(viewer, marker._basePosition);
    marker.visible = visible;
    if (!visible) return;

    marker.quaternion.copy(camera.quaternion);
    const scale = this._projectedMarkerScale(viewer, camera, marker);
    if (scale != null) marker.scale.set(scale, scale, scale);
  }

  _active3dMarkerLabelKey() {
    if (!popupCardState.isOpen || !this._cmlActiveSphere) return null;
    if (popupCardState.entityType === 'cml') {
      return this._markerLabelKey('cml', this._cmlActiveSphere._cmlId);
    }
    if (popupCardState.entityType === 'tmlpoint') {
      return this._markerLabelKey('tmlpoint', this._cmlActiveSphere._tmlPointId);
    }
    return null;
  }

  _update3dMarkerLabelLayout(viewer) {
    const activeKey = this._active3dMarkerLabelKey();
    const entries = this._markerLabelEntries || [];
    const candidates = entries.map((entry) => {
      const client = viewer.worldToClient(entry.worldPosition);
      return {
        ...entry,
        x: client?.x,
        y: client?.y,
        inFrustum: this._markerPointIsVisible(viewer, entry.worldPosition),
        forceVisible: entry.key === activeKey || entry.key === this._hoveredMarkerLabelKey,
      };
    });
    const placements = layoutMarkerLabels(candidates, {
      width: viewer.container.clientWidth,
      height: viewer.container.clientHeight,
    });

    placements.forEach((placement, index) => {
      const element = entries[index].element;
      element.classList.toggle('is-hidden', !placement.visible);
      if (placement.visible) {
        element.style.transform = `translate3d(${placement.left}px, ${placement.top}px, 0)`;
      }
    });
  }

  _update3dMarkerVisuals() {
    const viewer = store.state.viewer;
    if (!viewer) return;
    const camera = viewer.getCamera();
    (this._cmlMarkers || []).forEach((marker) => this._update3dMarkerGlyph(viewer, camera, marker));
    (this._tmlMarkers || []).forEach((marker) => this._update3dMarkerGlyph(viewer, camera, marker));
    this._update3dMarkerLabelLayout(viewer);
    viewer.impl.invalidate(true);
  }

  _markerLabelFromEvent(event, entityType) {
    const label = event.target?.closest?.('.cml-tml-3d-label');
    return label?.dataset.markerEntity === entityType ? label : null;
  }

  /**
   * AVA-437 #5b — deterministic signature of the CML marker set + the gate
   * inputs that decide what actually renders. Sorted-by-id and value-based
   * (NOT object-identity), so two renders match iff they would draw the same
   * spheres/labels at the same points with the same condition rating, under the
   * same showCml toggle + isolation. Reads showCml + isolatedCmlIds INSIDE so
   * the same formula is used at the top-of-call compare and the end-of-render
   * store. Used to skip a redundant re-render that would otherwise tear down an
   * open CML popup's anchor (e.g. opening the master panel via "View readings").
   * @param {Array} cmlRecords
   * @returns {string}
   */
  _computeCmlRenderSignature(cmlRecords) {
    const showCml = !!store.state.userSettings?.displaySettings?.showCml;
    const iso = (store.state.TAGS?.isolatedCmlIds || []).slice().sort().join(',');
    const parts = (cmlRecords || [])
      .filter((cml) => cml && cml.point)
      .map((cml) => {
        const pt = cml.point;
        // Normalize conditionRating to a canonical lowercase name so the signature
        // matches regardless of which render path produced the CML: the monitoring
        // cache normalizes int→PascalCase string, while raw /cmls DTOs keep the int
        // (0..4). Mirror _getCmlConditionColor's int→name (CONDITION_RATING_ORDER) +
        // lowercase so both representations compare equal. (AVA-437 #5b review fix)
        const rawRating = cml.conditionRating;
        const normRating = rawRating == null
          ? ''
          : (typeof rawRating === 'number'
            ? (CONDITION_RATING_ORDER[rawRating] || String(rawRating))
            : String(rawRating)).toLowerCase();
        return `${cml.id}:${pt.x},${pt.y},${pt.z}:${normRating}`;
      })
      .sort();
    return `${parts.join('|')}#showCml=${showCml}#iso=${iso}`;
  }

  /**
   * Subject-aware point-marker interface used by spatial focus.
   *
   * The existing CML renderer remains the one geometry/lifecycle implementation, but its records
   * carry an explicit stable subject and activation callback. That keeps rendering locality without
   * letting the renderer guess that every point is a CML.
   */
  showSpatialPointMarkers(
    input,
    {
      force = false,
      colorResolver = null,
      ownerId = null,
      onActivate = null,
    } = {},
  ) {
    const markers = Array.isArray(input?.markers) ? input.markers : [];
    const cmlRecords = markers.map((marker) => ({
      id: marker.id,
      point: marker.point,
      cmlNo: marker.label,
    }));
    const markerByRecord = new Map(
      cmlRecords.map((record, index) => [record, markers[index]]),
    );

    return this.showCmlPointMarkers({ cmlRecords }, {
      force,
      ownerId,
      colorResolver: colorResolver
        ? (record) => colorResolver(markerByRecord.get(record))
        : null,
      markerDescriptor: (record) => markerByRecord.get(record) || null,
      onActivate,
    });
  }

  showCmlPointMarkers(
    inspection,
    {
      force = false,
      colorResolver = null,
      ownerId = null,
      markerDescriptor = null,
      onActivate = null,
    } = {},
  ) {
    // AVA-437 #5b — skip the entire clear+re-render when a CML popup is open and
    // the incoming set + gate inputs are identical to what is already on screen.
    // clearCmlPointMarkers() tears down the popup's anchor and closes any open
    // CML popup (FR-014d); the master panel's mixin re-renders the SAME master
    // CMLs the user clicked, so without this guard "View readings" would close
    // the very popup it opened from. Computed BEFORE clearCmlPointMarkers so we
    // can bail before any teardown.
    const incomingSignature = this._computeCmlRenderSignature(inspection?.cmlRecords);
    if (
      popupCardState.isOpen
      && popupCardState.entityType === 'cml'
      && !force
      && incomingSignature === this._cmlRenderSignature
    ) {
      debugLog('[CML markers] skip redundant re-render (popup open, identical set)');
      return;
    }

    this.clearCmlPointMarkers();
    if (!inspection?.cmlRecords) return;
    if (!store.state.viewer) return;

    // Gate: respect CML toggle (unless force=true for edit mode)
    if (!force && !store.state.userSettings?.displaySettings?.showCml) return;

    this._cmlMarkers = [];
    // T015 — reverse map from sphere mesh → cml object so the click handler
    // can resolve which CML was hit by the raycaster. Cleared and rebuilt on
    // every call to showCmlPointMarkers (same lifecycle as _cmlMarkers).
    this._cmlSphereMap = new Map();
    this._cmlMarkerActivationMap = new Map();

    const unitScale = store.state.unitScale;
    const scaleFactor = (unitScale && unitScale > 0) ? (1 / unitScale) : 1;

    // CML triangle geometry (unified marker vocabulary — circle = general marker,
    // triangle = CML, square = TML). Circumradius R ≈ the old 0.08 sphere footprint;
    // bounding height apex→base = 1.5·R drives the on-screen px scale in the camera
    // handler below (baseTriangleH).
    const CML_TRIANGLE_R = 0.05;
    const CML_TRIANGLE_H = CML_TRIANGLE_R * 1.5;

    // Get isolated CML IDs from store - if set, only show these CMLs
    const isolatedCmlIds = store.state.TAGS?.isolatedCmlIds || [];
    const hasIsolation = isolatedCmlIds.length > 0;

    inspection.cmlRecords
      .filter(cml => cml.point)
      .filter(cml => !hasIsolation || isolatedCmlIds.includes(cml.id))
      .forEach(cml => {
        const descriptor = typeof markerDescriptor === 'function'
          ? markerDescriptor(cml)
          : null;
        const pt = cml.point;
        const viewPoint = this.worldToView3d(
          new THREE.Vector3(pt.x, pt.y, pt.z),
          null
        );
        if (!viewPoint) return;

        const conditionColor = (colorResolver ? colorResolver(cml) : this._getCmlConditionColor(cml)) || NO_DATA_COLOR;
        const colorInt = parseInt(conditionColor.replace('#', ''), 16);

        // Triangle marker (point-up), condition-colored. ShapeGeometry — not
        // CircleGeometry — so it renders against Forge's stripped THREE build.
        // Billboarded in the camera handler so local +Y stays screen-up (point-up).
        const triR = CML_TRIANGLE_R * scaleFactor;
        const triShape = new THREE.Shape();
        triShape.moveTo(0, triR);                          // apex (top)
        triShape.lineTo(-triR * 0.866, -triR * 0.5);       // base-left  (0.866 ≈ √3/2)
        triShape.lineTo(triR * 0.866, -triR * 0.5);        // base-right
        triShape.closePath();
        const geometry = new THREE.ShapeGeometry(triShape);
        const material = new THREE.MeshBasicMaterial({
          color: colorInt,
          transparent: true,
          opacity: 0.85,
          depthTest: false,
          side: THREE.DoubleSide,
        });
        const cmlMarker = new THREE.Mesh(geometry, material);
        cmlMarker.position.set(viewPoint.x, viewPoint.y, viewPoint.z);
        cmlMarker._basePosition = viewPoint.clone();
        cmlMarker._isCmlSphere = true;                     // legacy flag name (read by camera/click handlers)
        cmlMarker._cmlId = cml.id;                         // T015 — fast lookup tag
        cmlMarker._markerWorldSpan = CML_TRIANGLE_H * scaleFactor;
        cmlMarker._markerTargetPx = CML_MARKER_TARGET_PX;
        addToScene(cmlMarker, store.state.viewer, 'cml-markers-scene');
        this._cmlMarkers.push(cmlMarker);
        this._cmlSphereMap.set(cmlMarker, cml);            // T015 — marker→cml reverse map
        if (descriptor && typeof onActivate === 'function') {
          this._cmlMarkerActivationMap.set(cmlMarker, {
            subject: descriptor.subject || null,
            onActivate,
          });
        }

        const labelText = cml.cmlNo
          ? cml.cmlNo + (cml.currentMinWT_Cached != null ? ` | ${cml.currentMinWT_Cached.toFixed(2)}mm` : '')
          : 'CML';
        this._create3dMarkerLabel({
          entityType: 'cml',
          subjectKind: descriptor?.subject?.kind || 'cml',
          id: cml.id,
          text: labelText,
          conditionColor,
          worldPosition: cmlMarker._basePosition,
          priority: markerConditionPriority(cml.conditionRating, CONDITION_RATING_ORDER),
        });
      });

    const viewer = store.state.viewer;
    this._cmlCameraHandler = () => {
      if (!viewer) return;
      this._flagForgeViewerInteracting();
      this._schedule3dMarkerVisualUpdate();
    };
    viewer?.addEventListener(
      Autodesk.Viewing.CAMERA_CHANGE_EVENT,
      this._cmlCameraHandler
    );
    viewer?.addEventListener(Autodesk.Viewing.VIEWER_RESIZE_EVENT, this._cmlCameraHandler);
    this._update3dMarkerVisuals();

    // T015 — install the click handler once. Subsequent calls to
    // showCmlPointMarkers are no-ops on the handler (the spheres array
    // changes but the listener doesn't need re-installing).
    this._setupCmlMarkerClickHandler();
    // Hover affordance — single shared listener for both CML and TML markers.
    this._setupMarkerHoverHandler();
    // Block Forge element selection when clicking a marker (parity with tag icons).
    this._setupMarkerMouseDownHandler();

    // Also show CML hotspots in 360 panorama if active
    if (this.panoramaViewer && this.panoramaHotspotManager) {
      this.panoramaHotspotManager.showCmlHotspots(inspection);
    }

    // AVA-437 #5b — record what is now on screen so the next call can detect an
    // identical re-render and skip it (keeping an open CML popup's anchor alive).
    // Computed over the same cmlRecords + gate inputs as the top-of-call compare,
    // so the two signatures are directly comparable.
    //
    // Only a PLAIN render (no force, no custom colorResolver) establishes the skip
    // baseline. A force/colorResolver render paints non-default colours; recording
    // its signature could let a later plain render wrongly skip and leave those
    // custom colours on screen. Reset to null in that case. (AVA-437 #5b review fix)
    this._cmlRenderSignature = (!force && !colorResolver)
      ? this._computeCmlRenderSignature(inspection.cmlRecords)
      : null;

    // Ownership: only claim the layer if something actually painted. The in-service
    // isolatedCmlIds filter (above) and per-point worldToView3d nulls can yield a
    // "successful" 0-marker render — stamping an owner over an empty screen would make
    // the owning surface's switch read Active with nothing on the model.
    if (this._cmlMarkers.length > 0) {
      store.commit('SET_CML_MARKER_OWNER', ownerId);
    } else {
      store.commit('SET_CML_MARKER_OWNER', null);
      debugLog('[CML markers] 0 rendered (likely active CML isolation) — owner not claimed', { ownerId });
    }
  }

  // ─── Screen-space marker hit detection ──────────────────────────────────
  // Forge's overlay scenes don't raycast cleanly against billboarded
  // PlaneGeometry (the ORIGINAL CML click handler's own comment warned about
  // this; the matrix-world fix didn't help — the real issue is the overlay
  // pipeline doesn't share a clean Three.js camera with raycasts). Instead,
  // project each marker's world position to screen via `viewer.worldToClient`
  // (same primitive `_updateCmlPopupAnchorPosition` already uses successfully)
  // and compare to the click's screen coords. Generous pixel hit radius means
  // both the sphere AND its label register as hits without needing 3D
  // intersection math.
  _findCmlAtClient(clientX, clientY) {
    const viewer = store.state.viewer;
    if (!viewer || typeof viewer.worldToClient !== 'function') return null;
    if (!this._cmlSphereMap || this._cmlSphereMap.size === 0) return null;

    const containerRect = viewer.container.getBoundingClientRect();
    const cx = clientX - containerRect.left;
    const cy = clientY - containerRect.top;

    let bestCml = null;
    let bestMarker = null;
    let bestDist = Infinity;
    const seenCmlIds = new Set();

    this._cmlSphereMap.forEach((cml, mesh) => {
      if (!mesh._basePosition) return;
      // Sphere + label share the same _basePosition (they sit at the same
      // 3D point with a small Z offset). Project once per CML id.
      if (seenCmlIds.has(cml.id)) return;
      seenCmlIds.add(cml.id);
      const screen = viewer.worldToClient(mesh._basePosition);
      if (!screen) return;
      const dx = screen.x - cx;
      const dy = screen.y - cy;
      const dist = Math.sqrt(dx * dx + dy * dy);
      if (dist < CML_MARKER_HIT_RADIUS_PX && dist < bestDist) {
        bestDist = dist;
        bestCml = cml;
        bestMarker = mesh;
      }
    });

    return bestCml ? { cml: bestCml, marker: bestMarker, dist: bestDist } : null;
  }

  _findTmlAtClient(clientX, clientY) {
    const viewer = store.state.viewer;
    if (!viewer || typeof viewer.worldToClient !== 'function') return null;
    if (!this._tmlMarkers || this._tmlMarkers.length === 0) return null;

    const containerRect = viewer.container.getBoundingClientRect();
    const cx = clientX - containerRect.left;
    const cy = clientY - containerRect.top;

    let bestMarker = null;
    let bestDist = Infinity;
    const seenIds = new Set();

    for (const mesh of this._tmlMarkers) {
      if (!mesh._basePosition || !mesh._tmlPointId) continue;
      // Square marker + label share the same _basePosition — project once.
      if (seenIds.has(mesh._tmlPointId)) continue;
      seenIds.add(mesh._tmlPointId);
      const screen = viewer.worldToClient(mesh._basePosition);
      if (!screen) continue;
      const dx = screen.x - cx;
      const dy = screen.y - cy;
      const dist = Math.sqrt(dx * dx + dy * dy);
      if (dist < TML_MARKER_HIT_RADIUS_PX && dist < bestDist) {
        bestDist = dist;
        bestMarker = mesh;
      }
    }

    return bestMarker ? {
      tmlPointId: bestMarker._tmlPointId,
      parentCmlId: bestMarker._parentCmlId,
      marker: bestMarker,
      dist: bestDist,
    } : null;
  }

  // ─── Cross-viewer marker sync (Phase 1a) ────────────────────────────────────
  // See .claude/features/CROSS_VIEWER_MARKER_SYNC.md.

  /**
   * Resolve the 3D marker mesh for a CML or TML by id. CML markers are keyed in
   * `_cmlSphereMap` (sphere has `_isCmlSphere`; label only `_cmlId`); TML markers
   * live in the separate `_tmlMarkers` array (mirror `_findTmlAtClient`). Returns
   * the non-label mesh (its `_basePosition` is the clean viewer-space point) or
   * null when 3D isn't loaded / the entity has no marker here ("if available").
   */
  find3DMarkerByEntity(entityType, id) {
    if (!id) return null;
    if (entityType === 'tmlpoint') {
      if (!this._tmlMarkers || this._tmlMarkers.length === 0) return null;
      let fallback = null;
      for (const mesh of this._tmlMarkers) {
        if (mesh._tmlPointId !== id || !mesh._basePosition) continue;
        if (mesh._isTmlMarker) return mesh;
        if (!fallback) fallback = mesh;
      }
      return fallback;
    }
    if (!this._cmlSphereMap || this._cmlSphereMap.size === 0) return null;
    let fallback = null;
    for (const mesh of this._cmlSphereMap.keys()) {
      if (mesh._cmlId !== id || !mesh._basePosition) continue;
      if (mesh._isCmlSphere) return mesh;
      if (!fallback) fallback = mesh;
    }
    return fallback;
  }

  /**
   * Single-slot 3D highlight: a pulsing translucent halo in the marker's OWN
   * condition color (its material was built from it), at the marker base point.
   * Replaces any prior highlight. Net-new (no existing CML/TML 3D highlight).
   * The opacity + scale breathe (rAF loop) makes it read like the 360/doc blink.
   */
  highlightMarkerIn3D(marker) {
    if (!marker || !marker._basePosition || !store.state.viewer) return;
    this.clearMarkerHighlightIn3D();
    const unitScale = store.state.unitScale;
    const scaleFactor = (unitScale && unitScale > 0) ? (1 / unitScale) : 1;
    const colorHex = (marker.material && marker.material.color) ? marker.material.color.getHex() : 0x03624c;
    const geometry = new THREE.SphereGeometry(0.08 * scaleFactor, 16, 16);
    const material = new THREE.MeshBasicMaterial({
      color: colorHex,
      transparent: true,
      opacity: 0.4,
      depthTest: false,
    });
    const mesh = new THREE.Mesh(geometry, material);
    mesh.position.copy(marker._basePosition);
    mesh._isXsyncHighlight = true;
    // Bind the glow to the marker's LIVE scale so zoom, the marker's [0.3,15] scale
    // clamp, and CML-vs-TML sizing are ALL handled by construction — the marker's
    // own camera handler already computes that scale every frame. MULT = 1.65 ×
    // base-geometry ratio (glow sphere diameter 0.16 vs marker size: CML triangle
    // height 0.075 / TML square edge 0.06); no px target / clamp to keep in sync.
    mesh._sourceMarker = marker;
    mesh._glowScaleMult = marker._tmlPointId ? (1.65 * 0.06 / 0.16) : (1.65 * 0.075 / 0.16);
    addToScene(mesh, store.state.viewer, 'cml-sync-highlight-scene');
    this._xsyncHighlight3d = mesh;
    this._startXsyncHighlightPulse();
    debugLog('[xsync] 3D highlight on', marker._cmlId || marker._tmlPointId, colorHex.toString(16));
  }

  /** rAF opacity + scale breathe for the 3D highlight; stopped in clear. */
  _startXsyncHighlightPulse() {
    this._stopXsyncHighlightPulse();
    const mesh = this._xsyncHighlight3d;
    if (!mesh) return;
    let phase = 0;
    const tick = () => {
      if (!this._xsyncHighlight3d) return;
      const viewer = store.state.viewer;
      if (!viewer) { this._xsyncHighlightRaf = window.requestAnimationFrame(tick); return; }
      phase += 0.15;
      const k = 0.5 + 0.5 * Math.sin(phase);   // 0..1
      mesh.material.opacity = 0.25 + 0.3 * k;   // breathe 0.25 ↔ 0.55

      // Bind to the marker's LIVE (already zoom/clamp/type-correct) scale so the
      // glow-to-marker ratio holds by construction — no px/clamp math to re-derive.
      // Fall back to a gentle pulse if the source marker is gone.
      const src = mesh._sourceMarker;
      const srcScale = (src && src.scale) ? src.scale.x : 0;
      const s = srcScale > 0
        ? mesh._glowScaleMult * srcScale * (1 + 0.15 * k)
        : (1 + 0.15 * k);
      mesh.scale.set(s, s, s);
      viewer.impl?.invalidate(true);
      this._xsyncHighlightRaf = window.requestAnimationFrame(tick);
    };
    this._xsyncHighlightRaf = window.requestAnimationFrame(tick);
  }

  _stopXsyncHighlightPulse() {
    if (this._xsyncHighlightRaf != null) {
      window.cancelAnimationFrame(this._xsyncHighlightRaf);
      this._xsyncHighlightRaf = null;
    }
  }

  clearMarkerHighlightIn3D() {
    this._stopXsyncHighlightPulse();
    if (!this._xsyncHighlight3d) return;
    removeFromScene(this._xsyncHighlight3d, store.state.viewer, 'cml-sync-highlight-scene');
    this._xsyncHighlight3d = null;
    store.state.viewer?.impl?.invalidate(true);
  }

  // ─── Point-marker click → stable-subject activation ─────────────────────────
  // The legacy scene/map names remain because CML and spatial point markers share one renderer.
  // Spatial markers carry their own activation; plain CML markers keep the original popup path.
  //
  // The popup component's positioning adapter (T010 in usePopupCard) reads
  // anchor.getBoundingClientRect() every rAF tick, so as long as we keep the
  // anchor element positioned on the sphere (via the camera-change handler),
  // the popup follows the marker through pan/zoom (FR-013, SC-010).
  _setupCmlMarkerClickHandler() {
    if (this._cmlMarkerClickInstalled) return;

    const viewer = store.state.viewer;
    if (!viewer || !viewer.container) {
      debugLog('[CML Popup] viewer.container not ready — deferring click handler install');
      return;
    }

    // Create a single anchor element (reused across opens). Position is
    // updated on click + on every camera change.
    if (!this._cmlPopupAnchor) {
      const anchor = document.createElement('div');
      anchor.className = 'cml-popup-anchor';
      anchor.style.position = 'fixed';
      anchor.style.width = '1px';
      anchor.style.height = '1px';
      anchor.style.pointerEvents = 'none';
      anchor.style.left = '-9999px';
      anchor.style.top = '-9999px';
      document.body.appendChild(anchor);
      this._cmlPopupAnchor = anchor;
    }

    this._cmlMarkerClickHandler = (event) => {
      const markerLabel = event.target?.closest?.('.cml-tml-3d-label');
      const exactLabel = this._markerLabelFromEvent(event, 'cml');
      if (markerLabel && !exactLabel) return;

      let hit = this._findCmlAtClient(event.clientX, event.clientY);
      if (exactLabel) {
        const marker = this.find3DMarkerByEntity('cml', exactLabel.dataset.markerId);
        const cml = marker ? this._cmlSphereMap.get(marker) : null;
        hit = cml ? { cml, marker, dist: 0 } : null;
      }
      if (!hit) {
        if (typeof window !== 'undefined' && window.__cmlDebugClicks) {
          debugLog(`[CML Click] no hit, cmlMarkers=${this._cmlMarkers?.length || 0}`);
        }
        return;
      }
      const spatialActivation = this._cmlMarkerActivationMap?.get(hit.marker);
      debugLog('[Point marker] hit', {
        kind: spatialActivation?.subject?.kind || 'cml',
        id: spatialActivation?.subject?.id || hit.cml.id,
        distance: hit.dist,
      });

      // Stop propagation so the Forge viewer's default selection behavior
      // doesn't fire for this click.
      event.stopPropagation();
      event.preventDefault();

      this._cmlActiveSphere = hit.marker;
      if (spatialActivation) {
        Promise.resolve(spatialActivation.onActivate({
          subject: spatialActivation.subject,
          anchorEl: this._cmlPopupAnchor,
          sourceViewer: '3d',
        })).catch((err) => {
          debugError('[Spatial marker] activation failed', err);
        });
        this._updateCmlPopupAnchorPosition();
        this._schedule3dMarkerVisualUpdate();
        return;
      }
      debugLog(`[CML Popup] marker clicked → opening popup for cml=${hit.cml.id}`);
      // ORDER MATTERS: openPopupCard sets popupCardState.isOpen=true. The
      // anchor-positioning helper EARLY-RETURNS when isOpen is false (parks
      // anchor at -9999px). Calling the helper BEFORE openPopupCard would
      // leave the popup positioned off-screen on first render — manifesting
      // as "double-click needed" because the second click closes the (still
      // off-screen) popup via same-entity toggle. Open first, position after.
      openPopupCard('cml', hit.cml.id, this._cmlPopupAnchor, { sourceViewer: '3d' });
      this._updateCmlPopupAnchorPosition();
      this._schedule3dMarkerVisualUpdate();
    };

    viewer.container.addEventListener('click', this._cmlMarkerClickHandler, true);
    this._cmlMarkerClickInstalled = true;
  }

  // AVA-437 #7a — flag Forge-viewer interaction so the popup positioning rAF
  // loop (usePopupCard._tickPositioning) pauses its layout-forcing rect read
  // during pan/zoom. Mirrors the 360 PanoramaCompass interaction-gating
  // pattern (onCompassInteractStart/End ~line 1059): flip the reactive flag
  // true on the first camera-change frame, then arm a 300ms coast timer that
  // flips it back false once movement stops. Called from the CML + TML
  // CAMERA_CHANGE_EVENT handlers (a popup can be open against either entity).
  //
  // The `true` commit is guarded against the current flag value so we don't
  // fire a Vuex mutation every single camera frame — only the leading edge of
  // a gesture commits; subsequent frames just re-arm the cheap setTimeout.
  _flagForgeViewerInteracting() {
    // No popup open → the rAF tracking loop isn't running, so there's nothing to
    // pause; skip the flag/commit/log entirely so ordinary camera moves don't emit
    // misleading "interaction START/END" logs. (AVA-437 #7 review — Minor.)
    if (!popupCardState.isOpen) return;
    if (!store.state.forgeViewerInteracting) {
      // Leading edge only (guarded) — fires once per gesture, not per frame.
      debugLog('[CML Popup] Forge viewer interaction START → pause popup rAF tracking');
      store.commit('SET_FORGE_VIEWER_INTERACTING', true);
    }
    if (this._forgeInteractEndTimer != null) {
      clearTimeout(this._forgeInteractEndTimer);
    }
    this._forgeInteractEndTimer = setTimeout(() => {
      debugLog('[CML Popup] Forge viewer interaction END (300ms coast) → resume popup rAF tracking');
      store.commit('SET_FORGE_VIEWER_INTERACTING', false);
      this._forgeInteractEndTimer = null;
    }, 300);
  }

  // Position the shared anchor element on the currently active sphere's
  // projected client coordinates. Called from the click handler and from the
  // CAMERA_CHANGE_EVENT handler so the popup stays attached during pan/zoom.
  _updateCmlPopupAnchorPosition() {
    if (!this._cmlPopupAnchor) return;
    if (!this._cmlActiveSphere || !this._cmlActiveSphere._basePosition) return;
    // Only move the anchor while the popup is open against a CML or TmlPoint
    // (TRK-145 — TmlPoint click reuses this same anchor + position helper).
    // Otherwise leave it parked off-screen so it doesn't influence layout.
    //
    // Bug repro before this fix (per user logs 2026-05-23):
    //   [usePopupCard] open(tmlpoint, …)        ← popup state goes Loading
    //   [usePopupCard] TmlPoint resolved …       ← vm built, status Loaded
    //   [usePopupCard] anchor off-screen → close ← rAF loop sees anchor at -9999px
    // Cause: this gate only accepted 'cml', so TmlPoint clicks parked the
    // anchor off-screen, which the positioning rAF then interpreted as the
    // "anchor exited viewport" auto-close signal (FR-014c).
    if (!popupCardState.isOpen
      || (popupCardState.entityType !== 'cml' && popupCardState.entityType !== 'tmlpoint')) {
      this._cmlPopupAnchor.style.left = '-9999px';
      this._cmlPopupAnchor.style.top = '-9999px';
      return;
    }
    const viewer = store.state.viewer;
    if (!viewer || typeof viewer.worldToClient !== 'function') return;
    const client = viewer.worldToClient(this._cmlActiveSphere._basePosition);
    if (!client) return;
    // worldToClient returns coords relative to the viewer container. Add an
    // offset so the popup appears next to (not on top of) the marker, then
    // clamp to the visible viewport so the popup body + action row never get
    // hidden below the fold.
    //
    // AVA-437 #7b — measure the ACTUAL rendered card box instead of a hardcoded
    // 320×440 envelope. The action bar (this ticket) made the card taller than
    // the old 440 constant, so the clamp under-estimated the card's height and
    // let the action row overflow the viewport bottom. Fall back to the old
    // envelope when the host isn't mounted yet (first open, pre-render).
    const containerRect = viewer.container.getBoundingClientRect();
    const hostEl = document.querySelector('.cml-popup-card-host');
    const POPUP_H = (hostEl && hostEl.offsetHeight) || 440;
    const POPUP_W = (hostEl && hostEl.offsetWidth) || 320;
    const OFFSET = 14;
    const MARGIN = 12;
    // AVA-437 #7b — the host renders at (x + 16, y − 16) relative to the (x, y)
    // we write to anchor.style.left/top (popupCardStyles.scss: margin-left 16px,
    // margin-top −16px). Clamp the ACTUAL card box [x+DX, y+DY, W, H], not the
    // raw anchor point, so the on-screen card — not an imaginary box at the
    // anchor — is what stays inside the viewport.
    const HOST_DX = 16;
    const HOST_DY = -16;
    let x = containerRect.left + client.x + OFFSET;
    let y = containerRect.top + client.y + OFFSET;
    if ((x + HOST_DX) + POPUP_W > window.innerWidth - MARGIN) {
      // Not enough room to the right — flip to the left of the marker.
      x = containerRect.left + client.x - POPUP_W - OFFSET;
    }
    if ((y + HOST_DY) + POPUP_H > window.innerHeight - MARGIN) {
      // Not enough room below — flip above (anchor at the bottom edge of the popup).
      y = containerRect.top + client.y - POPUP_H - OFFSET;
    }
    // Clamp lower bounds against the rendered box position (anchor + host offset),
    // so the offset card edge — not the anchor — respects the top/left margin.
    if (x + HOST_DX < MARGIN) x = MARGIN - HOST_DX;
    if (y + HOST_DY < MARGIN) y = MARGIN - HOST_DY;
    this._cmlPopupAnchor.style.left = `${x}px`;
    this._cmlPopupAnchor.style.top = `${y}px`;
  }

  _teardownCmlMarkerClickHandler() {
    const viewer = store.state.viewer;
    if (viewer && viewer.container && this._cmlMarkerClickHandler) {
      viewer.container.removeEventListener('click', this._cmlMarkerClickHandler, true);
    }
    this._cmlMarkerClickHandler = null;
    this._cmlMarkerClickInstalled = false;
    if (this._cmlPopupAnchor && this._cmlPopupAnchor.parentNode) {
      this._cmlPopupAnchor.parentNode.removeChild(this._cmlPopupAnchor);
    }
    this._cmlPopupAnchor = null;
    this._cmlActiveSphere = null;
  }

  clearCmlPointMarkers() {
    // A clear means "no owner", regardless of instance state. Commit BEFORE the
    // `if (!this._cmlMarkers) return` early-out below (a fresh ForgeViewerService created
    // by CLEAR_MAIN_DATA has no _cmlMarkers yet but may need the token nulled).
    store.commit('SET_CML_MARKER_OWNER', null);
    if (this._cmlCameraHandler) {
      store.state.viewer?.removeEventListener(
        Autodesk.Viewing.CAMERA_CHANGE_EVENT,
        this._cmlCameraHandler
      );
      store.state.viewer?.removeEventListener(
        Autodesk.Viewing.VIEWER_RESIZE_EVENT,
        this._cmlCameraHandler
      );
      this._cmlCameraHandler = null;
    }
    // AVA-437 #7a — a mid-gesture teardown (panel close / filter change while
    // the camera is still moving) must not leave the interaction flag stuck
    // true, which would permanently pause an unrelated popup's rAF tracking.
    if (this._forgeInteractEndTimer != null) {
      clearTimeout(this._forgeInteractEndTimer);
      this._forgeInteractEndTimer = null;
    }
    store.commit('SET_FORGE_VIEWER_INTERACTING', false);
    this._remove3dMarkerLabels('cml');
    if (!this._cmlMarkers) return;
    this._cmlMarkers.forEach(m => {
      if (m.material?.map) {
        m.material.map.dispose();
      }
      removeFromScene(m, store.state.viewer, 'cml-markers-scene');
    });
    this._cmlMarkers = [];
    if (this._cmlSphereMap) this._cmlSphereMap.clear();
    if (this._cmlMarkerActivationMap) this._cmlMarkerActivationMap.clear();
    // AVA-437 #5b — after a genuine clear the screen no longer matches any prior
    // signature, so reset it; otherwise the next render could wrongly skip.
    this._cmlRenderSignature = null;
    // T015 — also tear down the popup click handler and anchor. If the popup
    // is currently open for a CML in this viewer, close it (the marker that
    // anchored it just stopped rendering, FR-014d).
    if (popupCardState.isOpen && popupCardState.entityType === 'cml') {
      closePopupCard();
    }
    this._teardownCmlMarkerClickHandler();
    store.state.viewer?.impl?.invalidate(true);

    // Also clear CML hotspots from 360 panorama
    if (this.panoramaHotspotManager) {
      this.panoramaHotspotManager.clearCmlHotspots();
    }
  }

  // ── TmlPoint Markers (Wave 005++ visibility) ──────────────────────────────
  // Renders a sub-point sphere + label per TmlPoint, visually subordinated to
  // its parent CmlRecord (smaller sphere, color inherited from the parent's
  // _getCmlConditionColor). Independent of CML markers so the two can be
  // toggled separately (FR: showCml vs showTml). Click handlers are NOT
  // wired in this slice — the popup story for TmlPoints is a separate ticket.
  //
  // Input shape: same as showCmlPointMarkers (object with `cmlRecords` array)
  // OR a bare array of CmlRecords. Each CML is expected to have a `tmlPoints`
  // array populated; callers without TmlPoint data should not invoke this
  // (or will get an empty render). The `tagInfoCmlMarkersMixin` fetches
  // TmlPoints via useMonitoringTab.loadTmlPointsForCml before calling.
  showTmlPointMarkers(input, { force = false, colorResolver = null } = {}) {
    this.clearTmlPointMarkers();

    const cmlRecords = Array.isArray(input?.cmlRecords)
      ? input.cmlRecords
      : (Array.isArray(input) ? input : null);
    if (!cmlRecords) return;
    if (!store.state.viewer) return;

    // Visibility gate. Default-to-true semantic: undefined === true so a
    // fresh DisplaySettings (no showTml field yet) still renders markers.
    const showTmlEnabled = store.state.userSettings?.displaySettings?.showTml !== false;
    if (!force && !showTmlEnabled) return;

    this._tmlMarkers = [];

    const unitScale = store.state.unitScale;
    const scaleFactor = (unitScale && unitScale > 0) ? (1 / unitScale) : 1;

    // TML markers are visually subordinated to parent CML markers — see D14
    // hierarchy: judgment lives on CMLs, TMLs are measurement contributors.
    // Square billboard at 75% of CML sphere diameter. CML sphere is 0.04
    // radius (0.08 diameter) → TML square edge = 0.06. Billboard plane keeps
    // it facing the camera so it reads as a flat square from any viewpoint.
    const TML_SQUARE_EDGE = 0.06;
    cmlRecords.forEach((cml) => {
      if (!cml?.tmlPoints || !Array.isArray(cml.tmlPoints)) return;
      const conditionColor = (colorResolver ? colorResolver(cml) : this._getCmlConditionColor(cml)) || NO_DATA_COLOR;
      const colorInt = parseInt(conditionColor.replace('#', ''), 16);

      cml.tmlPoints
        .filter((tp) => tp && tp.point && !tp.isDeleted)
        .forEach((tp) => {
          const pt = tp.point;
          const viewPoint = this.worldToView3d(
            new THREE.Vector3(pt.x, pt.y, pt.z),
            null,
          );
          if (!viewPoint) return;

          // Square billboard plane — 75% of the CML's 0.08-diameter sphere.
          // The plane is later quaternion-synced to the camera in the camera
          // handler, so it reads as a flat square facing the viewer.
          const geometry = new THREE.PlaneGeometry(
            TML_SQUARE_EDGE * scaleFactor,
            TML_SQUARE_EDGE * scaleFactor,
          );
          const material = new THREE.MeshBasicMaterial({
            color: colorInt,
            transparent: true,
            opacity: 0.85,
            depthTest: false,
            side: THREE.DoubleSide,
          });
          const marker = new THREE.Mesh(geometry, material);
          marker.position.set(viewPoint.x, viewPoint.y, viewPoint.z);
          marker._basePosition = viewPoint.clone();
          marker._isTmlMarker = true;
          marker._tmlPointId = tp.id;
          marker._parentCmlId = cml.id;
          marker._markerWorldSpan = TML_SQUARE_EDGE * scaleFactor;
          marker._markerTargetPx = TML_MARKER_TARGET_PX;
          addToScene(marker, store.state.viewer, 'tml-markers-scene');
          this._tmlMarkers.push(marker);

          if (tp.position) {
            this._create3dMarkerLabel({
              entityType: 'tmlpoint',
              id: tp.id,
              parentCmlId: cml.id,
              text: tp.position,
              conditionColor,
              worldPosition: marker._basePosition,
              priority: markerConditionPriority(cml.conditionRating, CONDITION_RATING_ORDER),
            });
          }
        });
    });

    const viewer = store.state.viewer;
    this._tmlCameraHandler = () => {
      if (!viewer) return;
      this._flagForgeViewerInteracting();
      this._schedule3dMarkerVisualUpdate();
    };
    viewer?.addEventListener(
      Autodesk.Viewing.CAMERA_CHANGE_EVENT,
      this._tmlCameraHandler,
    );
    viewer?.addEventListener(Autodesk.Viewing.VIEWER_RESIZE_EVENT, this._tmlCameraHandler);
    this._update3dMarkerVisuals();

    // Install click + hover + selection-block (idempotent — once per session).
    this._setupTmlMarkerClickHandler();
    this._setupMarkerHoverHandler();
    this._setupMarkerMouseDownHandler();

    // Also show TML hotspots in the 360 panorama if active — parity with the
    // CML path (see showCmlPointMarkers). Implicitly toggle-gated: we only
    // reach here after the showTml gate above, so the 360 TML hotspots inherit
    // the same visibility state as the 3D markers.
    if (this.panoramaViewer && this.panoramaHotspotManager) {
      this.panoramaHotspotManager.showTmlHotspots(input);
    }
  }

  clearTmlPointMarkers() {
    if (this._tmlCameraHandler) {
      store.state.viewer?.removeEventListener(
        Autodesk.Viewing.CAMERA_CHANGE_EVENT,
        this._tmlCameraHandler,
      );
      store.state.viewer?.removeEventListener(
        Autodesk.Viewing.VIEWER_RESIZE_EVENT,
        this._tmlCameraHandler,
      );
      this._tmlCameraHandler = null;
    }
    // AVA-437 #7a — the TML handler arms the same shared _forgeInteractEndTimer
    // as the CML handler; clear it on teardown so a mid-gesture clear can't
    // leave the interaction flag stuck true (mirrors clearCmlPointMarkers).
    if (this._forgeInteractEndTimer != null) {
      clearTimeout(this._forgeInteractEndTimer);
      this._forgeInteractEndTimer = null;
    }
    store.commit('SET_FORGE_VIEWER_INTERACTING', false);
    this._remove3dMarkerLabels('tmlpoint');
    if (!this._tmlMarkers) return;
    this._tmlMarkers.forEach((m) => {
      if (m.material?.map) m.material.map.dispose();
      removeFromScene(m, store.state.viewer, 'tml-markers-scene');
    });
    this._tmlMarkers = [];
    // TRK-145 — if the popup is open against a TmlPoint and we're clearing
    // those markers (panel close, filter change, etc.), close the popup. The
    // anchor mesh is going away — leaving the popup mounted would either pin
    // it to a stale position or trigger the rAF "anchor removed" auto-close
    // a frame later anyway. Closing here is cleaner.
    if (popupCardState.isOpen && popupCardState.entityType === 'tmlpoint') {
      closePopupCard();
    }
    // Tear down TML click handler. Hover handler stays installed — it's
    // shared with CML markers and lightweight (early-returns when both
    // arrays are empty).
    this._teardownTmlMarkerClickHandler();
    store.state.viewer?.impl?.invalidate(true);

    // Also clear TML hotspots from the 360 panorama (parity with
    // clearCmlPointMarkers → clearCmlHotspots).
    if (this.panoramaHotspotManager) {
      this.panoramaHotspotManager.clearTmlHotspots();
    }
  }

  // ── TmlPoint marker click handler ───────────────────────────────────────
  // Parallel to `_setupCmlMarkerClickHandler` but defers to it when both
  // raycasts hit at the same screen point (CML handler fires first and calls
  // event.preventDefault() on hit; this handler checks event.defaultPrevented
  // and skips, avoiding the "open then immediately close" race the popup
  // card's same-entity-toggle logic would cause).
  //
  // Pragmatic v1 popup behavior: a TmlPoint click opens the PARENT CML's
  // popup, visually anchored on the clicked TmlPoint marker (we set
  // `_cmlActiveSphere` to the TML mesh, and the existing popup-anchor
  // positioning helper follows that field). The dedicated TmlPoint popup
  // (its own view model + position + latest reading + parent link) is
  // tracked as a follow-up — usePopupCard.js entityType is currently
  // 'cml'-only per its line 207 docstring.
  _setupTmlMarkerClickHandler() {
    if (this._tmlMarkerClickInstalled) return;
    const viewer = store.state.viewer;
    if (!viewer || !viewer.container) return;

    this._tmlMarkerClickHandler = (event) => {
      if (event.defaultPrevented) return;

      const markerLabel = event.target?.closest?.('.cml-tml-3d-label');
      const exactLabel = this._markerLabelFromEvent(event, 'tmlpoint');
      if (markerLabel && !exactLabel) return;

      let hit = this._findTmlAtClient(event.clientX, event.clientY);
      if (exactLabel) {
        const marker = this.find3DMarkerByEntity('tmlpoint', exactLabel.dataset.markerId);
        hit = marker ? {
          tmlPointId: exactLabel.dataset.markerId,
          parentCmlId: exactLabel.dataset.parentCmlId,
          marker,
          dist: 0,
        } : null;
      }
      if (!hit) {
        if (typeof window !== 'undefined' && window.__cmlDebugClicks) {
          debugLog(`[TML Click] no hit, tmlMarkers=${this._tmlMarkers?.length || 0}`);
        }
        return;
      }
      debugLog(`[TML Click] hit tmlPointId=${hit.tmlPointId} parent=${hit.parentCmlId} dist=${hit.dist?.toFixed(1)}`);

      event.stopPropagation();
      event.preventDefault();

      debugLog(`[TML Popup] marker clicked → opening TmlPoint popup id=${hit.tmlPointId} parent=${hit.parentCmlId}`);

      // TRK-145 — TmlPoint popup is now wired. The popup pulls TmlPoint data
      // from the Monitoring tab observable cache (same store the markers
      // were rendered from); no extra HTTP fetch is needed. The parentCmlId
      // hint lets resolveTmlPoint() avoid an O(allCmls) cache scan.
      //
      // We re-use the shared `_cmlPopupAnchor` because the popup is a singleton
      // and only one is open at a time. Setting `_cmlActiveSphere` to the
      // TmlPoint marker keeps the anchor-position helper pinned to the
      // clicked TmlPoint (the helper just reads `_basePosition` off the
      // active marker — type-agnostic).
      this._cmlActiveSphere = hit.marker;
      // ORDER MATTERS (same reasoning as the CML handler at line 4399):
      // openPopupCard sets isOpen=true; the anchor-positioning helper
      // early-returns when isOpen is false. Open first, then position.
      openPopupCard(
        'tmlpoint',
        hit.tmlPointId,
        this._cmlPopupAnchor,
        { parentCmlId: hit.parentCmlId, sourceViewer: '3d' },
      );
      this._updateCmlPopupAnchorPosition();
      this._schedule3dMarkerVisualUpdate();
    };

    viewer.container.addEventListener('click', this._tmlMarkerClickHandler, true);
    this._tmlMarkerClickInstalled = true;
  }

  _teardownTmlMarkerClickHandler() {
    const viewer = store.state.viewer;
    if (viewer && viewer.container && this._tmlMarkerClickHandler) {
      viewer.container.removeEventListener('click', this._tmlMarkerClickHandler, true);
    }
    this._tmlMarkerClickHandler = null;
    this._tmlMarkerClickInstalled = false;
  }

  // ── Shared hover affordance across CML + TML markers ────────────────────
  // Switches the viewer cursor to 'pointer' over any clickable marker so
  // users get visual feedback that the marker can be opened. Single install
  // per session; raycasts both marker arrays each mousemove (cheap at the
  // scale of ~10-100 meshes). When off all markers, restores cursor only
  // if we ourselves had set 'pointer' — so we don't fight Forge's own
  // cursor management (crosshair during picking, etc.).
  _setupMarkerHoverHandler() {
    if (this._markerHoverInstalled) return;
    const viewer = store.state.viewer;
    if (!viewer || !viewer.container) return;

    this._markerHoverHandler = (event) => {
      const hasCml = this._cmlMarkers?.length > 0;
      const hasTml = this._tmlMarkers?.length > 0;
      if (!hasCml && !hasTml) return;

      const markerLabel = event.target?.closest?.('.cml-tml-3d-label');
      const hit = markerLabel ? null : (
        this._findCmlAtClient(event.clientX, event.clientY)
        || this._findTmlAtClient(event.clientX, event.clientY)
      );
      const hoveredKey = markerLabel
        ? this._markerLabelKey(markerLabel.dataset.markerEntity, markerLabel.dataset.markerId)
        : (hit?.cml
          ? this._markerLabelKey('cml', hit.cml.id)
          : (hit?.tmlPointId ? this._markerLabelKey('tmlpoint', hit.tmlPointId) : null));
      if (hoveredKey !== this._hoveredMarkerLabelKey) {
        this._hoveredMarkerLabelKey = hoveredKey;
        this._schedule3dMarkerVisualUpdate();
      }

      // Set cursor on `viewer.canvas` (NOT container) to match the pattern
      // Forge itself uses elsewhere — see toggleCrossHairCursorToViewer +
      // _setCursor at line 5290. Container-level cursor is overridden by
      // Forge's own canvas cursor management, so the affordance never shows.
      const cursorTarget = viewer.canvas || viewer.container;
      if (hit || markerLabel) {
        cursorTarget.style.cursor = 'pointer';
      } else if (cursorTarget.style.cursor === 'pointer') {
        cursorTarget.style.cursor = '';
      }
    };

    viewer.container.addEventListener('mousemove', this._markerHoverHandler);
    this._markerHoverInstalled = true;
  }

  // ── Block Forge element-selection on marker mousedown ───────────────────
  // Mirrors the existing tag-icon behavior: clicking a CML/TML marker should
  // NOT also select the underlying Forge model element. Forge's selection
  // tool fires on mousedown (not click), so by the time our click handler
  // runs the element is already selected. We intercept mousedown FIRST
  // (capture phase) and `stopImmediatePropagation` if the click would land
  // on a marker. mouseup is intentionally NOT intercepted — letting it
  // through gives Forge's tool a clean state and the browser still derives
  // the click event from the matched mousedown+mouseup, so the popup opens
  // as expected.
  _setupMarkerMouseDownHandler() {
    if (this._markerMouseDownInstalled) return;
    const viewer = store.state.viewer;
    if (!viewer || !viewer.container) return;

    this._markerMouseDownHandler = (event) => {
      if (event.button !== 0) return; // left-button only

      const markerLabel = event.target?.closest?.('.cml-tml-3d-label');
      const hit = markerLabel || this._findCmlAtClient(event.clientX, event.clientY)
        || this._findTmlAtClient(event.clientX, event.clientY);

      if (hit) {
        const markerIdentity = markerLabel
          ? `${markerLabel.dataset.markerEntity} ${markerLabel.dataset.markerId}`
          : (hit.cml ? `CML ${hit.cml.id}` : `TML ${hit.tmlPointId}`);
        debugLog(`[Marker MouseDown] hit ${markerIdentity} — blocking Forge selection`);
        event.stopImmediatePropagation();
      }
    };

    viewer.container.addEventListener('mousedown', this._markerMouseDownHandler, true);
    this._markerMouseDownInstalled = true;
  }

  view3dToWorldLength(length) {
    return length * store.state.unitScale;
  }
  worldToView3dLength(length) {
    return length / store.state.unitScale;
  }
  //thumbnail popups
  // Convert a Pannellum hotspot MouseEvent into coordinates relative to the
  // panorama render container (#panoramaContainer) — the SAME reference frame
  // the 3D path's event.offsetX/offsetY already uses (#panoramaContainer is
  // coextensive with #viewer3d). Pannellum hotspot events expose layerX/layerY
  // relative to the tiny hotspot <div>, which lands the card top-left;
  // clientX/clientY minus the container rect produces the correct anchor.
  panoEventToContainerOffset(event) {
    const container = document.getElementById('panoramaContainer');
    if (!container) {
      debugWarn('[360-Card] #panoramaContainer not found — 360 popup may be mispositioned');
    }
    const rect = container ? container.getBoundingClientRect() : { left: 0, top: 0 };
    const coords = { offsetX: event.clientX - rect.left, offsetY: event.clientY - rect.top };
    debugLog('[360-Card] anchor offset', coords);
    return coords;
  }

  // Resolve a viewer click into the thumbnail popup's { x, y } position in the
  // popup's offset-parent (.page-view) coordinate frame, so the card opens next
  // to the clicked icon in every viewer (2D / 3D / 360). Three input shapes:
  //   • raw DOM event (2D/3D Forge canvas) — has clientX/clientY. Its
  //     offsetX/offsetY are relative to event.target (canvas / sprite / overlay)
  //     and mis-place the card (top-left / wrong spot), so we derive from the
  //     reliable clientX/clientY minus the .page-view rect. closest('.page-view')
  //     picks the correct panel in dual-panel mode.
  //   • pre-resolved { offsetX, offsetY } — the 360 hotspot path already converts
  //     via panoEventToContainerOffset() (#panoramaContainer, coextensive with
  //     .page-view); used as-is.
  //   • null — no cursor context (e.g. 2D single-tag); use the centered fallback.
  // See .claude/features/360_MODAL_POSITION_AND_DOUBLE_CLICK.md.
  _resolveCardPosition(event, fallbackX, fallbackY) {
    if (event && event.clientX != null) {
      const host =
        (event.target && event.target.closest && event.target.closest('.page-view')) ||
        document.querySelector('.page-view');
      const rect = host ? host.getBoundingClientRect() : { left: 0, top: 0 };
      const pos = { x: event.clientX - rect.left + 50, y: event.clientY - rect.top - 50 };
      debugLog('[360-Card] card position (viewport → .page-view)', pos);
      return pos;
    }
    if (event && event.offsetX != null) {
      return { x: event.offsetX + 50, y: event.offsetY - 50 };
    }
    return { x: fallbackX, y: fallbackY };
  }

  onClickOn3dIcon(item, event, type) {
    if (store.getters['GET_IS_MEASURING']) return;

    let url = item instanceof Image360 ? item.thumbnailURL : item.thumbnailUrl;
    const { x, y } = this._resolveCardPosition(event, 'calc(50% + 120px)', 'calc(50% - 120px)');

    store.commit('setThumbnailPopupInfo', {
      type: type,
      info: {
        item: item,
        shown: true,
        imgUrl: url,
        x: x,
        y: y,
      },
    });
  }
  showListOfThumbnails(items, event, type) {
    if (store.getters['GET_IS_MEASURING']) return;

    const { x, y } = this._resolveCardPosition(event, 'calc(50% - 130px)', 'calc(50% - 120px)');

    store.commit('setThumbnailPopupInfo', {
      type: type,
      info: { items: items, shown: true, showContext: true, x: x, y: y },
    });
  }
  updatePopupItemsForTag(tag) {
    let popup2dInfo = store.getters['get2dThumbnailPopupInfo'];
    if (popup2dInfo && popup2dInfo.item && popup2dInfo.item.id == tag.id) {
      popup2dInfo.item = tag;
      popup2dInfo.imgUrl = tag.thumbnailUrl;
    }
    let popup3dInfo = store.getters['get3dThumbnailPopupInfo'];
    if (popup3dInfo && popup3dInfo.item && popup3dInfo.item.id == tag.id) {
      popup3dInfo.item = tag;
      popup3dInfo.imgUrl = tag.thumbnailUrl;
    }
    let popup360Info = store.getters['get360ThumbnailPopupInfo'];
    if (popup360Info && popup360Info.item && popup360Info.item.id == tag.id) {
      popup360Info.item = tag;
      popup360Info.imgUrl = tag.thumbnailUrl;
    }
  }
  startWaitingForPickingCropOrigin() {
    store.commit('setIsPickingCropOrigin', true);
  }

  toggleTagArea2dCommand(tag) {
    if (!store.state.planViewer) {
      Vue.prototype.$dialog.notify.warning('Please open 2d viewer first.');

      return;
    }
    if (!store.state.selectedLevel) {
      Vue.prototype.$dialog.notify.warning('Please open a level first.');

      return;
    }
    if (!store.state.selectedLevel.hasAllMappingInfo()) {
      Vue.prototype.$dialog.notify.warning('Please finish mapping 2d/3d in admin first.');

      return;
    }
    if (tag.area2dCoordinates) tag.area2dCoordinates = null;
    else store.state.forgeService.getDrawPointsExtension().setTagToAddAreaTo(tag);
  }
  toggleCreatingAreaToDownloadPC() {
    if (!store.state.planViewer) {
      Vue.prototype.$dialog.notify.warning('Please open 2d viewer first.');

      return;
    }
    if (!store.state.selectedLevel) {
      Vue.prototype.$dialog.notify.warning('Please open a level first.');
      return;
    }
    if (!store.state.selectedLevel.hasAllMappingInfo()) {
      Vue.prototype.$dialog.notify.warning('Please finish mapping 2d/3d in admin first.');

      return;
    }

    let value = store.getters['getIsDrawingAreaToDownloadPC'];
    store.dispatch('toggleAreaToDownloadPC', { value: !value });
    store.state.forgeService.getDrawPointsExtension().setDrawingMode(!value);
  }
  sendDataToDownloadPointCloudTab(polygonPoints) {
    let isGlobalSearchTabShown = store.state.isTabShown && store.state.selectedTab == 0;
    let allImages = store.state.projects.flatMap((o) => o.images);
    var images = store.state.selectedLevel.filterImagesInside(allImages).filter((o) => o.isLocked);
    if (isGlobalSearchTabShown && store.getters['GET_GLOBAL_SEARCH_TEXT']) {
      images = images.filter((o) => store.state.filtered360Imgs.includes(o));
    }

    let results = [];

    images.forEach((image) => {
      let inside = isPointInsidePolygon(image.forgeCameraPosition, polygonPoints);
      if (inside) results.push(image);
    });

    store.commit('setImagesInCropBox', results);

    store.dispatch('SHOW_PANEL', { tabIndex: PANEL_TAB.SCAN_DOWNLOAD, pinned: true });
  }
  getAutomaticTagsByIds(ids, callback) {
    return new Promise((resolve, reject) => {
      postData(
        `api/equipments/getAutomaticTagsByIds`,
        ids,
        (result) => {
          result.equipments = result.equipments.map((e) => {
            let autoTag = Object.assign(new ForgeEquipment(), e);
            autoTag.parseContent();
            return autoTag;
          });

          store.dispatch('PUSH_TAGS_TO_AUTOMATIC_TAGS', { tags: result.equipments });

          if (callback) callback(result.equipments);

          resolve(result.equipments);
        },
        (error) => {
          debugLog(error);
          reject(error);
        },
      );
    });
  }
  // viewType => "3d", "2d", "360"
  addNewTag(viewType, tagPoint, level2D, canAddScaffold) {
    let is3D = viewType == '3d';

    let isTreeLoaded = store.state.isTreeLoaded;
    if (is3D && !isTreeLoaded) {
      Vue.prototype.$dialog.notify.warning('Please wait for forge to load data.');

      return;
    }

    if (!is3D && !level2D) {
      store.commit('setIsPickingTag', false);
    }

    if (viewType == '360') {
      $('.pnlm-ui').css('cursor', 'default');
    }

    store.dispatch('SHOW_PANEL', { tabIndex: PANEL_TAB.TAGS, pinned: true });
    let selection = is3D ? store.state.viewer.model.selector.getSelection() : [];

    store.dispatch('CLEAR_PREVIOUS_TAGS');
    store.commit('SET_EDITING_TAG', null);
    store.commit('SET_ADDING_TAG_INFO', {
      name: '',
      viewType: viewType,
      tagPoint: tagPoint,
      level2D: level2D,
      selection: selection,
      type: 'AVA Inspect',
      canAddScaffold: canAddScaffold,
    });
  }
  createTagFromSelection() {
    setTimeout(() => {
      if (!store.state.isPickingTag) return;
      let selection = store.state.viewer.model.selector.getSelection();
      let point = this.view3dToWorld(getBBBox(selection).getCenter());
      this.addNewTag('3d', point, null, true);
      store.commit('setIsPickingTag', false);
    }, 50);
  }
  editForgeTagElement(elem, options = {}) {
    const { sourcePanel = null } = options;
    store.dispatch('SHOW_PANEL', { tabIndex: PANEL_TAB.TAGS, pinned: true });
    store.dispatch('CLEAR_PREVIOUS_TAGS');
    store.commit('SET_EDITING_TAG', elem.clone());
    store.commit('setLastSelectedTagId', elem.id);
    // Track source panel for correct back navigation (clear if not provided)
    store.commit('TAGS_TYPES/SET_SOURCE_PANEL', sourcePanel);
    store.state.forgeService.updateAll3DIcons();
  }
  showEditScaffoldUI(scaffold, options = {}) {
    const { sourcePanel = null } = options;
    store.dispatch('SHOW_PANEL', { tabIndex: PANEL_TAB.TAGS, pinned: true });
    store.dispatch('CLEAR_PREVIOUS_TAGS');
    store.commit('SET_EDITING_TAG', scaffold.clone());
    store.commit('setLastSelectedTagId', scaffold.id);
    // Track source panel for correct back navigation (clear if not provided)
    store.commit('TAGS_TYPES/SET_SOURCE_PANEL', sourcePanel);
    store.state.forgeService.updateAll3DIcons();
  }
  showEditAnnotationUI(annotation, options = {}) {
    const { sourcePanel = null } = options;
    store.dispatch('SHOW_PANEL', { tabIndex: PANEL_TAB.TAGS, pinned: true });
    store.dispatch('CLEAR_PREVIOUS_TAGS');
    store.commit('SET_EDITING_TAG', annotation.clone());
    store.commit('setLastSelectedTagId', annotation.id);
    // Track source panel for correct back navigation (clear if not provided)
    store.commit('TAGS_TYPES/SET_SOURCE_PANEL', sourcePanel);
    store.state.forgeService.updateAll3DIcons();
  }
  showEditTagUI(tag, clearPrevious, options = {}) {
    const { sourcePanel = null } = options;
    store.dispatch('SHOW_PANEL', { tabIndex: PANEL_TAB.TAGS, pinned: true });
    if (clearPrevious) store.dispatch('CLEAR_PREVIOUS_TAGS');
    store.commit('SET_EDITING_TAG', tag.clone());
    store.commit('setLastSelectedTagId', tag.id);
    // Track source panel for correct back navigation (clear if not provided)
    store.commit('TAGS_TYPES/SET_SOURCE_PANEL', sourcePanel);
    store.state.forgeService.updateAll3DIcons();
  }
  /**
   * Show inspection info panel (standard Inspections)
   * Opens a separate panel beside Condition Map instead of overlaying
   * @param {ForgeInspection} tag - The inspection tag to display
   */
  showEditInspectionUI(tag) {
    // Set the editing state
    store.commit('SET_EDITING_AMIS_TAG', tag.clone());
    store.commit('SET_IS_AMIS_TAG_READ_ONLY', true);
    store.commit('setLastSelectedTagId', tag.id);

    // Open the separate inspection info panel (side-by-side architecture)
    store.dispatch('GENERAL/OPEN_PANEL', PANEL_IDS.INSPECTION_INFO);

    // Some entry paths (Global Search thumbnail-popup info icon, AVA Inspections
    // list rows) pass a sparse DTO that's missing fields like masterTagId.
    // Detect by the absence of the own-property and fetch the full DTO in the
    // background so the Monitoring tab cascade and other consumers see a
    // complete object. Fire-and-forget; the panel opens immediately and
    // upgrades when the full DTO arrives.
    if (tag && tag.id && !('masterTagId' in tag)) {
      store.dispatch('FETCH_INSPECTION_TAG_BY_ID', tag.id)
        .then((hydrated) => {
          const current = store.state.tags?.editingAMISTag;
          if (current && current.id === tag.id) {
            store.commit('SET_EDITING_AMIS_TAG', hydrated);
            debugLog(`showEditInspectionUI: hydrated sparse inspection ${tag.id} (masterTagId=${hydrated.masterTagId})`);
          }
        })
        .catch((err) => {
          debugError(`showEditInspectionUI: hydration failed for inspection ${tag.id}`, err);
        });
    }
  }

  /**
   * Show AMIS tag info panel (same as standard inspection)
   * Opens a separate panel beside Condition Map instead of overlaying
   * @param {ForgeInspection} tag - The AMIS tag to display
   */
  showEditAMISUI(tag) {
    store.dispatch('CLEAR_PREVIOUS_TAGS');

    // Set the editing state
    store.commit('SET_EDITING_AMIS_TAG', tag.clone());
    store.commit('SET_IS_AMIS_TAG_READ_ONLY', true);
    store.commit('setLastSelectedTagId', tag.id);

    // Open the separate inspection info panel (side-by-side architecture)
    store.dispatch('GENERAL/OPEN_PANEL', PANEL_IDS.INSPECTION_INFO);

    store.state.forgeService.updateAll3DIcons();
  }

  /**
   * Show AVA Inspect tag info panel
   * Opens a separate panel beside Condition Map instead of overlaying
   * @param {ForgeAvaInspect} tag - The AVA Inspect tag to display
   */
  showEditAvaInspectUI(tag) {
    // AVA inspection detail state is independent from standard inspection state.
    store.commit('SET_EDITING_AVA_INSPECT_TAG', tag.clone());
    store.commit('SET_IS_AVA_INSPECT_TAG_READ_ONLY', true);
    store.commit('setLastSelectedTagId', tag.id);

    // Open the separate AVA inspection info panel (side-by-side architecture)
    store.dispatch('GENERAL/OPEN_PANEL', PANEL_IDS.AVA_INSPECTION_INFO);

    store.state.forgeService?.update3dIconsInAllViews?.();
  }
  openTagInActivityManager(tag) {
    var type = 'tag';
    if (tag instanceof ForgeAnnotation) type = 'annotation';
    else if (tag instanceof ForgeScaffold) type = 'scaffold';
    else if (tag instanceof ForgeInspection) type = 'inspection';

    if (!store.getters['getIsRealityActivityManagerShown'])
      store.state.mainApp.selectActivityViewOption(2);

    let isTabShown = store.state.isTabShown;
    ForgeMessage.sendMessageToParent('pick-tag', {
      pickedTagId: tag.id,
      type: type,
      fullWidth: !isTabShown,
    });
  }
  getLevelElements(level) {
    return new Promise((resolve, reject) => {
      let viewer = store.state.viewer;

      if (!viewer || !level) return [];

      let result = [];

      try {
        let levelBox = level.getViewCropBox();

        getAllLeafComponents(viewer.model, (dbIds) => {
          dbIds.forEach((dbId) => {
            let box = getBBBox([dbId], viewer.model);
            let center = box.getCenter();
            if (levelBox.containsPoint(center)) {
              result.push(dbId);
            }
          });

          resolve(result);
        });
      } catch (error) {
        reject(error);
      }
    });
  }
  fillLevelsDbids(viewer, callback) {
    if (!viewer || !viewer.model) return;
    getAllLeafComponents(viewer.model, (dbIds) => {
      let allObjects = [];
      dbIds.forEach((dbId) => {
        let box = getBBBox([dbId], viewer.model);
        let center = box.getCenter();
        allObjects.push({ dbId: dbId, center: center });
      });
      store.state.levels.forEach((level) => {
        let levelBox = level.getViewCropBox();
        level.dbidsList = allObjects
          .filter((o) => levelBox.containsPoint(o.center))
          .map((o) => o.dbId);
      });
      if (callback) callback();
    });
  }
  getTagById(id) {
    return store.getters['getAllTags'].find((o) => o.id == id);
  }
  updateAllLinkedTagsWithTagLinks(updatedTag) {
    let existingTag = this.getTagById(updatedTag.id);

    let dbLinks = existingTag ? existingTag.linkedTagsList ?? [] : [];

    let newLinks = updatedTag.linkedTagsList ?? [];

    //add new added links
    for (let i = 0; i < newLinks.length; i++) {
      const id = newLinks[i];

      if (dbLinks.includes(id)) continue;

      let tag = this.getTagById(id);

      if (!tag || !(tag instanceof ForgeBaseTag)) continue;

      let links = tag.linkedTagsList ?? [];

      if (!links.includes(updatedTag.id)) {
        tag.createNewLink(updatedTag.id);
      }
    }

    //remove deleted link
    for (let i = 0; i < dbLinks.length; i++) {
      const id = dbLinks[i];

      if (newLinks.includes(id)) continue;

      let tag = this.getTagById(id);

      if (!tag || tag.linkedTagsList == null) continue;

      let links = tag.linkedTagsList ?? [];

      tag.removeLinkedTag(updatedTag.id);
    }
  }
  deleteTagLinksFromOtherTags(tag) {
    let links = tag.linkedTagsList != null ? tag.linkedTagsList : [];
    if (links.Count == 0) return;
    //add new added links
    for (let i = 0; i < links.length; i++) {
      const id = links[i];
      let linked = this.getTagById(id);
      if (!linked) continue;
      let linksIds = linked.linkedTagsList;
      if (linksIds == null) linksIds = [];
      let index = linksIds.indexOf(tag.id);
      linksIds.splice(index, 1);
      linked.linkedTagsList = linksIds;
    }
  }
  deleteAllTagsLinks(tags) {
    tags.forEach((removedTag) => {
      let links = removedTag.linkedTagsList;

      for (let i = 0; i < links.length; i++) {
        const id = links[i];

        let tag = this.getTagById(id);

        if (!tag) continue;

        tag.removeLinkedTag(removedTag.id);
      }
    });
  }

  //3d icons
  // `invalidate2DGeometry`: a tag moved or changed level at the same tag count, which the
  // count-keyed 2D cluster cache cannot detect. Plain redraws (zoom, toggles) keep the cache.
  update3dIconsInAllViews({ invalidate2DGeometry = false } = {}) {
    if (invalidate2DGeometry) this.getLabels2DExtension()?.invalidateTagGeometryCaches();
    this.updateAll3DIcons();
    this.updateAll2DIcons();
    if (this.panoramaViewer) {
      this.updateTagsAnnotationsInPanoViewer();
      this.update360ImagesHotspots();
    }
  }
  updateAll3DIcons() {
    if (!store.state.viewer || !store.state.viewer.model) return;
    let labelEx = this.getLabels3DExtension();
    if (labelEx) {
      labelEx.update360Images();
      labelEx.updateTags();
    }
    this.updateScaffoldin3D();
  }
  updateTagsIconsIn3D() {
    if (!store.state.viewer || !store.state.viewer.model) return;
    let labelEx = this.getLabels3DExtension();
    if (labelEx) {
      labelEx.update360Images();
      labelEx.updateTags();
    }
  }
  clearAll3D_2DIcons() {
    if (store.state.viewer && store.state.viewer.model) {
      this.getLabels3DExtension()?.clear360ImagesIcons();
      this.getLabels3DExtension()?.clear3DTags();
      store.state.viewer.impl.invalidate(true);
    }
    let labels2DEx = this.getLabels2DExtension();
    if (labels2DEx) {
      labels2DEx.clear360ImagesIcons();
      labels2DEx.clear3DTags();
      store.state.planViewer.impl.invalidate(true);
    }
  }
  /** Redraw only the 360 scan icons, in every open view (e.g. once the facility's scans arrive). */
  update360IconsInAllViews() {
    if (store.state.viewer?.model) this.getLabels3DExtension()?.update360Images();
    this.getLabels2DExtension()?.update360Images();
    if (this.panoramaViewer) this.update360ImagesHotspots();
  }
  updateAll2DIcons() {
    if (!store.state.planViewer || !this.getLabels2DExtension()) return;
    this.getLabels2DExtension()?.update360Images();
    this.getLabels2DExtension()?.updateTags();
  }
  updateScaffoldin3D() {
    let ext = store.state.forgeService.getScaffoldBoxExtension();

    if (ext) {
      ext.update();
    }
  }
  updateListWithEditingTag(list) {
    let isReadOnly = store.getters['GET_IS_TAG_READ_ONLY'];

    if (!isReadOnly) {
      let _tag = store.getters['GET_EDITING_TAG'];

      if (_tag && list.length && _tag.constructor === list[0].constructor) {
        list = [...list.filter((o) => o.id !== _tag.id), _tag];
      }
    }

    isReadOnly = store.getters['GET_IS_AMIS_TAG_READ_ONLY'];

    if (!isReadOnly) {
      let _tag_amis = store.getters['GET_EDITING_AMIS_TAG'];

      store.state.forgeService.updateAMISTagsColors([_tag_amis]);

      if (_tag_amis && list.length && _tag_amis.constructor === list[0].constructor) {
        list = [...list.filter((o) => o.id !== _tag_amis.id), _tag_amis];
      }
    }

    return list;
  }
  addCategoryColorToLabel(categoryName, label) {
    if (!categoryName) return;
    let category = store.state.categories.find((o) => o.name == categoryName);
    if (!category) return;
    let categCircle = document.createElement('div');
    categCircle.style.width = '13px';
    categCircle.style.height = '13px';
    categCircle.style.borderRadius = '10px';
    categCircle.style.marginLeft = '5px';
    categCircle.style.backgroundColor = category.color;
    label.appendChild(categCircle);
  }
  clearElementsByClassName(className) {
    let labels = document.getElementsByClassName(className);
    while (labels.length > 0) {
      labels[0].parentNode.removeChild(labels[0]);
    }
  }
  create3DIconToViewer(options) {
    let worldPosition = options.position;
    let width = options.width;
    let height = options.height;
    let rotation = options.rotation;
    let differences = options.differences;
    let title = options.title;
    let id = options.id;
    let className = options.className;
    let forgeViewer = options.forgeViewer;
    let onClick = options.onClick;
    let addContent = options.addContent;
    let removeTildeSign = options.removeTildeSign;
    let metadata = options.metadata;
    let linkType = options.linkType;
    let cmlId = options.cmlId;

    if (worldPosition == null) return;

    // Get color based on link type
    const linkColor = LINK_TYPE_COLORS[linkType] || LINK_TYPE_COLORS.default;

    // Function to lighten a hex color
    const lightenColor = (hex, percent) => {
      const num = parseInt(hex.replace('#', ''), 16);
      const r = Math.min(255, Math.floor((num >> 16) + (255 - (num >> 16)) * percent));
      const g = Math.min(255, Math.floor(((num >> 8) & 0x00FF) + (255 - ((num >> 8) & 0x00FF)) * percent));
      const b = Math.min(255, Math.floor((num & 0x0000FF) + (255 - (num & 0x0000FF)) * percent));
      return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
    };
    const linkColorLight = lightenColor(linkColor, 0.7);

    let label = document.createElement('div');
    label.setAttribute('data-id', id);
    label.setAttribute('data-x', worldPosition.x);
    label.setAttribute('data-y', worldPosition.y);
    label.setAttribute('data-z', worldPosition.z);
    if (width) label.setAttribute('data-width', width);
    if (height) label.setAttribute('data-height', height);
    if (rotation) label.setAttribute('data-rotation', rotation);
    if (metadata) label.setAttribute('data-metadata', metadata);
    if (linkType) label.setAttribute('data-tag-type', linkType);
    // CML/TML link → target CML id, so applyCmlConditionColorsToDocLinks can patch
    // the marker's condition color after the async coloring fetch resolves.
    if (cmlId) label.setAttribute('data-cml-id', cmlId);
    label.title = title;
    label.className = className;
    label.onclick = onClick;
    let elem = forgeViewer.container;
    if (!elem) return;
    elem.appendChild(label);

    if (addContent) {
      // Calculate position at start of center line (left edge, vertically centered)
      // Ensure we have a proper Vector3 for calculations
      let dotPosition = new THREE.Vector3(worldPosition.x, worldPosition.y, worldPosition.z || 0);

      if (width && height && rotation !== undefined) {
        // Calculate offset to left edge of rectangle along rotation direction
        const halfWidth = width / 2;
        const cosR = Math.cos(rotation);
        const sinR = Math.sin(rotation);
        dotPosition.x = worldPosition.x - halfWidth * cosR;
        dotPosition.y = worldPosition.y - halfWidth * sinR;
      }

      const clientPosition = forgeViewer.worldToClient(dotPosition);

      // Marker glyph. Unified vocabulary: circle = generic link, triangle = CML,
      // square = TML. Keeps the `.markup-link-dot` class in every case so the
      // positioning contract (updateLabelsPositionsByClassName → hasDot) still holds.
      // background-color starts as the link-type color; for CML/TML it is patched to
      // the condition color by applyCmlConditionColorsToDocLinks once loaded.
      let dot = document.createElement('div');
      dot.className = 'markup-link-dot';
      let dotShapeCss;
      if (linkType === 'CML') {
        // +50% vs the base dot, with a thin outline (drop-shadow follows the clipped
        // triangle — a border/box-shadow would be clipped away by clip-path).
        dotShapeCss = 'width: 21px; height: 20px; clip-path: polygon(50% 0%, 100% 100%, 0% 100%); filter: drop-shadow(0 0 1px rgba(0,0,0,0.8));';
      } else if (linkType === 'TML') {
        dotShapeCss = 'width: 18px; height: 18px; filter: drop-shadow(0 0 1px rgba(0,0,0,0.8));';
      } else {
        dotShapeCss = 'width: 8px; height: 8px; border-radius: 50%;';
      }
      dot.style.cssText = `
        position: absolute;
        ${dotShapeCss}
        background-color: ${linkColor};
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 3;
      `;
      label.appendChild(dot);

      // Different display for P&ID vs other types
      if (linkType === 'P&ID') {
        // Create first left chevron (<<) - outer
        let chevronLeft1 = document.createElement('div');
        chevronLeft1.className = 'markup-link-chevron-left-1';
        chevronLeft1.style.cssText = `
          position: absolute;
          width: 8px;
          height: 8px;
          border-left: 2px solid ${linkColor};
          border-bottom: 2px solid ${linkColor};
          left: 2px;
          top: 50%;
          transform: translateY(-50%) rotate(45deg);
          z-index: 2;
        `;
        label.appendChild(chevronLeft1);

        // Create second left chevron (<<) - inner
        let chevronLeft2 = document.createElement('div');
        chevronLeft2.className = 'markup-link-chevron-left-2';
        chevronLeft2.style.cssText = `
          position: absolute;
          width: 8px;
          height: 8px;
          border-left: 2px solid ${linkColor};
          border-bottom: 2px solid ${linkColor};
          left: 10px;
          top: 50%;
          transform: translateY(-50%) rotate(45deg);
          z-index: 2;
        `;
        label.appendChild(chevronLeft2);

        // Create first right chevron (>>) - inner
        let chevronRight1 = document.createElement('div');
        chevronRight1.className = 'markup-link-chevron-right-1';
        chevronRight1.style.cssText = `
          position: absolute;
          width: 8px;
          height: 8px;
          border-right: 2px solid ${linkColor};
          border-top: 2px solid ${linkColor};
          right: 10px;
          top: 50%;
          transform: translateY(-50%) rotate(45deg);
          z-index: 2;
        `;
        label.appendChild(chevronRight1);

        // Create second right chevron (>>) - outer
        let chevronRight2 = document.createElement('div');
        chevronRight2.className = 'markup-link-chevron-right-2';
        chevronRight2.style.cssText = `
          position: absolute;
          width: 8px;
          height: 8px;
          border-right: 2px solid ${linkColor};
          border-top: 2px solid ${linkColor};
          right: 2px;
          top: 50%;
          transform: translateY(-50%) rotate(45deg);
          z-index: 2;
        `;
        label.appendChild(chevronRight2);

        // Store original width/height for position updates
        if (width && height) {
          label.setAttribute('data-clientwidth', 44);
          label.setAttribute('data-clientheight', 20);
        }

        // Style the label container for dot+chevrons display
        label.style.cssText = `
          position: absolute;
          width: 44px;
          height: 20px;
          min-width: unset;
          border: none;
          background: transparent;
          cursor: pointer;
          left: ${Math.floor(clientPosition.x)}px;
          top: ${Math.floor(clientPosition.y)}px;
          transform: translate(-50%, -50%);
        `;

        // Create tooltip for tag name
        let tooltip = document.createElement('div');
        tooltip.className = 'markup-link-tooltip';
        tooltip.textContent = title;
        tooltip.style.cssText = `
          position: absolute;
          left: 100%;
          top: 50%;
          transform: translateY(-50%);
          padding: 4px 8px;
          background: ${linkColorLight};
          color: #000000;
          font-size: 12px;
          font-weight: 600;
          white-space: nowrap;
          border-radius: 4px;
          border: 1.5px solid ${linkColor};
          margin-left: 6px;
          opacity: 0;
          visibility: hidden;
          transition: opacity 0.2s, visibility 0.2s;
          z-index: 10;
          pointer-events: none;
        `;
        label.appendChild(tooltip);

        // Add hover effect for P&ID
        label.addEventListener('mouseenter', () => {
          label.style.filter = 'brightness(1.2)';
          tooltip.style.opacity = '1';
          tooltip.style.visibility = 'visible';
        });
        label.addEventListener('mouseleave', () => {
          label.style.filter = 'none';
          tooltip.style.opacity = '0';
          tooltip.style.visibility = 'hidden';
        });
      } else if (linkType === 'CML' || linkType === 'TML') {
        // CML triangle / TML square: the shape dot IS the marker — no target rings.
        // Keep the 28×28 dot-anchored container so it centers on the point exactly
        // like the generic circle markers (and stays out of the rectangle-resize
        // positioning branch via the .markup-link-dot class).
        if (width && height) {
          label.setAttribute('data-clientwidth', 28);
          label.setAttribute('data-clientheight', 28);
        }
        label.style.cssText = `
          position: absolute;
          width: 28px;
          height: 28px;
          min-width: unset;
          border: none;
          background: transparent;
          cursor: pointer;
          left: ${Math.floor(clientPosition.x)}px;
          top: ${Math.floor(clientPosition.y)}px;
          transform: translate(-50%, -50%);
        `;

        // Tooltip (border/bg patched to the condition color by the recolor pass).
        let tooltip = document.createElement('div');
        tooltip.className = 'markup-link-tooltip';
        tooltip.textContent = title;
        tooltip.style.cssText = `
          position: absolute;
          left: 100%;
          top: 50%;
          transform: translateY(-50%);
          padding: 4px 8px;
          background: ${linkColorLight};
          color: #000000;
          font-size: 12px;
          font-weight: 600;
          white-space: nowrap;
          border-radius: 4px;
          border: 1.5px solid ${linkColor};
          margin-left: 6px;
          opacity: 0;
          visibility: hidden;
          transition: opacity 0.2s, visibility 0.2s;
          z-index: 10;
          pointer-events: none;
        `;
        label.appendChild(tooltip);

        // Hover: scale the shape itself (no rings in this branch).
        label.addEventListener('mouseenter', () => {
          dot.style.transform = 'translate(-50%, -50%) scale(1.25)';
          tooltip.style.opacity = '1';
          tooltip.style.visibility = 'visible';
        });
        label.addEventListener('mouseleave', () => {
          dot.style.transform = 'translate(-50%, -50%) scale(1)';
          tooltip.style.opacity = '0';
          tooltip.style.visibility = 'hidden';
        });
      } else {
        // Create inner circle element (first ring around dot)
        let circleInner = document.createElement('div');
        circleInner.className = 'markup-link-circle-inner';
        circleInner.style.cssText = `
          position: absolute;
          width: 16px;
          height: 16px;
          border-radius: 50%;
          border: 2px solid ${linkColor};
          background: transparent;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          z-index: 2;
        `;
        label.appendChild(circleInner);

        // Create outer circle element (second ring around dot)
        let circleOuter = document.createElement('div');
        circleOuter.className = 'markup-link-circle-outer';
        circleOuter.style.cssText = `
          position: absolute;
          width: 24px;
          height: 24px;
          border-radius: 50%;
          border: 2px solid ${linkColor};
          background: transparent;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          z-index: 1;
        `;
        label.appendChild(circleOuter);

        // Store original width/height for position updates
        if (width && height) {
          label.setAttribute('data-clientwidth', 28);
          label.setAttribute('data-clientheight', 28);
        }

        // Style the label container for dot+circle display
        label.style.cssText = `
          position: absolute;
          width: 28px;
          height: 28px;
          min-width: unset;
          border: none;
          background: transparent;
          border-radius: 50%;
          cursor: pointer;
          left: ${Math.floor(clientPosition.x)}px;
          top: ${Math.floor(clientPosition.y)}px;
          transform: translate(-50%, -50%);
        `;

        // Create tooltip for tag name
        let tooltip = document.createElement('div');
        tooltip.className = 'markup-link-tooltip';
        tooltip.textContent = title;
        tooltip.style.cssText = `
          position: absolute;
          left: 100%;
          top: 50%;
          transform: translateY(-50%);
          padding: 4px 8px;
          background: ${linkColorLight};
          color: #000000;
          font-size: 12px;
          font-weight: 600;
          white-space: nowrap;
          border-radius: 4px;
          border: 1.5px solid ${linkColor};
          margin-left: 6px;
          opacity: 0;
          visibility: hidden;
          transition: opacity 0.2s, visibility 0.2s;
          z-index: 10;
          pointer-events: none;
        `;
        label.appendChild(tooltip);

        // Add hover effect
        label.addEventListener('mouseenter', () => {
          circleOuter.style.transform = 'translate(-50%, -50%) scale(1.2)';
          circleOuter.style.boxShadow = `0 0 8px ${linkColor}`;
          tooltip.style.opacity = '1';
          tooltip.style.visibility = 'visible';
        });
        label.addEventListener('mouseleave', () => {
          circleOuter.style.transform = 'translate(-50%, -50%) scale(1)';
          circleOuter.style.boxShadow = 'none';
          tooltip.style.opacity = '0';
          tooltip.style.visibility = 'hidden';
        });
      }

      if (differences != null) {
        let divTextX = document.createElement('div');
        divTextX.innerHTML = `<span>X</span> <span>${differences.x}</span>`;
        divTextX.className = 'tag-title text-diff-x';
        label.appendChild(divTextX);

        let divTextY = document.createElement('div');
        divTextY.innerHTML = `<span>Y</span> <span>${differences.y}</span>`;
        divTextY.className = 'tag-title text-diff-y';
        label.appendChild(divTextY);

        if (differences.z) {
          let divTextZ = document.createElement('div');
          divTextZ.innerHTML = `<span>Z</span> <span>${differences.z}</span>`;
          divTextZ.className = 'tag-title text-diff-z';
          label.appendChild(divTextZ);
        }
      }
    }
    return label;
  }
  updateLabelsPositionsByClassName(className, forgeViewer) {
    let labels = document.getElementsByClassName(className);
    for (let i = 0; i < labels.length; i++) {
      let label = labels[i];
      const worldPosition = new THREE.Vector3(
        parseFloat(label.getAttribute('data-x')),
        parseFloat(label.getAttribute('data-y')),
        parseFloat(label.getAttribute('data-z')),
      );

      let width = parseFloat(label.getAttribute('data-width'));
      let height = parseFloat(label.getAttribute('data-height'));
      let rotation = parseFloat(label.getAttribute('data-rotation')) || 0;

      // Check if this is a markup-link (dot+circle style)
      const hasDot = label.querySelector('.markup-link-dot');

      if (hasDot && width && height) {
        // Calculate position at start of center line (left edge, vertically centered)
        const halfWidth = width / 2;
        const cosR = Math.cos(rotation);
        const sinR = Math.sin(rotation);
        const dotWorldPosition = new THREE.Vector3(
          worldPosition.x - halfWidth * cosR,
          worldPosition.y - halfWidth * sinR,
          worldPosition.z
        );
        const clientPosition = forgeViewer.worldToClient(dotWorldPosition);

        label.style.left = `${Math.floor(clientPosition.x)}px`;
        label.style.top = `${Math.floor(clientPosition.y)}px`;
      } else if (hasDot) {
        // Icon-only mode (no width/height) — raw position + CSS transform handles centering
        const clientPosition = forgeViewer.worldToClient(worldPosition);
        label.style.left = `${Math.floor(clientPosition.x)}px`;
        label.style.top = `${Math.floor(clientPosition.y)}px`;
      } else {
        // Original rectangle positioning logic
        const clientPosition = forgeViewer.worldToClient(worldPosition);

        if (width && height) {
          const worldCornerNW = new THREE.Vector3(
            worldPosition.x - width / 2,
            worldPosition.y + height / 2,
            0,
          );
          const worldCornerSE = new THREE.Vector3(
            worldPosition.x + width / 2,
            worldPosition.y - height / 2,
            0,
          );
          const clientCornerNW = forgeViewer.worldToClient(worldCornerNW);
          const clientCornerSE = forgeViewer.worldToClient(worldCornerSE);
          const clientWidth = Math.abs(clientCornerNW.x - clientCornerSE.x);
          const clientHeight = Math.abs(clientCornerNW.y - clientCornerSE.y);
          label.setAttribute('data-clientwidth', clientWidth);
          label.setAttribute('data-clientheight', clientHeight);
          label.style.width = `${clientWidth}px`;
          label.style.height = `${clientHeight}px`;
        }

        //position label in the center of the box
        label.style.left = `${Math.floor(clientPosition.x - label.offsetWidth / 2)}px`;
        label.style.top = `${Math.floor(clientPosition.y - label.offsetHeight / 2)}px`;
        label.style.rotate = `${rotation}rad`;
      }
    }
  }
  toggleCrossHairCursorToViewer(isToggleOn, viewer) {
    if (isToggleOn) viewer.canvas.style.cursor = 'crosshair';
    else this.restoreViewerCursor(viewer);
  }

  restoreViewerCursor(viewer) {
    if (!viewer?.canvas) return;

    const MEASURE_CURSOR = 'url("data:image/png;base64,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"), auto';

    // Check active modes in priority order and restore the correct cursor
    if (store.getters['GET_IS_MEASURING'] || store.getters['GET_IS_MEASURING_AREA']) {
      const ext = viewer.getExtension?.('MeasurementExtension');
      if (ext?.isActive) {
        viewer.canvas.style.cursor = MEASURE_CURSOR;
        return;
      }
      // Area measurement uses the same cursor
      const planExt = viewer.getExtension?.('Plan2DExtension');
      if (planExt?.measuringAreaOn) {
        viewer.canvas.style.cursor = MEASURE_CURSOR;
        return;
      }
    }

    if (store.state.isPickingPin || store.state.isPickingCmlPoint) {
      viewer.canvas.style.cursor = 'crosshair';
      return;
    }

    // Default: Forge pointer cursor
    viewer.canvas.style.cursor =
      'url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAABHVBMVEUAAABPTk4AAAAAAAAJCQkRERE0MzQQEBAODg4QEBB4d3dbWlo9PDw/Pj4vLy8sLCwZGBgWFhYcHBwKCgoSEhIAAAAKCgoICAgKCgoQEBAODg4EBAQICAgPDw8REREMDAx2dnY0NDQvLy9QUFAaGhomJSYjIyM7OjokJCQNDA0mJiYNDQ0AAAAUFBQJCQkQEBAEBAQNDQ0PDw8VFRX///+amJkAAAD5+fnz8/PKycn9/f339vbi4eLR0dDNzMyAgIB8e3xycHH7+/vw7+/o6OjX1ta7urq4t7iwsLCnp6eioqKbmppva21OTk74+Pjl5eXc3Nzb29vLy8vDw8PDwsKrqqqdnZ2WlpaSkpKTkZKMiouEg4NkZGRISEgxLzBpgbsEAAAANHRSTlMA+fiQXgngKSYG/vX17uvBuqackpCNg3BpUkpAPBwTDvj18+vl0s/NwrOwoZZ+TDg4NBkBGrzX8QAAAP5JREFUKM99j9Vuw0AQRdeuKZyGkyZNmbnXDLHDVGb8/8/oy7paK1bO0+oc7WiGnGiaxq+QRTQAOh8f9Jv4H/Ge8PZPrCdlvkxfYluUT2WyyCq3mZ7unwlKVLcqOzA/Mf71j0TWJ/Ym6rPeca05Ni4iIevYc7yoUD2zQFhq71BdI9nvBeBabFDSPe8DswlUc1Riw3VxbH0NHBUPQ0jrbDnPYDjALQBMq9E7nkC5y7VDKTZlUg8Q0lmjvl74zlYErgvKa42GPKf3/a0kQmYCDY1SYMDosqMoiWrGwz/uAbNvc/fNon4kXRKGq+PUo2Mb96afV0iUxqGU2s4VBbKUP65NL/LKF+7ZAAAAAElFTkSuQmCC"),auto';
  }

  //Admin
  getForgeModels(assetId, callback) {
    if (!assetId) return null;

    HttpService.get({
      url: `api/assets/fetchAdminModel/?assetId=${assetId}`,
    })
      .then((response) => {
        callback(response.data);
      })
      .catch((error) => {
        debugError(error);
      });
  }
  saveMasterModel(assetId, modelName) {
    let encoded = encodeURIComponent(modelName);
    HttpService.post({
      url: `api/assets/editSelectedModel?assetId=${assetId}&selectedModel=${encoded}`,
      data: null,
    })
      .then((response) => {
        debugLog('Saved selected Model');
      })
      .catch((error) => {
        debugLog(error);
      });
  }
  saveSelectedLevel(assetId, levelName) {
    let encoded = encodeURIComponent(levelName);
    HttpService.post({
      url: `api/assets/editSelectedLevel?assetId=${assetId}&selectedLevel=${encoded}`,
      data: null,
    })
      .then((response) => {
        debugLog('Saved selected Level');
      })
      .catch((error) => {
        debugLog(error);
      });
  }
  deleteVersion(assetId, id, callback) {
    HttpService.delete({
      url: `api/forge/oss/objects?assetId=${assetId}&id=${id}&isSmallModel=false`,
    })
      .then((response) => {
        callback();
      })
      .catch((error) => {
        debugLog(error);
      });
  }
  saveSettings(assetId, settings, callback) {
    HttpService.post({
      url: `api/forge/settings/saveSettings`,
      data: {
        assetId: assetId,
        settings: settings,
      },
    })
      .then((response) => {
        callback();
      })
      .catch((error) => {
        debugLog(error);
      });
  }
  async saveUserSettings() {
    return HttpService.post({
      url: `api/forge/settings/saveUserSettings`,
      data: store.state.userSettings,
    })
      .catch((error) => {
        debugLog(error);
      });
  }
  uploadFileInChunks(file, assetId, versionInfo, onProgress) {
    return new Promise((resolve, reject) => {
      const chunkSize = 1024 * 1024 * 100; // 100 MB
      const fileSize = file.size;
      const chunks = Math.ceil(fileSize / chunkSize);
      let chunk = 0;
      let result = null;
      const uploadId = store.state.forgeService.generateUniqueId();

      function chunkUpload() {
        const start = chunk * chunkSize;
        const end = Math.min(fileSize, (chunk + 1) * chunkSize);
        const chunkFile = file.slice(start, end);
        const formData = new FormData();
        formData.append('fileToUpload', chunkFile);
        formData.append('assetId', assetId.toString());
        formData.append('isSmallModel', 'false');
        formData.append('isSvf2', versionInfo.isSvf2);
        formData.append('name', versionInfo.name);
        formData.append('version', versionInfo.version);
        formData.append('userUpdated', store.state.username);

        const xhr = new XMLHttpRequest();
        xhr.upload.addEventListener(
          'progress',
          (evt) => {
            if (evt.lengthComputable) {
              onProgress(start + evt.loaded, fileSize);
            }
          },
          false,
        );
        xhr.addEventListener('load', () => {
          if (xhr.status === 200) {
            result = xhr.responseText;
            if (++chunk < chunks) {
              chunkUpload();
            } else {
              resolve(JSON.parse(result));
            }
          } else {
            reject(xhr.statusText);
          }
        });
        xhr.addEventListener('error', () => {
          reject(xhr.statusText);
        });
        xhr.addEventListener('abort', () => {
          reject('Upload cancelled.');
        });
        xhr.open('POST', config.API_URL + 'api/assets/uploadModelChunks', true);
        xhr.setRequestHeader('Authorization', $getAuthHeaders().Authorization);
        xhr.setRequestHeader('Upload-Id', uploadId);
        xhr.setRequestHeader('File-Name', file.name);
        xhr.setRequestHeader('Chunk-Number', chunk + 1);
        xhr.setRequestHeader('Total-Chunks', chunks);
        xhr.send(formData);
      }

      chunkUpload();
    });
  }
  uploadFile(assetId, versionInfo, file, onProgress, callback) {
    let formData = new FormData();
    formData.append('fileToUpload', file);
    formData.append('assetId', assetId.toString());
    formData.append('isSmallModel', 'false');
    formData.append('isSvf2', versionInfo.isSvf2);
    formData.append('name', versionInfo.name);
    formData.append('version', versionInfo.version);
    formData.append('userUpdated', store.state.username);
    // const ctrl = new AbortController()    // timeout
    // setTimeout(() => ctrl.abort(), 5000);
    HttpService.post({
      url: `api/assets/uploadModel`,
      data: formData,
      // signal: ctrl.signal,
      headers: {
        'Content-Type': false,
        processData: false,
      },
      onUploadProgress: function (progressEvent) {
        if (progressEvent.event.lengthComputable) {
          onProgress(progressEvent.loaded, progressEvent.total);
        }
      },
    })
      .then((response) => {
        callback(response.data);
      })
      .catch((error) => {
        debugLog(error);
      });
  }

  uploadVersionToAsset(uploadInChunks, assetId, versionInfo, file, onProgress, callback, onError) {
    if (uploadInChunks) {
      store.state.forgeService
        .uploadFileInChunks(file, assetId, versionInfo, onProgress)
        .then((result) => {
          if (callback) callback(result);
        })
        .catch((error) => {
          debugLog(error);
          if (onError) onError(error);
        });
    } else {
      store.state.forgeService.uploadFile(assetId, versionInfo, file, onProgress, callback);
    }
  }

  generateUniqueId() {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let id = '';
    for (let i = 0; i < 10; i++) {
      id += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return id;
  }

  //Azure storage
  getClientURL(containerName, sasToken, callBack) {
    HttpService.get({
      url: `api/blobStorage/getSasToken`,
    })
      .then((response) => {
        const token = response.token;
        const url = `${store.state.pointCloudContainer}?${token.token}`;
        const containerClient = new ContainerClient(url, new AnonymousCredential());
        callBack(containerClient);
      })
      .catch((error) => {
        debugLog(error);
      });
  }

  async getSignedContainerUrl() {
    return new Promise((resolve, reject) => {
      HttpService.get({
        url: `api/BlobStorage/signedContainerUrl`
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          debugLog(error);
          reject(error);
        });
    });
  }

  async uploadPointCloud(files, pointCloudName, assetId, abortController, onFileStartUpload, onProgress, onComplete, updatePointClouds) {
    try {
      let pcFileCount = 0;
      for (let i = 0; i < files.length; i++) {
        let file = files[i];
        if (file.name == 'cloud.js' || file.name == 'metadata.json') pcFileCount++;
      }

      if (pcFileCount == 0) {
        Vue.prototype.$dialog.notify.warning('File cloud.js OR metadata.json not found.');
        return;
      }

      if (pcFileCount > 1) {
        Vue.prototype.$dialog.notify.warning('Found more than one instance of cloud.js OR metadata.json');
        return;
      }

      let guid = $uuidv4();
      let signedContainerUrl = await this.getSignedContainerUrl();

      let sortedFiles = Array.from(files).sort((a, b) => {
        if (a.name === 'cloud.js' || a.name === 'metadata.json') return -1;
        if (b.name === 'cloud.js' || b.name === 'metadata.json') return 1;
        return a.size - b.size;
      });

      let pointCloudModel = null;
      const maxRetries = 3;
      const maxBlockSize = 100 * 1024 * 1024; // 100MB max block size

      for (let file of sortedFiles) {
        let blobServiceClient = new BlobServiceClient(signedContainerUrl);
        let containerClient = blobServiceClient.getContainerClient(``);
        let blockBlobClient = containerClient.getBlockBlobClient(`Reality/${assetId}/pointClouds/${guid}-${file.webkitRelativePath}`);

        onFileStartUpload(file);

        // Calculate optimal block size based on file size
        let blockSize = Math.min(maxBlockSize, Math.ceil(file.size / 40000)); // Ensure blocks <= 50000
        blockSize = Math.max(blockSize, 4 * 1024 * 1024); // Minimum 4MB

        let retryCount = 0;
        let uploadSuccess = false;

        while (!uploadSuccess && retryCount < maxRetries) {
          try {
            await blockBlobClient.uploadData(file, {
              onProgress: (e) => {
                e.size = file.size;
                e.name = file.name;
                onProgress(e);
              },
              abortSignal: abortController.signal,
              blockSize: blockSize,
              concurrency: 5,
              maxSingleShotSize: maxBlockSize
            });
            uploadSuccess = true;
          } catch (error) {
            retryCount++;
            if (retryCount >= maxRetries) {
              throw new Error(`Failed to upload file ${file.name} after ${maxRetries} attempts: ${error.message}`);
            }
            debugWarn(`Retry ${retryCount}/${maxRetries} for file ${file.name}`);
            await new Promise(resolve => setTimeout(resolve, 1000 * retryCount)); // Exponential backoff
          }
        }

        if (file.name === 'cloud.js' || file.name === 'metadata.json') {
          let cloudJsUrl = blockBlobClient.url.split('?')[0];
          await this.uploadPointCloudjsFile(cloudJsUrl, assetId, pointCloudName, (pointcloude) => {
            pointCloudModel = pointcloude;
            updatePointClouds(pointCloudModel);
          });
        }
      }

      onComplete(pointCloudModel);
      debugLog('All files uploaded successfully');
    } catch (error) {
      debugError('Error uploading point cloud:', error);
      throw error;
    }
  }

  uploadPointCloudjsFile(url, assetId, name, callback) {
    return new Promise((resolve, reject) => {
      let formData = new FormData();
      formData.append('assetId', assetId.toString());
      formData.append('name', name);
      formData.append('cloudJsUrl', url);

      const ctrl = new AbortController(); // timeout
      setTimeout(() => ctrl.abort(), 5000);

      HttpService.post({
        url: `api/upload/pointCloud/cloudjsFile`,
        data: formData,
        headers: {
          'Content-Type': false,
          processData: false,
        },
      })
        .then((response) => {
          callback(response.data);
          resolve(response.data);
        })
        .catch((error) => {
          debugLog(error);
          reject(error);
        });
    });
  }
  addPointCloudUrlToMongo(assetId, name, url, callback) {
    let data = { assetId: assetId, name: name, url: url, user: store.state.username };
    const ctrl = new AbortController(); // timeout
    setTimeout(() => ctrl.abort(), 5000);
    HttpService.post({
      url: `api/mongo/addPointCloudUrl`,
      data: data,
    })
      .then((response) => {
        callback(response.data);
      })
      .catch((error) => {
        debugLog(error);
      });
  }
  addPointCloudFolder(assetId, url, callback) {
    let data = { assetId: assetId, url: url, user: store.state.username };
    const ctrl = new AbortController(); // timeout
    setTimeout(() => ctrl.abort(), 5000);
    HttpService.post({
      url: `api/forge/addPointCloudFolder`,
      data: data,
    })
      .then((response) => {
        callback(response.data);
      })
      .catch((error) => {
        debugLog(error);
      });
  }
  deletePointCloud(pointCloudModel, onProgress, onDone) {
    let _this = this;
    this.getClientURL(async (containerClient) => {
      let pointCloudUrl = decodeURIComponent(pointCloudModel.url);
      pointCloudUrl = pointCloudUrl.replace(store.state.pointCloudContainer + '/', '');
      let endWordLength = pointCloudUrl.endsWith('/cloud.js')
        ? '/cloud.js'.length
        : '/metadata.json'.length;
      pointCloudUrl = pointCloudUrl.substring(0, pointCloudUrl.length - endWordLength);
      let options = {
        prefix: pointCloudUrl,
      };
      let marker = undefined;
      do {
        const listBlobsResponse = await containerClient.listBlobsFlat(options);
        marker = listBlobsResponse.nextMarker;
        const items = listBlobsResponse.segment.blobItems;
        let doneFiles = 0;
        onProgress(doneFiles, items.length);
        for await (const blob of containerClient.listBlobsFlat(options)) {
          await containerClient.deleteBlob(blob.name);
          doneFiles++;
          onProgress(doneFiles, items.length);
        }

        _this.deletePointCloud_Mongo(pointCloudModel.id, () => {
          onDone();
        });
      } while (marker);
    });
  }
  deletePointCloud_Mongo(id, callback) {
    HttpService.post({
      url: `api/mongo/delete/pointCloud?id=${id}`,
      data: null,
    })
      .then((response) => {
        callback(response.data);
      })
      .catch((error) => {
        debugLog(error);
      });
  }
  deletePointClouds(ids) {
    HttpService.post({
      url: `api/pointClouds/deleteAll`,
      data: { ids: ids },
    })
      .then((response) => {
        debugLog(response.data);
        if (response.data === true) {
          store.dispatch('ADMIN/SET_IS_POINT_CLOUDS_DELETED', response.data);
        }
      })
      .catch((error) => {
        debugLog(error);
      });
  }
  openNearest360ToPoint(point, callback) {
    if (!store.state.viewer) return;

    let isImageLoaded = false;

    let closestImage = store.state.forgeService.getClosestImageToPoint(point);

    if (closestImage) {
      if (!store.state.forgeService.panoramaViewer) {
        store.state.mainApp.openViewPageWithType('360');
      } else {
        store.state.mainApp.showViewPageWithType('360');
      }
      setTimeout(() => {
        if (closestImage != store.state.selectedImage) {
          store.state.forgeService.launchPanoViewer(closestImage);
          if (store.state.viewer) store.state.forgeService.navigateIn3D(closestImage);
        } else {
          isImageLoaded = true;
        }

        if (callback) callback(isImageLoaded);
      }, 100);
    }
  }
  /**
   * Opens the 360 scan that belongs to a tag and runs `callback` once it is on screen.
   *
   * Resolution ladder for a tag carrying `linked360ImageInfo` (mirrors
   * `zoomToTagByScanPosition`): loaded projects of the current facility -> API refetch
   * by id -> nearest scan to the tag's point. A stale, foreign or deleted image id
   * therefore degrades to the nearest scan instead of a dead end.
   *
   * @param {ForgeBaseTag} tag - Tag to open a 360 for.
   * @param {Function} [callback] - Invoked exactly once, with the opened image.
   */
  async openNearest360ToTag(tag, callback) {
    let closestImage = null;
    let linked360ImageInfo = tag.linked360ImageInfo;
    let callbackFired = false;

    // The open callback used to be registered for the 360 load AND invoked inline
    // right after, so every fresh load ran it twice. Both paths go through here now.
    let fireOpenCallback = (reason) => {
      if (callbackFired) {
        debugLog('[Open360] Duplicate open callback suppressed:', reason);
        return;
      }

      callbackFired = true;
      debugLog('[Open360] Open callback fired once:', reason, closestImage?.name);

      if (callback) callback(closestImage);
    };

    let openClosetImage = () => {
      if (closestImage) {
        if (!store.state.forgeService.panoramaViewer) {
          store.state.mainApp.openViewPageWithType('360');
        } else {
          store.state.mainApp.showViewPageWithType('360');
        }
        setTimeout(() => {
          // Compare by id, not identity: a scan recovered by the refetch rung below is
          // a different object than the one the store holds for the same scan.
          let isAlreadyOpened = !!closestImage.id && store.state.selectedImage?.id === closestImage.id;

          if (!isAlreadyOpened) {
            store.commit('setLoad360ViewerCallback', () => fireOpenCallback('panorama loaded'));

            store.state.forgeService.launchPanoViewer(closestImage);

            if (store.state.viewer) store.state.forgeService.navigateIn3D(closestImage);
          } else {
            // Scan already open (launchPanoViewer skipped, loadHandler won't run):
            // release the cross-facility 360 zoom overlay immediately. No-op for
            // non-zoom flows (flag is already false).
            store.commit('setPending360Zoom', false);

            fireOpenCallback('scan already open');
          }
        }, 100);
      } else {
        // No nearby scan resolved: nothing mounts, so release the cross-facility
        // 360 zoom overlay (MainView pending360Zoom) here rather than leaving it
        // to the watchdog. No-op for non-zoom flows (flag is already false).
        store.commit('setPending360Zoom', false);
      }
    };

    if (linked360ImageInfo?.imageId) {
      closestImage = (store.state.projects || [])
        .flatMap((o) => o.images || [])
        .find((img) => img.id == linked360ImageInfo.imageId);

      if (closestImage) {
        debugLog('[Open360] Linked scan resolved from loaded projects:', closestImage.name);
      } else {
        debugLog(
          '[Open360] Linked scan missing from loaded projects, refetching:',
          linked360ImageInfo.imageId,
        );

        try {
          const { data } = await images360Service.getById(
            linked360ImageInfo.imageId,
            store.state.assetId,
          );
          if (data) {
            closestImage = Image360.fromDTO(data);
            debugLog('[Open360] Linked scan refetched from API:', closestImage.name);
          }
        } catch (err) {
          debugLog('[Open360] API lookup failed for linked scan:', linked360ImageInfo.imageId, err);
        }
      }

      if (!closestImage) {
        closestImage = store.state.forgeService.getClosestImageToPoint(tag.getPointInView());
        debugLog(
          '[Open360] Linked scan unresolvable in this facility, using nearest scan:',
          closestImage?.name ?? 'none available',
        );
      }
    } else {
      closestImage = store.state.forgeService.getClosestImageToPoint(tag.getPointInView());
      debugLog('[Open360] Tag has no linked scan, using nearest scan:', closestImage?.name ?? 'none available');
    }

    // else if (viewer) {
    //     // let point = tag instanceof ForgeScaffold ? tag.position : tag.point;
    //     closestImage = store.state.forgeService.getClosestImageToPoint(tag.getPointInView());
    // } else if (store.state.selectedImage) {
    //     debugger
    //     closestImage = store.state.forgeService.getClosestImageToPoint(tag.getPointInView());
    // } else {
    //     store.commit("setShowLoading", true);

    //     let index = mainApp.openViewPageWithType('3d');

    //     let isModelLoaded = () => viewer?.model?.getInstanceTree();

    //     waitForValue(isModelLoaded, 60000)
    //         .then(() => {
    //             closestImage = store.state.forgeService.getClosestImageToPoint(tag.getPointInView());
    //             dispose3DViewer();
    //             openClosetImage();
    //         })
    //         .catch((e) => {
    //             console.log(e);
    //             store.dispatch("alert_Forge", {
    //                 message: 'Please open 3d viewer or 360 Image first'
    //             })
    //         })
    //         .finally(() => {
    //             mainApp[`view${index}Type`] = '';
    //             mainApp[`isView${index}Visible`] = false;
    //             store.commit("setShowLoading", false);
    //         });

    //     return;
    // }

    openClosetImage();
  }
  getComparasionModeFOV(fov) {
    return fov * 0.6;
  }
  /**
 * Converts the panorama's horizontal field of view (HFOV) to the 3D viewer's vertical FOV (VFOV).
 * The conversion is based on an empirical calibration done at 1600x900 resolution (100% scale)
 * with an aspect ratio of 2.212766. The calibrated polynomial is:
 *
 *     polyValue = 0.0025 * (HFOV)² + 0.2835 * HFOV + 3.1799
 *
 * and the final vertical FOV is computed as:
 *
 *     VFOV = (polyValue * 2.212766) / currentAspectRatio
 *
 * @param {number} panoramaHFov - The horizontal FOV from the panorama viewer (in degrees)
 * @returns {number} - The vertical FOV (in degrees) to use in the 3D viewer
 */
  get3dVFovFormPanoramaHFov_v1(panoramaHFov) {
    // Get the current aspect ratio from the viewer's state.
    // If for some reason it's not available, default to 16:9 (i.e. 1.7778)
    const viewerState = store.state.viewer.getState();
    const aspectRatio = (viewerState && viewerState.viewport && viewerState.viewport.aspectRatio)
      ? viewerState.viewport.aspectRatio
      : (16 / 9);

    // Calculate the calibrated polynomial value based on the HFOV.
    const polyValue = 0.0025 * Math.pow(panoramaHFov, 2) + 0.2835 * panoramaHFov + 3.1799;

    // Calibration factor determined at 1600x900 resolution
    const calibrationFactor = window.calibrationFactor ?? 2.212766;

    // Compute the final vertical FOV, adjusting for the current aspect ratio.
    const verticalFov = (polyValue * calibrationFactor) / aspectRatio;

    return verticalFov;
  }

  get3dVFovFormPanoramaHFov(panoramaHFOV) {
    // y = 0.0025x2 + 0.2835x + 3.1799
    // this equation is calculated with resolution 1600x900 and scale 100%
    // aspect ratio for 3d viewer in this calculated equation is 2.212766

    let aspectRatio = store.state.viewer.getState().viewport.aspectRatio;

    const calibrationFactor = window.calibrationFactor ?? 2.212766;

    return (
      ((0.0025 * panoramaHFOV * panoramaHFOV + 0.2835 * panoramaHFOV + 3.1799) * calibrationFactor) /
      aspectRatio
    );
  }
  mapPanoramaHFovTo3dVHov() {
    let fov = store.state.forgeService.panoramaViewer.getHfov();
    if (store.state.mainApp.localShowComparasionTool) {
      let vFov = this.get3dVFovFormPanoramaHFov(fov);
      store.state.viewer.navigation.setVerticalFov(vFov);
    } else {
      store.state.viewer.navigation.setFocalLength(store.state.viewer.navigation.fov2fl(fov));
    }
  }
  isHFovInBounds(hFov) {
    if (!this.panoramaViewer) return false;

    let bounds = this.panoramaViewer.getHfovBounds();
    let min = bounds[0];
    let max = bounds[1];

    return hFov >= min && hFov <= max;
  }
  formatValueToDisplayUnit(value) {
    if (!value) return '';

    return formatLength(value, store.state.userSettings.displaySettings.displayUnits);
  }
  isUSUnit(unit) {
    let usUnits = ['decimal-ft', 'ft-and-fractional-in', 'ft-and-decimal-in', 'decimal-in'];
    if (usUnits.includes(store.state.userSettings.displaySettings.displayUnits)) {
      return true;
    }
    return false;
  }
  loadFilteredTags(assetId, searchText, reload, allProperties, types, sortProperty, ascending) {
    let date = new Date().getTime();

    this.lastLoadFilteredTags = date;

    return new Promise((resolve, reject) => {
      if (reload) store.commit('SET_FILTERED_TAGS', []);
      let currentCount = reload ? 0 : store.getters['GET_FILTERED_TAGS'].length;
      let text = searchText ? btoa(searchText) : '';

      let dataJson = {
        assetId: assetId,
        userId: store.state.userId,
        searchText64: text,
        index: currentCount,
        range: 50,
        types: types ?? '',
        sortProperty: sortProperty ?? 'Name',
        ascending: ascending ?? true,
        allProperties: allProperties,
      };

      HttpService.post({
        url: `api/tags/getFilteredTags`,
        data: dataJson,
      })
        .then((response) => {
          if (this.lastLoadFilteredTags != date) return;

          let tags = [];

          response.data.forEach((t) => {
            switch (t.discriminator) {
              case 'ForgeScaffold':
                t = Object.assign(new ForgeScaffold(), t);
                t.position = Object.assign(new THREE.Vector3(), t.position);
                t.scale = Object.assign(new THREE.Vector3(), t.scale);
                t.max = Object.assign(new THREE.Vector3(), t.max);
                t.attachments = ForgeAttachment.parseAttachments(t.attachments);
                t.parseComments();
                break;
              case 'ForgeAnomaly':
                t = Object.assign(new ForgeAnomaly(), t);
                t.parseContent();
                break;
              case 'ForgeEquipment':
                t = Object.assign(new ForgeEquipment(), t);
                t.parseContent();
                break;
              case 'ForgePipeline':
                t = Object.assign(new ForgePipeline(), t);
                t.parseContent();
                break;
              case 'ForgeStructural':
                t = Object.assign(new ForgeStructural(), t);
                t.parseContent();
                break;
              case 'ForgeInspection':
                t = Object.assign(new ForgeInspection(), t);
                t.parseContent();
                break;
              case 'ForgeAnnotation':
                t = Object.assign(new ForgeAnnotation(), t);
                t.parseContent();
                break;
              default:
                break;
            }

            tags.push(t);
          });

          if (reload) store.commit('SET_FILTERED_TAGS', tags);
          else store.commit('SET_FILTERED_TAGS', store.getters['GET_FILTERED_TAGS'].concat(tags));

          resolve(tags);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  loadPipelinesTags(assetId, searchText, reload, allProperties) {
    return new Promise((resolve, reject) => {
      if (reload) store.commit('SET_PIPELINES_TAGS', []);

      let currentCount = reload ? 0 : store.getters['GET_PIPELINES_TAGS'].length;
      let text = searchText ? btoa(searchText) : '';
      HttpService.get({
        url: `api/tags/pipeline/fetchPipelines?assetId=${assetId}&searchText64=${text}&index=${currentCount}&range=20&allProperties=${allProperties}`,
      })
        .then((response) => {
          let result = response.data;
          let tags = result.tags.map((o) => Object.assign(new ForgePipeline(), o));
          tags.forEach((o) => o.parseContent());
          if (reload) {
            store.commit('SET_PIPELINES_TAGS_COUNT', result.count);
            store.commit('SET_FILTERED_PIPELINES_TAGS_IDS', result.dbIds ?? []);
            store.commit('SET_PIPELINES_TAGS', tags);
          } else {
            store.commit('SET_PIPELINES_TAGS', store.getters['GET_PIPELINES_TAGS'].concat(tags));
          }
          resolve(tags);
        })
        .catch((error) => {
          debugError(error);
          reject(error);
        });
    });
  }
  loadStructuralTags(assetId, searchText, reload, allProperties) {
    return new Promise((resolve, reject) => {
      if (reload) store.commit('SET_STRUCTURAL_TAGS', []);

      let currentCount = reload ? 0 : store.getters['GET_STRUCTURAL_TAGS'].length;
      let text = searchText ? btoa(searchText) : '';
      HttpService.get({
        url: `api/tags/structural/fetchStructural?assetId=${assetId}&searchText64=${text}&index=${currentCount}&range=20&allProperties=${allProperties}`,
      })
        .then((response) => {
          let result = response.data;
          let tags = result.tags.map((o) => Object.assign(new ForgeStructural(), o));
          tags.forEach((o) => o.parseContent());
          if (reload) {
            store.commit('SET_STRUCTURAL_TAGS_COUNT', result.count);
            store.commit('SET_FILTERED_STRUCTURAL_TAGS_IDS', result.dbIds ?? []);
            store.commit('SET_STRUCTURAL_TAGS', tags);
          } else {
            store.commit('SET_STRUCTURAL_TAGS', store.getters['GET_STRUCTURAL_TAGS'].concat(tags));
          }
          resolve(tags);
        })
        .catch((error) => {
          debugError(error);
          reject(error);
        });
    });
  }
  loadAutomaticTags(assetId, searchText, reload, allProperties, callback) {
    if (reload) store.commit('SET_AUTOMATIC_TAGS', []);
    let currentCount = reload ? 0 : store.getters['GET_AUTOMATIC_TAGS'].length;
    let text = searchText ? btoa(searchText) : '';
    return HttpService.get({
      url: `api/equipments/fetchAutomaticEquipments?assetId=${assetId}&searchText64=${text}&index=${currentCount}&range=20&allProperties=${allProperties}`,
    })
      .then((response) => {
        let res = response.data;
        store.commit('SET_AUTOMATIC_TAGS_COUNT', res.totalResult);
        store.commit('SET_FILTERED_AUTOMATIC_TAGS_IDS', res.allEquipmentsIds);
        let tags = res.equipments.map((o) => Object.assign(new ForgeEquipment(), o));
        tags.forEach((o) => o.parseContent());
        if (reload) store.commit('SET_AUTOMATIC_TAGS', tags);
        else store.commit('SET_AUTOMATIC_TAGS', store.getters['GET_AUTOMATIC_TAGS'].concat(tags));
        if (callback) callback(res);
      })
      .catch((error) => {
        debugLog(error);
      });
  }
  loadAMISInspectionBySearch(assetId, searchText, reload, allProperties) {
    return new Promise((resolve, reject) => {
      let text = searchText ? btoa(searchText) : '';
      let isAMIS = store.state.forgeSettings?.isAMIS;
      let index = reload ? 0 : store.state.inspections.length;
      HttpService.get({
        url: `api/AMIS/fetchAMISInspections?assetId=${assetId}&fetched=${isAMIS}&searchText64=${text}&index=${index}&range=20&allProperties=${allProperties}`,
      })
        .then((response) => {
          let fetchedInspections = response.data;
          fetchedInspections.inspections = fetchedInspections.inspections.map((o) =>
            Object.assign(new ForgeInspection(), o),
          );
          fetchedInspections.inspections.forEach((o) => o.parseContent());
          if (reload) store.state.inspections = fetchedInspections.inspections;
          else store.state.inspections = [...store.state.inspections, ...fetchedInspections.inspections];
          resolve(fetchedInspections);
        })
        .catch((error) => {
          debugLog(error);
          reject(error);
        });
    });
  }
  buildInspectionTree(objects) {
    const tree = { id: 'root', name: 'Inspection Tree', children: [] };

    const cl = { id: 'corrosion_loop', name: 'Corrosion Loop', children: [] };
    const fc = { id: 'fluid_classification', name: 'Fluid Classification', children: [] };

    objects.forEach((obj) => {
      // Handling Corrosion Loop

      const clKey1 = obj.clNo1;

      if (clKey1) {
        const clId1 = `cl_${clKey1}`;

        let clNode1 = cl.children.find((node) => node.id === clId1);

        if (!clNode1) {
          clNode1 = { id: clId1, name: clKey1, checked: false, children: [] };
          cl.children.push(clNode1);
        }

        clNode1.children.push(obj);
      }

      const clKey2 = obj.clNo2;

      if (clKey2) {
        const clId2 = `cl_${clKey2}`;

        let clNode2 = cl.children.find((node) => node.id === clId2);

        if (!clNode2) {
          clNode2 = { id: clId2, name: clKey2, checked: false, children: [] };
          cl.children.push(clNode2);
        }

        clNode2.children.push(obj);
      }

      if (!clKey1 && !clKey2) {
        const clId = `cl__blank`;
        let clNode = cl.children.find((node) => node.id === clId);
        if (!clNode) {
          clNode = { id: clId, name: '_blank', checked: false, children: [] };
          cl.children.push(clNode);
        }
        clNode.children.push(obj);
      }

      // Handling Fluid Classification

      const fcKey1 = obj.fluidClassification1;

      if (fcKey1) {
        const fcId1 = `fc_${fcKey1}`;

        let fcNode1 = fc.children.find((node) => node.id === fcId1);

        if (!fcNode1) {
          fcNode1 = { id: fcId1, name: fcKey1, checked: false, children: [] };
          fc.children.push(fcNode1);
        }

        fcNode1.children.push(obj);
      }

      const fcKey2 = obj.fluidClassification2;

      if (fcKey2) {
        const fcId2 = `fc_${fcKey2}`;

        let fcNode2 = fc.children.find((node) => node.id === fcId2);

        if (!fcNode2) {
          fcNode2 = { id: fcId2, name: fcKey2, checked: false, children: [] };
          fc.children.push(fcNode2);
        }

        fcNode2.children.push(obj);
      }

      if (!fcKey1 && !fcKey2) {
        const fcId = `fc__blank`;
        let fcNode = fc.children.find((node) => node.id === fcId);
        if (!fcNode) {
          fcNode = { id: fcId, name: '_blank', checked: false, children: [] };
          fc.children.push(fcNode);
        }
        fcNode.children.push(obj);
      }
    });

    if (cl.children.length) tree.children.push(cl);
    if (fc.children.length) tree.children.push(fc);

    return tree;
  }
  loadInspectionTagsAdvanced(searchText, reload) {
    store.state.TAGS.isLoadingAMISTags = true;

    let requestDate = Date.now();

    store.commit('SET_LAST_AMIS_ADVANCED_FETCH_DATE', requestDate);

    if (reload) store.commit('SET_AMIS_TAGS', []);

    let fetched = store.state.forgeSettings?.isAMIS;

    let currentCount = reload ? 0 : store.getters['GET_AMIS_TAGS'].length;

    let text = searchText ? btoa(searchText) : '';

    let masterTypes = [];

    if (!store.state.forgeSettings?.isAMIS) {
      masterTypes = store.getters['GET_SELECTED_MASTER_TYPE_OPTIONS'];
    }

    let sorting = store.state.TAGS.sortingData.find((t) => t.isSelected);
    let data = {
      assetId: store.state.assetId,
      fetched: fetched,
      orderBy: {
        property: sorting?.id ?? 'Name',
        ascending: sorting?.isAsc ?? true,
      },
      searchText64: text,
      searchIndex: currentCount,
      searchRange: 50,
      MasterTypes: masterTypes,
      selectedFilter: store.getters.GET_SELECTED_INSPECTION_PROPERTY_FILTER_INDEX,
      ids: store.getters.GET_INSPECTION_IDS_FILTER,
      reloading: reload,
      masterTagId: store.state.TAGS.selectedMasterTagId,
    };

    // Custom property filters
    data['customFilters'] = (store.state.TAGS.customFilters || [])
        .filter(f => isCustomFilterActive(f))
        .map(f => ({
            property: f.property,
            values: f.values || [],
            searchText: f.searchText || '',
            dateFrom: f.dateFrom || null,
            dateTo: f.dateTo || null,
            min: f.min != null ? f.min : null,
            max: f.max != null ? f.max : null,
        }));

    // Inspections (legacy/imported) filters payload (only when explicitly selected)
    const { inspections: sendInspections, avaInspections: sendAva } = store.state.TAGS.filterSources || { inspections: true, avaInspections: true };
    // Include sources array (enum values) for backend awareness
    const { FilterSource } = require('@/features/Dashboard/config/enums.js');
    const sources = [];
    if (sendInspections) sources.push(FilterSource.Inspections);
    if (sendAva) sources.push(FilterSource.AvaInspections);
    data['sources'] = sources;
    const inspectionsSelectedFilterName = store.state.TAGS.InspectionsSelectedFilter || store.state.TAGS.InspectionSelectedFilter;
    const inspectionsSelectedColorOptions = store.state.TAGS.inspectionsSelectedColorOptions || store.state.TAGS.selectedColorOptions || [];
    if (sendInspections && inspectionsSelectedFilterName && inspectionsSelectedFilterName !== 'No Filter' && inspectionsSelectedColorOptions.length) {
      // numeric index for selectedFilter
      data['selectedFilter'] = store.getters.GET_SELECTED_INSPECTION_PROPERTY_FILTER_INDEX;
      data['filters'] = inspectionsSelectedColorOptions.map((o) => {
        return {
          filterValue1: o.judgCrr1?.toString()?.includes('∞') ? 10e5 : o.judgCrr1,
          compareSign1: o.judgMkr1?.trim(),
          filterValue2: o.judgCrr2?.toString()?.includes('-∞') ? -10e5 : o.judgCrr2,
          compareSign2: o.judgMkr2?.trim(),
        };
      });
    }

    // AVA Inspections filters payload (NEW - sent in parallel without affecting legacy)
    const avaSelectedFilterName = store.state.TAGS.AvaInspectionsSelectedFilter;
    const avaSelectedColorOptions = store.state.TAGS.avaInspectionsSelectedColorOptions || [];
    if (sendAva && avaSelectedFilterName && avaSelectedFilterName !== 'No Filter' && avaSelectedColorOptions.length) {
      // numeric index for avaSelectedFilter
      data['avaSelectedFilter'] = store.getters.GET_SELECTED_AVA_INSPECTION_PROPERTY_FILTER_INDEX;
      data['avaFilters'] = avaSelectedColorOptions.map((o) => ({
        filterValue1: o.judgCrr1?.toString()?.includes('∞') ? 10e5 : o.judgCrr1,
        compareSign1: o.judgMkr1?.trim(),
        filterValue2: o.judgCrr2?.toString()?.includes('-∞') ? -10e5 : o.judgCrr2,
        compareSign2: o.judgMkr2?.trim(),
      }));
    }

    // Wrapper note: `postDataAsync` is callback-style, but at least one caller
    // (`inspectionView.modules.js` LOAD_INSPECTIONS) chains `.catch().finally()`
    // on the return value. Wrap the dispatch in a Promise so the method's
    // contract matches the consumer's expectation. Fire-and-forget callers
    // (forgeMessageUtils.js, store/index.js, dashboards) are unaffected —
    // an unconsumed Promise is silently discarded.
    return new Promise((resolve, reject) => {
      postDataAsync(
        'api/AMIS/fetchInspectionsAdvanced',
        data,
        (res) => {
          if (store.getters['GET_LAST_AMIS_ADVANCED_FETCH_DATE'] !== requestDate) {
            // Superseded by a newer request; resolve with null so the
            // wrapper doesn't leak a pending Promise.
            resolve(null);
            return;
          }

          let { totalSearchResult, allTagsCount, inspections, allFilteredInspections } = res;

          store.commit('SET_AMIS_TAGS_SEARCH_COUNT', totalSearchResult);
          store.commit('SET_AMIS_TAGS_TOTAL_COUNT', allTagsCount);

          let tags = inspections.map((o) => Object.assign(new ForgeInspection(), o));

          tags.forEach((o) => o.parseContent());

          if (reload) {
            store.commit('SET_AMIS_TAGS', tags);

            allFilteredInspections = allFilteredInspections.map((o) =>
              Object.assign(new ForgeInspection(), o),
            );

            allFilteredInspections.forEach((o) => {
              o.parseContent();
            });

            store.commit('SET_ALL_AMIS_FILTERED_INSPECTIONS', allFilteredInspections);

            store.commit('SET_INSPECTION_TAG_TREE', this.buildInspectionTree(allFilteredInspections));
          } else {
            store.commit('SET_AMIS_TAGS', store.getters['GET_AMIS_TAGS'].concat(tags));
          }
          store.state.TAGS.isLoadingAMISTags = false;

          store.dispatch('LOAD_AMIS_COLORS', () => {
            // TODO: Create inspection color map { inspectionId: color } and use it in all required places.
            store.state.forgeService.updateAMISTagsColors(store.state.TAGS.amisTags);
            store.state.forgeService.updateAMISTagsColors(
              store.getters.GET_ALL_AMIS_FILTERED_INSPECTIONS,
            );
            store.state.forgeService.updateAMISTagsColors(store.getters.GET_ALL_AMIS_TAGS_IDS);
            store.state.forgeService.update3dIconsInAllViews();
          });

          // Resolve once primary state is committed; color loading proceeds
          // asynchronously in the background and is not part of the
          // fetch's success contract.
          resolve(res);
        },
        (err) => {
          store.state.TAGS.isLoadingAMISTags = false;
          // $handleError({ message: 'Faild to fetch A-MIS inspections.' });
          reject(err);
        },
        null,
        'application/json',
        {},
        // Fills the facility-wide A-MIS tag list; must not be cancelled by moving between its pages.
        FACILITY_REQUEST,
      );
    });
  }
  updateAMISTagsColors(tags, defaultColor = '#9a5454') {
    let InspectionSelectedFilter = store.state.TAGS.InspectionSelectedFilter;
    let selectedColorsOptions = store.state.TAGS.InspectionAvailableColorOptions;

    this.advancedUpdateAMISTagsColors(
      tags,
      InspectionSelectedFilter,
      selectedColorsOptions,
      defaultColor,
    );
  }
  advancedUpdateAMISTagsColors(
    tags,
    InspectionSelectedFilter,
    selectedColorsOptions,
    defaultColor = '#9a5454',
  ) {
    let targetProperty = '';

    if (InspectionSelectedFilter == 'Remaining Thickness') targetProperty = 'rt';
    else if (InspectionSelectedFilter == 'Remaining Life') targetProperty = 'rl';
    else if (InspectionSelectedFilter == 'Corrosion Rate') targetProperty = 'cr';
    else if (InspectionSelectedFilter == 'Inspection Plan') targetProperty = 'ispDateDays';
    else if (InspectionSelectedFilter == 'Last Inspection (Thickness)')
      targetProperty = 'ispDateDays';
    else if (InspectionSelectedFilter == 'Last Inspection (Visual)')
      targetProperty = 'offerLastInspDateDays';
    else if (InspectionSelectedFilter == 'Last Inspection (Both)')
      targetProperty = 'nearestLastDateDays';
    else if (InspectionSelectedFilter == 'Next Inspection (Thickness)')
      targetProperty = 'nIspDateDays';
    else if (InspectionSelectedFilter == 'Next Inspection (Visual)')
      targetProperty = 'offerNextInspDateDays';
    else if (InspectionSelectedFilter == 'Next Inspection (Both)')
      targetProperty = 'closestNextDateDays';
    else if (InspectionSelectedFilter == 'AI Inspection')
      targetProperty = 'severity';
    tags.forEach((tag) => {
      tag.pinColor = this.getAMISTagColor(tag, selectedColorsOptions, targetProperty, defaultColor);
    });
  }
  getAMISTagColor(tag, selectedColorsOptions, targetProperty, defaultColor = '#6d2251') {
    let color = defaultColor;

    for (let i = 0; i < selectedColorsOptions.length; i++) {
      const o = selectedColorsOptions[i];

      let j1 = o.judgCrr1?.toString().includes('∞') ? Infinity : o.judgCrr1;
      let j2 = o.judgCrr2?.toString().includes('-∞') ? -Infinity : o.judgCrr2;

      if (o.judgMkr1 == '<' && o.judgMkr2 == '>=') {
        if (tag[targetProperty] !== null && tag[targetProperty] < j1 && tag[targetProperty] >= j2) {
          color = o.judgCor;
          break;
        }
      } else if (o.judgMkr1 == '<' && o.judgMkr2 == '>') {
        if (tag[targetProperty] !== null && tag[targetProperty] < j1 && tag[targetProperty] > j2) {
          color = o.judgCor;
          break;
        }
      } else if (o.judgMkr1 == '<=' && o.judgMkr2 == '>') {
        if (tag[targetProperty] !== null && tag[targetProperty] <= j1 && tag[targetProperty] > j2) {
          color = o.judgCor;
          break;
        }
      } else if (o.judgMkr1 == '<=' && o.judgMkr2 == '>=') {
        if (
          tag[targetProperty] !== null &&
          tag[targetProperty] <= j1 &&
          tag[targetProperty] >= j2
        ) {
          color = o.judgCor;
          break;
        }
      } else if (o.judgMkr1 == null && o.judgMkr2 == null && tag[targetProperty] === null) {
        color = o.judgCor;
        break;
      } else if (o.judgMkr1 == '==' && o.judgMkr2 == '==') {
        if (tag[targetProperty] == j1 && tag[targetProperty] == j2) {
          color = o.judgCor;
          break;
        }
      }
    }

    return color;
  }
  getCategoryColor(categoryId) {
    let category = store.state.categories.find((c) => c.id == categoryId);

    if (category) {
      return {
        r: parseInt(category.color.substr(1, 2), 16) / 255,
        g: parseInt(category.color.substr(3, 2), 16) / 255,
        b: parseInt(category.color.substr(5, 2), 16) / 255,
      };
    }

    return { r: 3.0, g: 3.0, b: 3.0 };
  }
}

export function createHotspotLabel(hotSpotDiv, args) {
  var imagePath = require(`@/images/tags-icons/${args.imageName}-hover.png`);

  var label = document.createElement('div');
  label.className = args.className;
  label.style.backgroundColor = HOTSPOT_LABEL_CHIP_BG;

  var icon = document.createElement('img');
  icon.className = 'tag-360 ' + args.imgClass;
  icon.src = imagePath;
  label.appendChild(icon);

  var textDiv = document.createElement('div');
  textDiv.innerText = args.title;
  textDiv.className = 'tag-title';
  textDiv.style.color = HOTSPOT_LABEL_TEXT_COLOR;
  textDiv.style.textShadow = HOTSPOT_LABEL_TEXT_SHADOW;
  label.appendChild(textDiv);

  if (args.category) store.state.forgeService.addCategoryColorToLabel(args.category, label);
  hotSpotDiv.appendChild(label);
}

export function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}
export function downloadShareFileById(id, callback) {
  //NOTE: you have to add the site to the ShareFile site first to avoid the CORS issue.
  //Go to ShareFile > Secuirity > Login & Security Policy > Trusted domains
  //then add all the clients

  //ShareFile documentation here
  //https://api.sharefile.com/docs/resource?name=Items
  $.ajax({
    url: 'https://modsmanagement.sf-api.com/sf/v3/Items(' + id + ')/Download?redirect=false',
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + store.state.shareFileToken,
    },
  }).done(function (response) {
    window.open(response.DownloadUrl, '_blank');
    if (callback) callback();
  });
}
export function downloadBlobUrl(uri, name) {
  convertBlobUrlToBase64(
    uri,
    store.state.viewer.container.clientWidth,
    store.state.viewer.container.clientWidth,
    (base64) => {
      let link = document.createElement('a');
      base64 = base64.replace('image/png', 'image/octet-stream');
      link.setAttribute('href', base64);

      if (!name.endsWith('.png')) name += '.png';
      link.setAttribute('download', name);
      link.setAttribute('target', '_blank');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  );
}
export function downloadURI(uri, name) {
  const link = document.createElement('a');
  link.href = uri;
  if (name) link.setAttribute('download', name);
  link.setAttribute('target', '_blank');
  document.body.append(link);
  link.click();
  document.body.removeChild(link);
}

export function readFileContent(file, onProgress) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => resolve(event.target.result);
    reader.onprogress = (e) => {
      if (e.lengthComputable) {
        if (onProgress)
          onProgress((e.loaded / e.total) * 100);
      }
    }
    reader.onerror = (error) => reject(error);
    reader.readAsText(file);
  });
}
//https://stackoverflow.com/questions/3665115/how-to-create-a-file-in-memory-for-user-to-download-but-not-through-server
export function downloadTextInFile(filename, text) {
  let element = document.createElement('a');
  element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

//https://stackoverflow.com/questions/13405129/javascript-create-and-save-file
// function download(data, filename) {
//     let file = new Blob([data], { type: "text/plain;charset=utf-8" });
//     if (window.navigator.msSaveOrOpenBlob) // IE10+
//         window.navigator.msSaveOrOpenBlob(file, filename);
//     else { // Others
//         let a = document.createElement("a"),
//             url = URL.createObjectURL(file);
//         a.href = url;
//         a.download = filename;
//         document.body.appendChild(a);
//         a.click();
//         setTimeout(function () {
//             document.body.removeChild(a);
//             window.URL.revokeObjectURL(url);
//         }, 0);
//     }
// }
export function take360Screenshot(viewer, callback) {
  let screenshot = viewer
    .getRenderer()
    .render(
      (viewer.getPitch() / 180) * Math.PI,
      (viewer.getYaw() / 180) * Math.PI,
      (viewer.getHfov() / 180) * Math.PI,
      { returnImage: true },
    );

  let i = new Image();

  i.onload = function () {
    let canvas = document.createElement('canvas');
    let scale = Math.min(
      THUMBNAIL_CONFIG.MAX_WIDTH / i.width,
      THUMBNAIL_CONFIG.MAX_HEIGHT / i.height,
      1,
    );
    canvas.width = Math.round(i.width * scale);
    canvas.height = Math.round(i.height * scale);
    let context = canvas.getContext('2d');
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.drawImage(this, 0, 0, canvas.width, canvas.height);
    let base64 = canvas.toDataURL(THUMBNAIL_CONFIG.FORMAT, THUMBNAIL_CONFIG.JPEG_QUALITY);
    canvas.remove();
    callback(base64);
  };

  i.src = screenshot;
}
export function takeScreenshot(viewer, callback) {
  viewer.getScreenShot(
    viewer.container.clientWidth,
    viewer.container.clientHeight,
    function (blobURL) {
      convertBlobUrlToBase64(
        blobURL,
        viewer.container.clientWidth,
        viewer.container.clientHeight,
        callback,
      );
    },
  );
}
export function convertBlobUrlToBase64(blobURL, width, height, callback) {
  let image = new Image();
  image.crossOrigin = 'Anonymous';
  image.onload = function () {
    let canvas = document.getElementById('screenshot');
    if (!canvas) {
      canvas = document.createElement('canvas');
      canvas.id = 'screenshot';
      canvas.style.position = 'absolute';
      canvas.style.display = 'block';
      document.body.appendChild(canvas);
    }
    let scale = Math.min(
      THUMBNAIL_CONFIG.MAX_WIDTH / width,
      THUMBNAIL_CONFIG.MAX_HEIGHT / height,
      1,
    );
    canvas.width = Math.round(width * scale);
    canvas.height = Math.round(height * scale);
    let canvasContext = canvas.getContext('2d');
    canvasContext.clearRect(0, 0, canvas.width, canvas.height);
    canvasContext.drawImage(image, 0, 0, canvas.width, canvas.height);

    let base64 = canvas.toDataURL(THUMBNAIL_CONFIG.FORMAT, THUMBNAIL_CONFIG.JPEG_QUALITY);
    document.getElementById('screenshot').remove();
    callback(base64);
  };
  image.src = blobURL;
}
export function debounce(func, timeout = 100) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}
//https://stackoverflow.com/questions/808826/draw-arrow-on-canvas-tag
export function canvas_arrow(context, fromx, fromy, tox, toy) {
  let headlen = 10; // length of head in pixels
  let dx = tox - fromx;
  let dy = toy - fromy;
  let angle = Math.atan2(dy, dx);
  context.moveTo(fromx, fromy);
  context.lineTo(tox, toy);
  context.lineTo(
    tox - headlen * Math.cos(angle - Math.PI / 6),
    toy - headlen * Math.sin(angle - Math.PI / 6),
  );
  context.moveTo(tox, toy);
  context.lineTo(
    tox - headlen * Math.cos(angle + Math.PI / 6),
    toy - headlen * Math.sin(angle + Math.PI / 6),
  );
}
//https://stackoverflow.com/questions/1255512/how-to-draw-a-rounded-rectangle-using-html-canvas
// type: all, top, left, right, bottom
export function roundRect(ctx, x, y, width, height, radius, type, fill, stroke) {
  if (typeof stroke === 'undefined') {
    stroke = true;
  }
  if (typeof radius === 'undefined') {
    radius = 5;
  }
  if (typeof radius === 'number') {
    if (type == 'top') {
      radius = { tl: radius, tr: radius, br: 0, bl: 0 };
    } else if (type == 'bottom') {
      radius = { tl: 0, tr: 0, br: radius, bl: radius };
    } else if (type == 'left') {
      radius = { tl: radius, tr: 0, br: 0, bl: radius };
    } else if (type == 'right') {
      radius = { tl: 0, tr: radius, br: radius, bl: 0 };
    } else {
      radius = { tl: radius, tr: radius, br: radius, bl: radius };
    }
  } else {
    let defaultRadius = { tl: 0, tr: 0, br: 0, bl: 0 };
    for (let side in defaultRadius) {
      radius[side] = radius[side] || defaultRadius[side];
    }
  }
  ctx.beginPath();
  ctx.moveTo(x + radius.tl, y);
  ctx.lineTo(x + width - radius.tr, y);
  ctx.quadraticCurveTo(x + width, y, x + width, y + radius.tr);
  ctx.lineTo(x + width, y + height - radius.br);
  ctx.quadraticCurveTo(x + width, y + height, x + width - radius.br, y + height);
  ctx.lineTo(x + radius.bl, y + height);
  ctx.quadraticCurveTo(x, y + height, x, y + height - radius.bl);
  ctx.lineTo(x, y + radius.tl);
  ctx.quadraticCurveTo(x, y, x + radius.tl, y);
  ctx.closePath();
  if (fill) {
    ctx.fill();
  }
  if (stroke) {
    ctx.stroke();
  }
}
export function bytesToSize(bytes) {
  let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes == 0) return '0 Byte';
  let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
}
//making same as what is done in this webpage
//https://thaivaluer.com/proj4js/xydatum.html
export function initProj4() {
  Proj4js.defs['EPSG:24047'] =
    '+title=Indian 1975 / UTM zone 47N+proj=utm +zone=47 +a=6377276.345 +b=6356075.41314024 +towgs84=204.5,837.9,294.8,0,0,0,0 +units=m +no_defs';
  Proj4js.defs['WGS84'] =
    '+title=long/lat:WGS84 +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees';
}
export function convertLatLongToXYZCoordinates_Indian(latLong) {
  if (!store.state.forgeSettings || !store.state.forgeSettings.gpsSettings) return null;
  let ORIGIN_N = store.state.forgeSettings.gpsSettings.originN;
  let ORIGIN_E = store.state.forgeSettings.gpsSettings.originE;
  let a = store.state.forgeSettings.gpsSettings.CONST_A;
  let b = store.state.forgeSettings.gpsSettings.CONST_B;
  let angle = store.state.forgeSettings.gpsSettings.angle;
  const theta = THREE.Math.degToRad(angle);

  let projSource = new Proj4js.Proj('WGS84');
  let projDest = new Proj4js.Proj('EPSG:24047');

  let pointSource = new Proj4js.Point(latLong.long.toString() + ',' + latLong.lat.toString());
  let utmPoint = Proj4js.transform(projSource, projDest, pointSource);

  let E = utmPoint.x - ORIGIN_E;
  let N = utmPoint.y - ORIGIN_N;
  let y =
    (E * Math.sin(theta) - a * Math.cos(theta) + N * Math.cos(theta) - b * Math.sin(theta)) /
    (Math.pow(Math.cos(theta), 2) + Math.pow(Math.sin(theta), 2));
  let x = (y * Math.cos(theta) + a - N) / Math.sin(theta);
  let z = store.state.viewer ? store.state.globalOffset.z - 8 : 10;
  return new THREE.Vector3(x, y, z);
}
export function getRotatedDirectionByNorthAngle() {
  if (
    !store.state.forgeSettings ||
    !store.state.forgeSettings.gpsSettings ||
    !store.state.forgeSettings.gpsSettings.angle
  )
    return null;
  let angle = store.state.forgeSettings.gpsSettings.angle;
  let axis = new THREE.Vector3(0, 0, 1);
  let vec2D = new THREE.Vector3(0, 1, 0);
  vec2D.applyAxisAngle(axis, THREE.Math.degToRad(angle));
  return vec2D;
}

export function getUnitValue(value, unitType, decimalPlaces) {
  let fileUnit = 'm';

  if (unitType == 'm') {
    return decimalPlaces != null ? value.toFixed(decimalPlaces) : value;
  } else if (unitType == 'cm') {
    let cmValue = value * 100;
    return decimalPlaces != null ? cmValue.toFixed(decimalPlaces) : cmValue;
  } else if (unitType == 'mm') {
    let mmValue = value * 1000;
    return decimalPlaces != null ? mmValue.toFixed(decimalPlaces) : mmValue;
  }

  let lengthFeet = getLengthInFeet(value, fileUnit);

  if (unitType == 'decimal-ft') {
    return decimalPlaces != null ? lengthFeet.toFixed(decimalPlaces) : lengthFeet;
  } else if (unitType == 'ft-and-fractional-in') {
    let feet = parseInt(lengthFeet);
    let inches = (lengthFeet - feet) * 12;
    let pureInch = parseInt(inches);
    let fractions = inches - pureInch;
    if (fractions > 0.75) return `${feet}.${pureInch + 0.75}`;
    else if (fractions > 0.5) return `${feet}.${pureInch + 0.5}`;
    else return `${feet}.${pureInch + 0.25}`;
  } else if (unitType == 'ft-and-decimal-in') {
    let feet = parseInt(lengthFeet);
    let inches = (lengthFeet - feet) * 12;
    return decimalPlaces != null ? `${feet}.${inches.toFixed(decimalPlaces)}` : `${feet}.${inches}`;
  } else if (unitType == 'decimal-in') {
    let inches = lengthFeet * 12;
    return decimalPlaces!= null? inches.toFixed(decimalPlaces) : inches;
  }

  return decimalPlaces != null ? value.toFixed(decimalPlaces) : value;
}

export function formatLength(length, type) {
  let fileUnit = 'm';

  let lengthFeet = getLengthInFeet(length, fileUnit);

  if (type == 'decimal-ft') {
    return lengthFeet.toFixed(3) + "'";
  } else if (type == 'ft-and-fractional-in') {
    let feet = parseInt(lengthFeet);
    let inches = (lengthFeet - feet) * 12;
    let pureInch = parseInt(inches);
    let fractions = inches - pureInch;
    if (fractions > 0.75) return `${feet}' ${pureInch}-3/4"`;
    else if (fractions > 0.5) return `${feet}' ${pureInch}-1/2"`;
    else return `${feet}' ${pureInch}-1/4"`;
  } else if (type == 'ft-and-decimal-in') {
    let feet = parseInt(lengthFeet);
    let inches = (lengthFeet - feet).toFixed(3);
    if (inches == 0) return `${feet}'`;
    return `${feet}' ${inches}"`;
  } else if (type == 'decimal-in') {
    return (lengthFeet * 12).toFixed(3) + '"';
  } else if (type == 'm') {
    return (lengthFeet * 0.3048).toFixed(3) + 'm';
  } else if (type == 'cm') {
    return (lengthFeet * 30.48).toFixed(3) + 'cm';
  } else if (type == 'mm') {
    return (lengthFeet * 304.8).toFixed(0) + 'mm';
  } else {
    return (lengthFeet * 0.3048).toFixed(3) + 'm';
  }
}

export function getLengthInFeet(length, type) {
  if (type == 'ft') return length;
  else if (type == 'in') return length / 12;
  else if (type == 'm') return length / 0.3048;
  else if (type == 'cm') return length / 30.48;
  else if (type == 'mm') return length / 304.8;
}

export function saveAttachmentToDatabase(attachment) {
  if (attachment.pagesMarkups?.length) {
    attachment.pagesMarkups.forEach((page) => {
      page.cropBox = {
        min: { x: 0, y: 0, z: 0 },
        max: { x: 0, y: 0, z: 0 },
      };
    });
  }
  // Links are per version: markups started while an older version is open belong to that version.
  // Without documentRevisionId the API stamps the current one.
  if (!attachment.documentRevisionId && attachment.viewRevisionId) {
    attachment.documentRevisionId = attachment.viewRevisionId;
  }
  let dataJson = attachment;
  if(!dataJson.createDate||dataJson.createDate==""){
    dataJson.createDate= new Date().toISOString();
  }
  var method=attachment.id? HttpService.put({
    url: `api/forge/attachments/editAttachment`,
    data: dataJson,
  }):
  HttpService.post({
    url: `api/forge/attachments/addAttachment`,
    data: dataJson,
  });



    method.then((response) => {
      //store.dispatch('RequestPIdsLinkedTags');

      let res = response.data;

      if (!res.pagesMarkups) return;

      for (let i = 0; i < res.pagesMarkups.length; i++) {
        const dbPage = res.pagesMarkups[i];
        let page = attachment.pagesMarkups.find((o) => o.pageId / 1 == dbPage.pageId / 1);

        if (page == null) continue;

        page.id = dbPage.id;
        page.deletedLinkIds = [];

        if (!page.links?.length) continue;

        for (let i = 0; i < dbPage.links.length; i++) {
          if (page.links[i].id) continue;
          page.links[i].id = dbPage.links[i].id;
        }
      }

      Vue.prototype.$dialog.notify.success('Attachment saved successfully.');
    })
    .catch((error) => {
      debugLog(error);
      Vue.prototype.$dialog.notify.error('Failed to save attachment.');
    });
}

export function loadScript(url, onCallBack, onError) {
  const script = document.createElement('script');
  let scriptName = url.slice(url.lastIndexOf('/') + 1, url.length);
  if (isScriptLoaded(scriptName)) {
    if (onCallBack) onCallBack();
  } else {
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('src', url);
    script.onload = onCallBack;
    script.onerror = onError;
    document.body.appendChild(script);
  }
}

export function unloadScript(scriptName) {
  let scripts = document.scripts;
  let script = '';
  for (let i = 0; i < scripts.length; i++) {
    if (scripts[i].src.toLowerCase().includes(scriptName.toLowerCase())) {
      script = scripts[i];
      break;
    }
  }
  script.parentElement.removeChild(script);
}

export function isScriptLoaded(scriptName) {
  let scripts = document.scripts;
  for (let i = 0; i < scripts.length; i++) {
    if (scripts[i].src.toLowerCase().includes(scriptName.toLowerCase())) {
      return true;
    }
  }
  return false;
}
export function renderPDFThumbnailToCanvas(pdfUrl, canvas) {
  //https://www.codegrepper.com/code-examples/javascript/how+to+generate+thumbnail+fast+in+pdfjs
  //https://stackoverflow.com/questions/66974404/how-to-import-pdf-js-using-cdn
  pdfjsLib.GlobalWorkerOptions.workerSrc =
    'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.4.456/build/pdf.worker.min.js';

  pdfjsLib
    .getDocument(pdfUrl)
    .promise.then(function (doc) {
      doc.getPage(1).then((page) => {
        var scale = canvas.width / page._pageInfo.view[2];
        var vp = page.getViewport({ scale: scale });
        page.render({ canvasContext: canvas.getContext('2d'), viewport: vp, intent: 'print' });
      });
    })
    .catch(debugError);
}

export function delay(milliSeconds) {
  return new Promise((resolve) => setTimeout(resolve, milliSeconds));
}
export function getShareFileAccessToken(callback) {
  HttpService.get({
    url: `api/sharefile/getAccessToken`,
  })
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      debugLog(error);
    });
}
export function getShareFileTopFolders(token, callback) {
  HttpService.get({
    url: `api/sharefile/getTopFolders/?token=${token}`,
  })
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      debugLog(error);
    });
}
export function getShareFileFolderChildren(id, token, callback) {
  HttpService.get({
    url: `api/sharefile/getFolderChildren/?id=${id}&token=${token}`,
  })
    .then((response) => {
      let data = response.data;

      if (!data) {
        callback([]);
        return;
      }
      let items = JSON.parse(data).Children;
      let result = items.map(
        (o) =>
          new ShareFileItem(
            o.Name,
            o.Id,
            o['odata.type'].endsWith('Folder'),
            o.FileSizeBytes,
            o.url,
          ),
      );

      callback(result);
    })
    .catch((error) => {
      debugLog(error);
    });
}

export function loadImage(url) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = function () {
      resolve(this);
    };
    img.src = url;
  });
}

export const PopupStatus = Object.freeze({
  ACTIVE: 'active',
  FULLSCREEN: 'fullscreen',
  MINIMIZED: 'minimized',
  HIDDEN: 'hidden',
  UNDEFINED: 'undefined',
});

export const ForgeVisiblityMode = Object.freeze({
  SHOW: 'show',
  SELECT: 'select',
  HIDE: 'hide',
  ISOLATE: 'isolate',
});

//used to export current PDF viewer scene to
export async function exportPDF(viewer, fileName, isBounded = false) {
  //Create Image element to bind viewer screenshot into
  let screenshotImage = new Image();

  //Create canvas element to render screenshot image as well as markups
  let canvas = document.createElement('canvas');
  canvas.id = 'snapshot';
  canvas.style.position = 'absolute';
  viewer.container.parentElement.appendChild(canvas);

  //In case want to crop the screenshot to model boundary only
  let modelBoundingBox = viewer.model.getBoundingBox();
  let modelClientMax = viewer.worldToClient(modelBoundingBox.max);
  let modelClientMin = viewer.worldToClient(modelBoundingBox.min);
  let modelHeight = Math.abs(modelClientMax.y - modelClientMin.y);
  let modelWidth = Math.abs(modelClientMax.x - modelClientMin.x);
  let modelLeft = modelClientMin.x;
  let modelTop = modelClientMax.y;
  canvas.width = isBounded ? modelWidth : viewer.canvas.width;
  canvas.height = isBounded ? modelHeight : viewer.canvas.height;
  canvas.style.left = isBounded ? modelLeft + 'px' : 0;
  canvas.style.top = isBounded ? modelTop + 'px' : 0;

  //Get Markups Extension
  let markupCore = viewer.loadedExtensions['Autodesk.Viewing.MarkupsCore'];

  //Image.onload should be dispatched when viewer.getScreenShot assings "screenshot" element src
  screenshotImage.onload = async function () {
    let ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    //render image [from viewer.screenshot] to canvas
    //https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/drawImage
    if (isBounded) {
      //drawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight)
      ctx.drawImage(
        screenshotImage,
        modelLeft,
        modelTop,
        canvas.width,
        canvas.height,
        0,
        0,
        canvas.width,
        canvas.height,
      );
    } else {
      //drawImage(image, dx, dy, dWidth, dHeight)
      ctx.drawImage(screenshotImage, 0, 0, canvas.width, canvas.height);
    }

    //render all markups to canvas
    // if Markups.Core not loaded, export PDF with image only
    if (markupCore) {
      // markupCore?.renderToCanvas(,,true) to render all layers
      markupCore.renderToCanvas(
        ctx,
        async () => {
          let imgData = canvas.toDataURL();
          await saveImageToPDF(imgData, canvas.width, canvas.height, fileName);
          viewer.container.parentElement.removeChild(canvas);
        },
        true,
      );
    } else {
      let imgData = canvas.toDataURL();
      await saveImageToPDF(imgData, canvas.width, canvas.height, fileName);
      viewer.container.parentElement.removeChild(canvas);
    }
  };
  //Get Viewer screenshot and bind it to image []
  viewer.getScreenShot(viewer.canvas.width, viewer.canvas.height, function (blobURL) {
    screenshotImage.src = blobURL;
  });
}

export async function saveImageToPDF(imgData, width, height, fileName) {
  //create PDF document using jsPDF lib
  let doc = new jspdf({ format: [height, width], orientation: 'landscape' });

  //Add Image to document page
  await doc.addImage(imgData, 'JPEG', 0, 0, width, height);

  await doc.save(fileName ?? window.location.origin);
}

export async function exportMarkupImageWithModel(viewer, saveAsPng, saveAsPdf, fileName, callback) {
  debugLog('ssssssssss')
  const canvas = document.createElement('canvas');
  canvas.id = 'snapshot';
  const canvasWidth = viewer.container.clientWidth * 4;
  const canvasHeight = viewer.container.clientHeight * 4;
  canvas.width = canvasWidth;
  canvas.height = canvasHeight;
  viewer.container.appendChild(canvas);

  const ctx = canvas.getContext('2d');
  const screenshotImage = new Image(canvasWidth, canvasHeight);
  const markupImage = new Image(canvasWidth, canvasHeight);

  function downloadAsPng(imageBase64) {
    const a = document.createElement('a');
    a.style.display = 'none';
    document.body.appendChild(a);
    a.href = imageBase64;
    a.download = `${fileName || 'markup'}.png`;
    a.click();
    document.body.removeChild(a);
  }

  function downloadAsPdf(imageBase64) {
    saveImageToPDF(imageBase64, canvasWidth, canvasHeight, fileName);
  }

  function handleDownload(imageBase64) {
    if (saveAsPng) {
      downloadAsPng(imageBase64);
    }
    if (saveAsPdf) {
      downloadAsPdf(imageBase64);
    }
    if (callback) {
      callback();
    }
  }

  screenshotImage.onload = () => {
    ctx.clearRect(0, 0, canvasWidth, canvasHeight);
    ctx.drawImage(screenshotImage, 0, 0, canvasWidth, canvasHeight);

    const markupExtension = viewer.loadedExtensions['Autodesk.Viewing.MarkupsCore'];
    const hasMarkup = markupExtension && markupExtension.svg;
    if (hasMarkup) {
      const markupData = markupExtension.editModeSvgLayerNode
        ? markupExtension.generateData()
        : markupExtension.svg.innerHTML;

      if (markupData.trim()) {
        markupImage.onload = () => {
          ctx.drawImage(markupImage, 0, 0, canvasWidth, canvasHeight);
          const imageBase64 = canvas.toDataURL();
          handleDownload(imageBase64);
        };
        markupImage.src = `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(markupData)))}`;
      } else {
        const imageBase64 = canvas.toDataURL();
        handleDownload(imageBase64);
      }
    } else {
      const imageBase64 = canvas.toDataURL();
      handleDownload(imageBase64);
    }
  };

  viewer.getScreenShot(canvasWidth, canvasHeight, (blobURL) => {
    screenshotImage.src = blobURL;
  });
}


export function exportMarkupImage(viewer, callback) {
  let markupExtension = viewer.loadedExtensions['Autodesk.Viewing.MarkupsCore'];
  let canvas = document.getElementById('markupsSnapshot');
  if (!canvas) {
    canvas = document.createElement('canvas');
    canvas.id = 'markupsSnapshot';
  }
  let modelSize = getModelClientDimensions(viewer, viewer.model);
  let modelWidth = Math.abs(modelSize.x);
  let modelLength = Math.abs(modelSize.y);
  canvas.width = modelWidth * 2;
  canvas.height = modelLength * 2;
  viewer.container.appendChild(canvas);
  let ctx = canvas.getContext('2d');
  let svgHeight = markupExtension.svg.clientHeight;
  let svgWidth = markupExtension.svg.clientWidth;
  let leftMargin = (svgWidth - modelWidth) / 2;
  let topMargin = (svgHeight - modelLength) / 2;
  let img = new Image(svgWidth, svgHeight);
  let data = markupExtension.editModeSvgLayerNode
    ? markupExtension.generateData()
    : markupExtension.svg.innerHTML;

  if (!data) {
    if (callback) callback(null);
    return;
  }

  img.onload = async function () {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(
      img,
      leftMargin,
      topMargin,
      svgWidth - 2 * leftMargin,
      svgHeight - 2 * topMargin,
      0,
      0,
      canvas.width,
      canvas.height,
    );
    let imageBase64 = canvas.toDataURL();
    if (callback) callback(imageBase64);
  };
  img.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(data)));
}

export function exportMarkupImage2(viewer, callback) {
  let markupExtension = viewer.loadedExtensions['Autodesk.Viewing.MarkupsCore'];
  let canvas = document.getElementById('markupsSnapshot');
  if (!canvas) {
    canvas = document.createElement('canvas');
    canvas.id = 'markupsSnapshot';
  }
  canvas.width = viewer.container.clientWidth * 2;
  canvas.height = viewer.container.clientHeight * 2;
  viewer.container.appendChild(canvas);
  let ctx = canvas.getContext('2d');
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.drawImage(new Image(canvas.width, canvas.height), 0, 0, canvas.width, canvas.height);

  markupExtension.renderToCanvas(
    ctx,
    function () {
      let ImageBase64 = canvas.toDataURL();

      if (callback) {
        callback(ImageBase64);
      }
    },
    true,
  );
}

export function urlToBase64(url, callback) {
  let xhr = new XMLHttpRequest();
  xhr.onload = function () {
    let reader = new FileReader();
    reader.onloadend = function () {
      callback(reader.result);
    };
    reader.readAsDataURL(xhr.response);
  };
  xhr.open('GET', url);
  xhr.responseType = 'blob';
  xhr.send();
}

export function imageToBase64(img) {
  img.crossOrigin = 'anonymous';
  let canvas = document.createElement('canvas');
  canvas.width = img.width;
  canvas.height = img.height;
  let ctx = canvas.getContext('2d');
  ctx.drawImage(img, 0, 0);
  let dataURL = canvas.toDataURL('image/png');
  return dataURL;
}

export async function exportAttachmentsPDF(attachmentsIds, fileName) {
  let attachments = await getAttachments(attachmentsIds);
  let imagesUrls = attachments.flatMap((o) => o.pagesMarkups).map((o) => o.imageUrl);

  //filter that No url is empty or null
  imagesUrls = imagesUrls.filter((x) => {
    return x != '' && x != null;
  });

  //create PDF document using jsPDF lib
  let doc = new jspdf.jsPDF();

  //delete default first page
  doc.deletePage(1);

  for (let i = 0; i < imagesUrls.length; i++) {
    const url = imagesUrls[i];
    let currentPageNumber = i + 1;

    $(`<img crossorigin="anonymous" src=${url} id=${currentPageNumber}>`).on('load', function () {
      let img = $(this)[0];
      let pageNumber = img.id;

      //Add Page to document
      doc.addPage();
      doc.setPage(pageNumber);

      let height = img.height;
      let width = img.width;

      doc.setPageHeight(pageNumber, height);
      doc.setPageWidth(pageNumber, width);

      let imageBase64 = imageToBase64(img);

      //Add Image to document page
      doc.addImage(imageBase64, 'JPEG', 0, 0, width, height);

      if (doc.getNumberOfPages() == imagesUrls.length) {
        //All pages are added
        //Export Document
        doc.save(fileName ?? window.location.origin);
      }
    });
  }
}

export function pad(num, size) {
  num = num.toString();
  while (num.length < size) num = '0' + num;
  return num;
}

export function updateMarkupsStyle(style) {
  style = JSON.parse(style);
  let extension = store.state.markupsComponent.autodeskMarkupsExtension;
  if (extension.editMode) {
    extension.setStyle(style);
  } else {
    extension.enterEditMode();
    extension.setStyle(style);
    extension.leaveEditMode();
  }
}

export async function addMarkupsForPrint(viewer, editor) {
  const avemc = Autodesk.Viewing.Extensions.Markups.Core;

  let templateStyle = {
    'font-size': 0.4,
    'stroke-color': '#0000FF',
    'stroke-opacity': 1,
    'fill-color': '#ffffff',
    'fill-opacity': 0,
    'font-family': 'Popins',
    'font-style': 'normal',
    'font-weight': 'bold',
  };
  let markups = [];

  //Create Test Package Number Markups
  let id = store.state.forgeService.newGuid();
  let modelBBox = viewer.model.getBoundingBox();
  templateStyle['font-size'] = 0.02 * modelBBox.max.y;
  let size = { x: modelBBox.max.x / 3, y: 0.03 * modelBBox.max.y };
  let position = { x: size.x / 2, y: modelBBox.max.y - size.y / 2 };
  let testPackageNumber = store.getters['getTestPackageNumber'];
  let createMarkup = new avemc.CreateText(
    editor,
    id,
    position,
    size,
    testPackageNumber,
    templateStyle,
  );
  createMarkup.selectOnExecution = false;
  createMarkup.execute();
  editor.enterEditMode('Layer_1');
  let markup = editor.getMarkup(id);
  markup.isTemp = true;
  markups.push(markup);

  //Create Link Number Markup
  id = store.state.forgeService.newGuid();
  position = { x: size.x / 2, y: size.y / 2 };
  let moduleUrl = store.state.parentModuleUrl;
  let contextId = store.state.MARKUPS.activeAttachment.referenceContextId;
  let targetId = store.state.MARKUPS.activeAttachment.referenceDocumentId;
  let url = `${moduleUrl}/odata/forgeLink?$filter=ContextID eq ${contextId} and TargetID eq ${targetId}`;
  let linksResponse = await getJSON(url);
  if (linksResponse && linksResponse.value && linksResponse.value.length > 0) {
    let link = linksResponse.value[0];
    let linkName = link.LinkName;
    createMarkup = new avemc.CreateText(editor, id, position, size, linkName, templateStyle);
    createMarkup.selectOnExecution = false;
    createMarkup.execute();
    editor.enterEditMode('Layer_1');
    markup = editor.getMarkup(id);
    markup.isTemp = true;
    markups.push(markup);
  }

  //Add Markups for Links
  let activeAttachment = store.state.MARKUPS.activeAttachment;
  let activePageNumber = store.state.MARKUPS.activeAttachmentPage;
  let activeForgePage = activeAttachment.pagesMarkups.find((x) => x.pageId == activePageNumber);
  if (activeForgePage && activeForgePage.links && activeForgePage.links.length > 0) {
    templateStyle['stroke-color'] = '#19af9a';
    templateStyle['fill-opacity'] = 0;
    for (let i = 0; i < activeForgePage.links.length; i++) {
      const link = activeForgePage.links[i];
      id = store.state.forgeService.newGuid();
      let createRect = new avemc.CreateRectangle(
        editor,
        id,
        link.position,
        { x: link.width, y: link.height },
        0,
        templateStyle,
      );
      createRect.execute();
      editor.enterEditMode('Layer_1');
      markup = editor.getMarkup(id);
      markup.isTemp = true;
      markups.push(markup);

      id = store.state.forgeService.newGuid();
      let createText = new avemc.CreateText(
        editor,
        id,
        link.position,
        { x: link.width, y: link.height },
        link.name,
        templateStyle,
      );
      createText.execute();
      editor.enterEditMode('Layer_1');
      markup = editor.getMarkup(id);
      markup.isTemp = true;
      markups.push(markup);
    }
  }

  return markups;
}

export function deletePrintMarkups(editor, markups) {
  if (markups && markups.length > 0) {
    for (let i = 0; i < markups.length; i++) {
      const markup = markups[i];
      editor.enterEditMode('Layer_1');
      editor.selectMarkup(markup);
      editor.deleteMarkup(markup);
    }
  }
}

export function getModelClientDimensions(viewer, model) {
  let modelBoundingBox = model.getBoundingBox();
  let bBoxClientMax = viewer.worldToClient(modelBoundingBox.max);
  let bBoxClientMin = viewer.worldToClient(modelBoundingBox.min);
  let bBoxClientSize = bBoxClientMax.sub(bBoxClientMin);
  return bBoxClientSize;
}

export function _addEvent(elm, evt, callback) {
  if (elm == null || typeof elm == undefined) return;
  let _hasEventListeners = window.addEventListener;
  if (_hasEventListeners) elm.addEventListener(evt, callback, false);
  else if (elm.attachEvent) elm.attachEvent('on' + evt, callback);
  else elm['on' + evt] = callback;
}

export function mergeTwoGuids(guid1, guid2) {
  let newGuid = '';
  for (let i = 0; i < guid1.length; i++) {
    let char = i % 2 === 0 ? guid1[i] : guid2[i];
    newGuid += char;
  }
  return newGuid;
}

export function groupBy(xs, key) {
  return xs.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
}

export function removeItemOnce(arr, value) {
  let index = arr.indexOf(value);
  if (index > -1) {
    arr.splice(index, 1);
  }
  return arr;
}

export function removeItemAll(arr, value) {
  let i = 0;
  while (i < arr.length) {
    if (arr[i] === value) {
      arr.splice(i, 1);
    } else {
      ++i;
    }
  }
  return arr;
}

export function showVirtualKeyboardOnFocus(e) {
  let showKeyboard = !store.state.userSettings.displaySettings.hideKeyboard;
  if (!(('ontouchstart' in window || navigator.maxTouchPoints) && showKeyboard)) return;
  store.state.currentInputElement = e.target;
  store.state.virtualKeyboardShown = true;
}

//cache helpers
let registrationService = null;
async function clearCache(urn) {
  try {
    const result = submitWorkerTask({ operation: 'CLEAR_URN', urn: urn });
    debugLog('One Model cache cleared successfully', result);
  } catch (err) {
    debugError('Could not be clear model cache', err);
  }
}
async function initServiceWorker_CacheAll() {
  try {
    registrationService = await navigator.serviceWorker.register(
      config.apiUrl + '/service-worker-cache-all.js',
    );
    debugLog('Service worker registered', registrationService.scope);
  } catch (err) {
    debugError('Could not register service worker', err);
  }
}

function submitWorkerTask(task) {
  const channel = new MessageChannel();
  channel.port1.onmessage = function (event) {
    if (event.data.error) {
      debugLog(event.data);
      return event.data;
    } else {
      return event.data;
    }
  };
  registrationService.active?.postMessage(task, [channel.port2]);
}

export function objectToQueryParams(obj) {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(obj)) {
    if (Array.isArray(value)) {
      value.forEach((v) => params.append(key, v));
    } else if (value instanceof Object) {
      for (const [k, v] of Object.entries(value)) {
        params.append(`${key}[${k}]`, v);
      }
    } else {
      if (value !== null) params.append(key, value);
    }
  }
  return params.toString();
}
